import { Component, Inject, Renderer2, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList, Sanitizer, SimpleChanges, OnChanges, AfterViewInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, HostListener, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatAutocomplete, MatAutocompleteTrigger, PageEvent, MatPaginator } from '@angular/material';
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeIdentifier, identifierName } from '@angular/compiler';
import { environment } from 'src/environments/environment';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { lastDateFunc, formatDate, formatDBTZDateToLocalDate } from 'lib/common/utils';
import { VquadbtfxoComponent } from 'src/app/statistics/network-status/vquadbtfxo/vquadbtfxo.component';
import { GooglemapstatuspopupComponent } from 'src/app/output-results/googlemapstatuspopup/googlemapstatuspopup.component';
import { AbsMapDisplayOptions } from 'src/app/shared/models/Configuration/GoogleMap/MapConfig';
import { AgmMap, MapsAPILoader, LatLngBounds } from '@agm/core';
import { GooglemaplegendpopupComponent } from 'src/app/output-results/googlemaplegendpopup/googlemaplegendpopup.component';
import { BasicComponent } from 'src/app/shared/basic/basic.component';
import { ResultsService } from 'src/app/shared/services/master/results/results.service';
import { Router, ActivatedRoute } from '@angular/router';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { Cluster } from 'cluster';
import { map, first } from 'rxjs/operators';
import { DemoService } from 'src/app/shared/demo.service';
import { Subscription, concat } from 'rxjs';
import { DataFilter } from 'lib/ng-data-table/base';
import { debug } from 'util';
import { stream } from 'exceljs';
//import OverlappingMarkerSpiderfier from 'overlapping-marker-spiderfier';
import { parse } from 'cfb/types';
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
//import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { promise } from 'protractor';
//import MarkerClusterer from '@google/markerclustererplus';

//import { circle } from 'leaflet';
//https://roufid.com/angular-uncaught-referenceerror-google-not-defined/
//https://medium.com/@jkeung/integrating-google-maps-api-w-angular-7-e7672396ce2d
//import { initMap } from "./InitMap";
declare var google: any;
//https://stackoverflow.com/questions/37081943/angular-2-import-external-js-file-into-component
//https://stackoverflow.com/questions/40294080/implementing-overlappingmarkerspidifier-with-sebm-angular2-google-map
declare var OverlappingMarkerSpiderfier: any;
////https://stackoverflow.com/a/64079939
//declare var saveSvgAsPng: any;

@Component({
  selector: 'app-test-jsgoogle-map',
  templateUrl: './test-jsgoogle-map.component.html',
  styleUrls: ['./test-jsgoogle-map.component.scss']
})
export class TestJSGoogleMapComponent implements OnInit, AfterViewInit {
  iconBGColor: string = 'FFA500';
  iconFontColor = "white";
  iconText = "PASS";
  GoogleMapID = 'DEMO_MAP_ID';

  dynamicBubbleClass11 = "5px solid " + "#" + this.iconBGColor;
  dynamicBubbleClass21 = "5px solid " + "#" + this.iconBGColor;

  map: any;
  overlay: google.maps.OverlayView;
  customLabelOverlay: google.maps.OverlayView;
  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  hasFilters: boolean = true;//false;

  rsltType: string = "GoogleMap";

  rsltTypeTS = '-1';
  TSSelected: number = 1;

  AutoRefreshInfo: any;
  isFilters: boolean = true;
  interval;

  title: string = "Google Maps";
  staticScreen = false; //true;

  isLoading = false;

  baseUrl: string;
  url: string;

  ////lat: 40.4230, lng: -98.7372 -- USA
  lat = 40.4230;//12.9264;// india
  lng = -98.7372;//77.6012;//india

  ///for polygon
  polyLat: number;
  polyLng: number;
  lat1: number = 14.4673;
  lng1: number = 78.8242;
  lat2: number = 16.5062;
  lng2: number = 80.6480;
  //iurl: string = "https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|000000|FFFFFF|Bubb";
  iurl: string = "./assets/images/Marks/GreenMark.png";
  iurl_b: string = "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=|000000";
  // google maps zoom level
  zoom: number = 4;//4; 
  clulster_max_zoom = 12;
  minClusterSize = 5;

  usePredefinedConfig: string = "OFF";
  showAnalysis = true;
  showNetTest = true;
  showMobileInfo = true;
  showErrorEvents = true;
  showTypes = true;
  showResults = true;
  count: number = 0;
  infoWindowbody: any;
  previous: any;
  Loading: string;
  DrawRoute: string = "OFF";
  DrawLine: string = "1";
  stopFollowRoadRoute: boolean = true;
  rsltTypeEach: any;
  bluetoothText: string;
  isBlutoothButton: boolean = false;
  mapRegionSelected: string = "0";
  modelRegName: string;
  btnRegioncolor: string = "btnToggle1";
  toggleMapRegion: boolean = false;
  infoRegionbody: any;
  analysisEnabled: string = "ON";
  netTestEnabled: string = "ON";
  mobileInfoEnabled: string = "ON";
  errorEventsEnabled: string = "ON";
  mapConfigID: number = 0;
  divPinLegends: any;
  showPopupLegend: boolean = false;
  currentPinLocation: any;
  mainFilterMapRegionName: string = '';

  thresholdLegends: string = "";
  thresholdLegendsCount: string = "";
  callIDLegends: string = "";//susheel
  devIDLegends: string = "";
  callEventsLegends: string = "";
  restorePreviousMapRegionName: string = "0";

  disableSection: string = "";
  showDrawRouteDirection: boolean = false;
  //map: any;
  origin: any;
  destination: any;
  commonFilterDates: string;
  resultTypeID: string;
  leftPanel: boolean = false;
  limitPinCount: boolean = false;
  firstTimeFunctionCall: boolean = false;
  totalNetTestPassCount: number = 0;
  totalNetTestFailCount: number = 0;
  totalMobInfoPassCount: number = 0;
  totalMobInfoFailCount: number = 0;
  totalFailuresOverall: number = 10;
  selectedMapConfigID: number = 0;
  modelMapName: string;
  imgSrc11: string;
  LoadingText: string = "";
  initialLoad: boolean = false;
  loadOldGoogleMap: boolean = true;
  NoAudioScoreCondition: number = 1.10;
  totalNoAudioScore: number = 0;

  mapData = [];
  latlngValMainAgain = [];
  LatLongOriginal = [];
  mapFilterConfigList = [];
  mapNamesObservable = [];
  infowindowArray = [];
  bluetoothData = [];
  mapRegionList = [];
  regNamesObservable = [];
  tempMarker = [];
  DisplayResultList1 = [];
  pinLegends = [];
  dynamicPinLegends = [];
  dynamicLegendPopupData = [];
  legendPopupData = [];
  appliedLegendThreshold = [];
  routeLatLng: any[] = [];
  PredefinedConfigOff = [];
  markerCollection: marker[];
  DirectPolylines = [];
  followRoadRoute = [];
  NoAudioPolqa_OnePoinOne = [];
  Province0List = [];
  Province1List = [];
  Province2List = [];
  Province3List = [];

  options = {
    suppressMarkers: true,
    polylineOptions: { strokeColor: 'red', strokeWeight: 2, strokeOpacity: 1.0, geodesic: true }
  };

  //// "../assets/images/Map/ClusterMarker_Circle.png"
  //,
  //hide: [
  //  {
  //    featureType: "poi",//poi.business
  //    stylers: [{ visibility: "off" }],
  //  },
  //  {
  //    featureType: "transit",
  //    elementType: "labels.icon",
  //    stylers: [{ visibility: "off" }],
  //  },
  //],

  mapOptions = {
    styles: [
      {
        url: "./assets/images/Map/ClusterMarker_Circle.png",
        width: 53,
        height: 53,
        textColor: '#fff',
      }
    ],
  };

  ///// to hide default googlemap pin marker like restaurant,pertol bunks etc. Transit is like public transport icon like train bus as of now it is visible 
  public customMapStyles = [
    {
      featureType: "poi",//poi.business
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "labels.icon",
      stylers: [{ visibility: "on" }],
    },
  ];

  pinMarker: marker;
  mapDisplayOptions = new AbsMapDisplayOptions();
  preDefinedConfigParam = new PredefinedConfig();
  //oms;//susheel

  mainFilterRegionCircleRegionList: google.maps.Circle[] = [];
  mainFilterRegionPolygonPathList: google.maps.Polygon[] = [];////
  circleRegionList: google.maps.Circle[] = [];
  polygonPathList: google.maps.Polygon[] = []; // Store reference to the polygon
  polygonPath: google.maps.Polygon | null = null; // Store reference to the polygon
  gMapMarkerCollection: google.maps.Marker[] = [];
  gMapAdvanceMarkerCollection: any[] = [];
  //gMapAdvanceMarkerCollection1 : google.maps.Marker.AdvancedMarkerElement[]=[];
  ///markerCluster: google.maps.MarkerClusterer;

  //MarkerClusterer: any;
  markerCluster!: any;
  dbTz = -500;
  dbAndBrHrs = -500;
  MainFilterID = 0;
  MainFilterTZ = 0;
  private subscriptions: Subscription[] = [];
  genArrDel = [];
  genArr = [];
  private dataFilter: DataFilter;
  filterEventIDSelected = false;
  delColSelected = false;

  //nearbyDistance: 20,
  optionsOMS = {
    //nearbyDistance: 100,
    legWeight: 2,
    markersWontMove: true,
    markersWontHide: true,
    keepSpiderfied: true,
    // spiderfyDistanceMultiplier:1.5,
    //circleSpiralSwitchover: 90,
    //spiralFootSeparation: 80,
    // spiralLengthStart :51,
    // spiralLengthFactor: 54,
    //spiderfiedZIndex :1,
    spiderfiedShadowColor: false,
    //unspiderfyFunction: function () { }
  };
  //   mapOptions = {
  //  zoom: myZoom,
  //  center: latlng,
  //  mapTypeId: google.maps.MapTypeId.ROADMAP
  //};
  //lat = 12.971599;
  //lng = 77.594563;
  //coordinates = new google.maps.LatLng(this.lat, this.lng);
  markerPositions = [];
  infoWindow = null;
  infowWindowFlag: boolean = false;
  // markerPositions =[
  //  { lat: 12.971599, lng: 77.594563 },
  //  { lat: 12.29581, lng: 76.639381 },
  //  { lat: 11.410204, lng: 76.695032 }
  //];

  @Output() childTitleEvent = new EventEmitter();

  @ViewChildren(MatAutocompleteTrigger) triggerCollection: QueryList<MatAutocompleteTrigger>;
  @ViewChild('inputReg', { static: false }) inputRegCtrl;
  @ViewChild('input', { static: false }) inputCtrl;

  control = new FormControl();

  @Input() myConfigName = "null";

  controlReg = new FormControl();

  @Input() myConfigNameReg = "null";

  toHighlight: string = '';
  toHighlightReg: string = '';


  isDeskTop = true;
  constructor(@Inject(DOCUMENT) private document: Document, private renderer2: Renderer2, private _Activatedroute: ActivatedRoute, private _router: Router, private http: HttpClient, private dialog: MatDialog, private sanitizer: DomSanitizer, private elRef: ElementRef, private mapsAPILoader: MapsAPILoader, private service: DemoService, private commonFilterService: CommonFilterService, private resultsService: ResultsService, private cd: ChangeDetectorRef, private responsive: BreakpointObserver) {
    this.baseUrl = environment.urlAddress + '/api/';
    this.dataFilter = new DataFilter();
    //debugger;
    this.firstTimeFunctionCall = true;

    this.commonFilterService.TSType.subscribe(res => { this.TSSelected = res; });//TsType

    //this.commonFilterService.DB_TZ.subscribe(res => {
    //  this.dbTz = res;
    //});
    //if (this.dbTz == -500) {//query var col table
    //  this.service.getDBTimezoneDiff('VquadData').then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    this.dbTz = res;
    //  });
    //}
    this.commonFilterService.mainFilterID.subscribe(res => {
      this.MainFilterID = res;

      this.commonFilterService.mfTZ.subscribe(res => {
        this.MainFilterTZ = res;
      });
    });

    /////get region name from mainfilter configured and plot region
    this.commonFilterService.mainFilter_MapRegionName.subscribe(res => {

      if (this.mainFilterRegionPolygonPathList.length > 0 || this.mainFilterRegionCircleRegionList.length > 0)
        this.removeMainFilterRegionPolgonPath();

      if (res != '' && res != null) {
        this.mainFilterMapRegionName = res;
        //this.GetMainFilterMapRegion();
      }
      else {
        this.mainFilterMapRegionName = '';
      }

    });

    this.commonFilterService.setNonFiltersScreen(this.staticScreen);//false

    this.Loading = "";

    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;
      this.parentEvent();
    });

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      //////alert(1);
      //console.log('listen');
      if (res === 'onlyGMapInit' && !this.filterEventIDSelected) {
        //debugger;

        //console.log('listen')
        if (!this.firstTimeFunctionCall)
          this.refreshSelections();
      }

      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  //alert('(Component2) Method called!');
      //}

      res => {
        //console.log('GeneralEventIDFilter')
        //console.log(res)
        //debugger
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        ////alert(5);
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0)) {
        //  console.log('filtersWithEventID')
        //  if (this.usePredefinedConfig == "OFF")
        //    this.GetMapConfigData();
        //  else
        //    this.GetMapConfigByID(this.selMapConfig);
        //}
      });
    this.subscriptions.push(_broadSubEventIDFilter);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });

    //Do Refresh Region
    const _broadSubRefreshByEdit = this.commonFilterService.componentRegionMethodCalled$.subscribe(
      res => {

        if (res != "0") {
          //this.refreshSelections();
          ////alert('reg')
          ////// redraw region paths on refresh  click
          debugger;
          if (res == "1") {
            // this.getListReg();
            debugger;
            this.GetAllMapRegion();
          }
          else if (res == "2") { ///// refresh as region is deleted in config screen
            // //alert('reg2')
            this.restorePreviousMapRegionName = "0";
            this.inputRegCtrl.nativeElement.value = "";
            this.removePolgonPath();
            this.GetAllMapRegion();
          }
        }
      });


    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  //alert('(Component2) Method called!');
      //}

      res => {
        ////alert(1);
        //console.log('refreshed-componentMethodCalled$')        
        //debugger;
        //debugger;

        //this.btnRegioncolor = "btnToggle1";
        //this.toggleMapRegion = false;

        this.refreshSelections();
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //Do Refresh after editing
    const _broadSubRefreshForEdit = this.commonFilterService.componentGMapsMethodCalled$.subscribe(
      res => {
        ////alert('edit');
        this.commonFilterService.basicGMapsSavedRefresh(0);
        this.refreshSelections();
      }
    );
    this.subscriptions.push(_broadSubRefreshForEdit);

    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(res => {
      //debugger

      this.AllGeneralFilter = res;
      ////alert(3);
      if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0) {
        if (!this.firstTimeFunctionCall) {
          //console.log('genFilter')
          //debugger;
          ////alert(2);
          this.refreshSelections();
        }
      }

      //reset here
      if (this.delColSelected)
        this.delColSelected = false;
      if (this.clearAllFiltersBool)
        this.clearAllFiltersBool = false;

      this.delFilterColName = '';//reset if delete or clear all filters
    });
    this.subscriptions.push(_broadSubAllGeneralFilter);

    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  //alert('(Component2) Method called!');
      //}

      res => {
        //debugger
        if (res !== '') {//IMP IMP
          ////alert(4);
          //console.log('delFilter')
          this.delFilterColName = res;
          //debugger;
          this.refreshSelections();
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      //console.log(res)     
      //debugger;
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  //alert('(Component2) Method called!');
      //}

      res => {
        //debugger;

        this.AutoRefreshInfo = res;

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            ////alert(6);
            this.refreshSelections();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);




    this.responsive.observe(['(min-width: 960px)', '(max-width: 1279.99px)', '(min-width: 1280px)', Breakpoints.Web, Breakpoints.WebLandscape, Breakpoints.WebPortrait,
      Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
      Breakpoints.Handset, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
      Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge
    ])
      .subscribe(result => {
        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.Tablet] || breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]
          || breakpoints[Breakpoints.Handset] || breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]
          || breakpoints[Breakpoints.XSmall] || breakpoints[Breakpoints.Small]) {
          this.isDeskTop = false;
          if ((breakpoints['(min-width: 960px)'] && breakpoints['(max-width: 1279.99px)']) || breakpoints['(min-width: 1280px)']) {
            this.isDeskTop = true;
          }
        }
        else if (breakpoints[Breakpoints.Medium]) {
          this.isDeskTop = false;
        }
        else {
          this.isDeskTop = true;
        }
      });
  }


  init = false;
  initReg = false;
  ngOnInit() {
    this.imgSrc11 = './assets/images/Marks/1.jpg';
    this.init = true;
    this.initReg = true;
    if (this.myConfigName == "")
      this.myConfigName = "null";
    if (this.myConfigNameReg == "")
      this.myConfigNameReg = "null";

  }

  ngAfterViewInit() {

    ////// to set default value for all checkboxes of display option sections
    //this.ResetDispalyOptionsList();

    this.GetSystemConfig(); ///commented for testing
    this.paths = [];
    this.GetAllMapRegion();
    //this.GetPredefinedConfig();

    if (this.firstTimeFunctionCall) {
      this.RestorePreviousDispalyOptions();
    }
    else {
      this.GetPredefinedConfig();
      /////this.GetSystemConfig();
    }
    // this.GetMapConfigByID(42);
    // this.GetAllMapRegion();
    //this.DynamicHtmlEvent();
    //this.SetPinLegnd();

    this.control.valueChanges.subscribe(newValue => {
      this.mapNamesObservable = this._mapName(newValue);
    })

    this.controlReg.valueChanges.subscribe(newValue => {
      this.regNamesObservable = this._regName(newValue);
    })

    //https://github.com/SebastianM/angular-google-maps/issues/1378
    this.cd.detectChanges();

    // this.JsMapInitilization();



    //debugger;

    //var el = document.getElementById("img12");
    //el.onclick = this.ShowMapLegendWin;

    //this.elRef.nativeElement.querySelector('img').addEventListner('click', this.ShowMapLegendWin.bind(this));
    //this.elRef.nativeElement.querySelector('button').addEventListner('click', this.ShowMapLegendWin.bind(this));
    // setTimeout(() => { this.map.triggerResize(); }, 500)

    if (this.myConfigName != "null") {
      this.isLoading = true;
      this.interval = setInterval(() => {
        this.triggerCollection.forEach((x, i) => {
          if (i == 1) {
            const selMatOption = x.autocomplete.options.toArray();
            if (selMatOption.length > 0) {
              this.control.setValue(selMatOption.find((o) => o.value.name === this.myConfigName).value);
              clearInterval(this.interval);
            }
          }
        });

      }, 1000);
      this.isLoading = false;
    }

    if (this.myConfigNameReg != "null") {
      this.isLoading = true;
      this.interval = setInterval(() => {
        this.triggerCollection.forEach((x, i) => {
          if (i == 0) {
            const selMatOption = x.autocomplete.options.toArray();
            if (selMatOption.length > 0) {
              this.controlReg.setValue(selMatOption.find((o) => o.value.name === this.myConfigNameReg).value);
              clearInterval(this.interval);
            }
          }
        });
      }, 1000);
      this.isLoading = false;
    }
  }

  loadOMSLibrary(loadOldGoogleMap: boolean): void {
    const head = document.head;

    // Clear existing dynamic scripts
    const existingScripts = head.querySelectorAll('.dynamic-script');
    existingScripts.forEach(script => script.remove());

    // Create a new script element
    const script = this.renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = loadOldGoogleMap ? 'scripts/oms.min.js' : 'scripts/oms.min_NewVersion.js';
    script.classList.add('dynamic-script');
    script.onload = () => {
      console.log('Script loaded successfully.');
    };

    // Append the script to the head
    this.renderer2.appendChild(head, script);
    this.cd.detectChanges();
  }

  RestorePreviousDispalyOptions() {

    this.commonFilterService.displayOptionValues.subscribe(res => {
      //debugger;
      if (this.firstTimeFunctionCall) {
        this.status1 = true;////open left panel always

        ///// restore previousseleted mapregion
        this.commonFilterService.gmapRegion_Config.subscribe(res => {
          //let selectedMapConfigID = res;
          this.restorePreviousMapRegionName = "0";
          if (res != '0') {
            this.restorePreviousMapRegionName = res;
            ////alert(this.restorePreviousMapRegionName);
          }
        });
      }


      if (this.firstTimeFunctionCall && res != null) {

        this.firstTimeFunctionCall = false;
        //console.log(res);
        //this.cd.detectChanges();
        this.mapDisplayOptions = res as AbsMapDisplayOptions;

        //debugger;
        this.usePredefinedConfig = this.mapDisplayOptions.usePredefinedConfig == 0 ? "OFF" : "ON";
        if (this.mapDisplayOptions.PredefinedConfig.restoreLat != 0 && this.mapDisplayOptions.PredefinedConfig.restoreLng != 0) {
          this.zoom = this.mapDisplayOptions.PredefinedConfig.restoreZoom;
          this.lat = this.mapDisplayOptions.PredefinedConfig.restoreLat;
          this.lng = this.mapDisplayOptions.PredefinedConfig.restoreLng;
        }

        if (this.usePredefinedConfig == "OFF") {
          if (this.mapDisplayOptions.DisplayResultList.length <= 0)
            this.GetDispaylOption();
          this.DisplayResultList = this.mapDisplayOptions.DisplayResultList;
          this.AnalysisList = this.mapDisplayOptions.AnalysisList;
          this.NetTestList = this.mapDisplayOptions.NetTestList;
          this.MobileInfoList = this.mapDisplayOptions.MobileInfoList;
          this.ErrorEventList = this.mapDisplayOptions.ErrorEventList;
          this.analysisEnabled = this.mapDisplayOptions.analysisEnabled;
          if (this.mapDisplayOptions.analysisEnabled == "OFF")
            this.DivToggle('showAnalysis');
          this.netTestEnabled = this.mapDisplayOptions.netTestEnabled;
          if (this.mapDisplayOptions.netTestEnabled == "OFF")
            this.DivToggle('showNetTest');
          this.mobileInfoEnabled = this.mapDisplayOptions.mobileInfoEnabled;
          if (this.mapDisplayOptions.mobileInfoEnabled == "OFF")
            this.DivToggle('showMobileInfo');
          this.errorEventsEnabled = this.mapDisplayOptions.errorEventsEnabled;
          if (this.mapDisplayOptions.errorEventsEnabled == "OFF")
            this.DivToggle('showErrorEvents');

          ////call api method after restoring previous selected values
          //this.GetMapChanges();
          //this.GetMapConfigData();
          if (this.mapDisplayOptions.displayOptionApplied)
            this.GetMapChanges();
          else
            this.GetPredefinedConfig();
        }
        else {
          this.selMapConfig = this.mapDisplayOptions.mapConfigID.toString();
          /////// SET below the input text value - this.selMapConfig has previuosly selected value
          //debugger;

          this.GetPredefinedConfig();

          this.TypeList = this.mapDisplayOptions.TypeList;
          this.ResultList = this.mapDisplayOptions.ResultList;
          this.preDefinedConfigParam = this.mapDisplayOptions.PredefinedConfig;
          this.DrawRoute = this.preDefinedConfigParam.drawRoute == 0 ? "OFF" : "ON";

          if (this.mapDisplayOptions.displayOptionApplied)
            this.GetMapChanges();

        }
        //this.DrawLine = this.preDefinedConfigParam.                           ///// need to create and store in preDefinedConfigParam

      }
      else if (this.firstTimeFunctionCall && res == null) ////if firstTimeFunctionCall is true and subcribe res is null..this happen very first time after login and then visiting googlemap page where restore previous value will be null.
      {
        this.firstTimeFunctionCall = false;
        /// this.GetSystemConfig();
        //debugger;
        this.GetMapConfigData();  // .then(() => { this.isLoading=false});
        //this.GetPredefinedConfig();
      }

    });
  }
  refreshSelections() {
    //debugger;
    ////alert('refreshSelections');
    ///// on refresh click set zoom position to previuosly selected posiition
    if (this.mapDisplayOptions.PredefinedConfig) {
      this.selMapConfig = this.mapDisplayOptions.mapConfigID.toString();
      if (this.mapDisplayOptions.PredefinedConfig.restoreLat != 0 && this.mapDisplayOptions.PredefinedConfig.restoreLng != 0) {
        this.zoom = this.mapDisplayOptions.PredefinedConfig.restoreZoom;
        this.lat = this.mapDisplayOptions.PredefinedConfig.restoreLat;
        this.lng = this.mapDisplayOptions.PredefinedConfig.restoreLng;
      }
    }

    if (this.mapDisplayOptions.displayOptionApplied) {
      //this.HandleGeneralFilter();
      this.GetMapChanges();
    }
    else {
      if (this.usePredefinedConfig == "OFF")
        this.GetMapConfigData();
      else {
        //this.HandleGeneralFilter();
        this.GetMapConfigByID(this.selMapConfig);
      }
    }

    ////// redraw region paths on refresh  click
    this.GetAllMapRegion();


  }

  HandleGeneralFilter() {
    //console.log(this.delFilterColName)
    if (this.delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key.toUpperCase() !== this.SetTimestampSearch(this.TSSelected).toUpperCase())
          delete this.filters[key];
      }
    }

    if (this.delFilterColName != 'clearAllFilters') {
      this.genArr = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"].toUpperCase() != this.SetTimestampSearch(this.TSSelected).toUpperCase();
      });

      this.commonFilterService.GeneralFilterDF.subscribe(res => {
        //console.log(res)
        this.filters = res;
      });
    }

    if (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0) {
      this.dataFilter.filters = this.filtersWithEventID;
      //console.log(filtersWithEventID)
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });
      let generalFilterArrayAll = this.dataFilter.getProcessedFiltersArray("ALL");
      this.genArr = [...this.genArr, ...generalFilterArrayAll];

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
      let generalFilterArrayNew = this.dataFilter.getProcessedFilters("");
      this.filters = { ...this.filters, ...generalFilterArrayNew };
    }
    else if (Object.keys(this.filtersWithEventID).length == 0) {
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }

    }
    //console.log(genArr)
    //console.log(filters)

    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      //cleared = 1;
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });

      for (const key in this.filters) {
        if (key == this.delFilterColName)
          delete this.filters[key];
      }
    }
    //console.log(this.genArr)
    this.hasFilters = this.genArr.length <= 0 ? false : true;

    if (this.delFilterColName != 'clearAllFilters') {
      //let newFilters = {};
      //for (const key in this.filters) {
      //  if (this.filters[key].rsltType == 'call-events' || this.filters[key].rsltType == '') {
      //    let value = this.filters[key].value;
      //    let matchMode = this.filters[key].matchMode;
      //    let valueTo = this.filters[key].valueTo;
      //    let type = this.filters[key].type;
      //    let rsltType = this.filters[key].rsltType;
      //    let title = this.filters[key].title;
      //    newFilters[key] = { value, matchMode, valueTo, type, rsltType, title };
      //  }
      //}
      ////console.log(newFilters)
      this.commonFilterService.setGeneralFilterData(this.filters);//(newFilters);
    }
    else
      this.hasFilters = false;

    if (!this.hasFilters) {
      ///if clearfilter is clicked then remove all filters from this.genArr
      //debugger;
      this.genArr = [];
    }

  }

  //https://medium.com/@hassam.dev/integrating-google-maps-in-angular-d3d478c5f1c6
  scriptMapJS: any;
  scriptCallBack: any;
  loadScript(url) {
    //https://stackoverflow.com/questions/38088996/adding-script-tags-in-angular-component-template
    //https://www.tektutorialshub.com/angular/renderer2-angular/
    this.scriptCallBack = this.renderer2.createElement('script');
    this.scriptCallBack.type = 'text/javascript';
    this.scriptCallBack.text = `
            function initMap() {
                 console.log('init map google')
            }
        `;
    this.renderer2.appendChild(this.document.body, this.scriptCallBack);

    return new Promise((resolve, reject) => {
      this.scriptMapJS = this.renderer2.createElement('script');
      this.scriptMapJS.type = 'text/javascript';
      this.scriptMapJS.src = url;
      this.scriptMapJS.text = ``;
      this.scriptMapJS.async = true;
      this.scriptMapJS.defer = true;
      this.scriptMapJS.onload = resolve;
      this.scriptMapJS.onerror = reject;
      this.renderer2.appendChild(this.document.body, this.scriptMapJS);
    })
  }

  GetSystemConfig() {
    this.url = this.baseUrl + 'UserAndSytemConfig/GetUserSystemConfiguration';
    let GoogleMapsAPIKey = "";
    this.GetConfigurations_Service().subscribe((res: any) => {
      //debugger;
      let rows: any[] = JSON.parse(res) as any[];
      GoogleMapsAPIKey = rows["GoogleMapsAPIKey"];
      this.GoogleMapID = rows["GoogleMapID_AdvancedMarker"];

      this.loadOldGoogleMap = rows["OldGoogleMap"].split('|')[0] === "0" ? true : false;
      this.infowWindowFlag = rows["OldGoogleMap"].split('|')[1] === "ON" ? true : false;
      ///// add/remove old or new oms library based in index file based on condition.
      this.loadOMSLibrary(this.loadOldGoogleMap);

      if (GoogleMapsAPIKey == "" || this.GoogleMapID == 'DEMO_MAP_ID') {
        //https://stackoverflow.com/questions/41684114/easy-way-to-make-a-confirmation-dialog-in-angular
        //https://www.javachinna.com/angular-confirmation-dialog/
        //https://stackblitz.com/edit/angular-confirmation-dialog?file=app%2Fconfirmation-dialog%2Fconfirmation-dialog.service.ts
        //https://itnext.io/confirm-dialog-with-decorator-in-angular-7491d1237667
        if (confirm("API Key not set yet. Redirecting to setting page... Do you want to continue?")) {
          //this._router.navigate([{ outlets: { filterPopup: null, configPopup: ['configuration', 'UserSetting', true, 'false'] } }]);//splitting 'configuration/UserSetting' as / converting in %2f in URL
          this._router.navigate([{ outlets: { filterPopup: null, configPopup: ['configuration', 'UserSetting', '1', 'false'] } }]);//splitting 'configuration/UserSetting' as / converting in %2f in URL
        }
      }
      else if (this.GoogleMapID == 'DEMO_MAP_ID') {
        if (confirm("Maps ID not set yet. Redirecting to setting page... Do you want to continue?")) {
          this._router.navigate([{ outlets: { filterPopup: null, configPopup: ['configuration', 'UserSetting', '2', 'false'] } }]);//splitting 'configuration/UserSetting' as / converting in %2f in URL
        }
      }
      else {
        let foundScriptElem = false;
        //https://stackoverflow.com/questions/9390445/remove-appended-script-javascript
        //https://dirask.com/posts/JavaScript-how-to-get-current-script-element-Zpaz2j
        var c = document.getElementsByTagName('script');
        for (var x = 0; x < c.length; x++) {
          if (document.body.innerHTML.indexOf('initMap') != -1) {
            foundScriptElem = true;//c[x].parentElement.removeChild(c[x]);
            break;
          }
        }

        /////to check if script is already added or not
        const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
        if (existingScript) {
          console.log('Google Maps script already exists in the DOM.');
          return;
        }

        if (!foundScriptElem) {
          let url = "";
          if (this.loadOldGoogleMap) {
            url = 'https://maps.googleapis.com/maps/api/js?key=' + GoogleMapsAPIKey + '&libraries=places&libraries=geometry&callback=initMap';
          }
          else {
            ////// below code used for AdvacneMarker  async defer
            url = 'https://maps.googleapis.com/maps/api/js?key=' + GoogleMapsAPIKey + '&loading=async&libraries=places&libraries=geometry&libraries=marker&callback=initMap';
          }
          //setTimeout(() => {
          //  this.loadScript(url);
          //}, 500);
          this.loadScript(url);
          //console.log('url');
          //console.log(url);
        }
      }
    });
  }
  GetConfigurations_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }

  EmptyBindGMap() {
    try {
      //https://stackoverflow.com/questions/9228958/how-to-check-if-google-maps-api-is-loaded
      if (typeof google === 'object' && typeof google.maps === 'object') {
        ///// to initialize the map and center it at load
        this.map = new google.maps.Map(document.getElementById('map'), {
          //center: { lat: 20.593684, lng: 78.96288 }, /// India
          center: { lat: 40.4230, lng: -98.7372 }, /// USA
          zoom: 4,
          // mapId: this.GoogleMapID
        });
      }
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  }

  ////// Advanced Marker
  GeneratePinMarker(iconURL: any, markerType: any) {

    ///https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|F|BC1E1E|000000  ---- normal Pin
    ///https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|ff9900|000000|PASS  ----- bubble
    let iconText = "";
    let iconBGColor = "";
    let iconFontColor = "";
    //let iconText = iconURL.split('|')[1];
    //let iconBGColor = "#FFFF00";//"#"+ iconURL.split('|')[2];
    //let iconFontColor = "#ff0000";//"#"+iconURL.split('|')[3];
    let imageContent = iconURL;
    if (markerType == "Pin") {
      iconText = imageContent.split('|')[1] == '' ? "" : imageContent.split('|')[1];
      iconBGColor = "#" + imageContent.split('|')[2];
      iconFontColor = "#" + imageContent.split('|')[3];
      const pinBackground = new google.maps.marker.PinElement({
        background: iconBGColor,  //'blue',        
        glyph: iconText,  // 'A', // text inside pin
        glyphColor: iconFontColor, // 'yellow',///color of text
        scale: 0.9, //// size of the icon pin
        borderColor: 'black'
        //borderColor: 'yellow',
      });
      return pinBackground.element;
    }
    else if (markerType == "Bubble") {
      //iconText = imageContent.split('|')[3] == '' ? "" : (imageContent.split('|')[3]).substring(0, 4)+"..";
      iconText = imageContent.split('|')[3] == "" ? '' : (imageContent.split('|')[3].length > 4 ? imageContent.split('|')[3].substring(0, 4) + ".." : imageContent.split('|')[3]),
        iconBGColor = "#" + imageContent.split('|')[1];
      iconFontColor = "#" + imageContent.split('|')[2];

      ///// create a stylesheet to be used by the marker
      //const stylesheet = document.createElement('style');
      // stylesheet.textContent = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 50px;  background: ' + iconBGColor + ';  border-radius: 5px;  padding: 4px;height:20px;  text-align: center;  color: ' + iconFontColor + ';padding-top:8px;}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid ' + iconBGColor + ';  border-right: 5px solid transparent;  border-top: 5px solid ' + iconBGColor + ';  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;}';
      //document.head.appendChild(stylesheet);

      //const htmlCSSTag = document.createElement("div");
      //htmlCSSTag.className = "bubble bubble-bottom-left";
      //htmlCSSTag.textContent = iconText;//"ABC";
      //return htmlCSSTag;

      let pinSvgString = '<svg width="30" height="35" viewBox="0 0 24 24"  stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"  style="fill:red;"></path><text x="50%" y="50%" text-anchor="middle" style="color:LABELCOLOR;" font-size="7" dy=".3em">LABEL</text></svg>';

      let encodedSvg = pinSvgString.replace('fill:red', `fill:${iconBGColor}`).replace('color:LABELCOLOR', `color: ${iconFontColor}`).replace('LABEL', `${iconText}`);

      ///// Create a div element for the icon with text
      const iconContainer = document.createElement('div');
      iconContainer.style.position = 'relative';
      iconContainer.style.width = '30px';
      iconContainer.style.height = '35px';
      iconContainer.style.display = 'flex';
      iconContainer.style.alignItems = 'center';
      iconContainer.style.justifyContent = 'center';
      // iconContainer.style.zIndex = '-100';
      // iconContainer.style.position = 'relative';

      //iconContainer.innerHTML = `
      //          <i class="fa fa-comment" style="font-size: 32px; color: ${iconBGColor}; position: absolute;"></i>
      //          <span style="font-size: 12px; color: ${iconFontColor}; position: absolute;">${iconText}</span>
      //      `;
      iconContainer.innerHTML = encodedSvg;

      return iconContainer;

    }
  }

  //////// old marker generation
  GeneratePinMarker_Custom(iconURL: any, iconBGColor: any) {
    //debugger;
    let iconText = "";
    let iconFontColor = "";

    if (iconURL.includes('d_map_xpin_letter')) {

      iconText = iconURL.split('|')[1] == '' ? "" : iconURL.split('|')[1];
      ////iconBGColor = "#" + imageContent.split('|')[2];
      iconFontColor = "#" + iconURL.split('|')[3];

      ////// start SVG IMAGE OF FONTWAESOME
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('height', '10');
      svg.setAttribute('width', '7.5');
      svg.setAttribute('viewBox', '0 0 384 512');

      // Create the path element
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z');
      path.setAttribute('fill', iconBGColor); // Set the initial fill color
      path.setAttribute('stroke', 'black'); // Set the border color
      path.setAttribute('stroke-width', '10'); // Set the border width

      // Append the path to the SVG element
      svg.appendChild(path);


      // Convert the SVG element to a data URL
      const svgString = new XMLSerializer().serializeToString(svg);  ////// WORKING CODE
      const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgString); ////// WORKINGCODE

      ////// end SVG IMAGE OF FONTWAESOME

      ///Below is new pin icon with large size
      //const svgCode = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="256" height="256"> <path d="M0 0 C1.49225096 1.31867315 2.97169917 2.65198674 4.4375 4 C5.2625 4.67417969 6.0875 5.34835938 6.9375 6.04296875 C23.70705858 20.07724872 32.69367412 40.914815 35.12109375 62.32421875 C37.17298628 86.16163694 31.79752038 108.48509774 16.4375 127 C11.21097724 133.17009542 5.57203133 138.89132968 -0.1875 144.5625 C-5.40893677 149.73949901 -10.02632982 155.22093503 -14.5625 161 C-15.74779297 162.44246094 -15.74779297 162.44246094 -16.95703125 163.9140625 C-34.10477167 185.24747184 -47.34154029 212.60333119 -50.5625 240 C-51.2225 240 -51.8825 240 -52.5625 240 C-52.69785156 239.16082031 -52.83320312 238.32164062 -52.97265625 237.45703125 C-56.11102437 219.92351353 -62.02684485 203.60437443 -70.5625 188 C-71.19579093 186.79842912 -71.82860973 185.59660927 -72.4609375 184.39453125 C-77.2515364 175.47414815 -83.10396507 167.7584887 -89.5625 160 C-90.03171875 159.42781738 -90.5009375 158.85563477 -90.984375 158.26611328 C-96.69418203 151.3151291 -102.67363797 144.83144533 -109.125 138.5625 C-118.75425769 129.14891416 -127.40487549 118.56344431 -132.5625 106 C-132.84351563 105.34773438 -133.12453125 104.69546875 -133.4140625 104.0234375 C-142.07914215 81.35418871 -139.98252938 54.99975513 -130.5625 33 C-120.02121251 10.81609648 -101.24911082 -4.32527519 -78.5625 -13 C-53.03417178 -21.44667551 -21.18780277 -16.62376349 0 0 Z " style="fill:red;stroke:black; stroke-width:5;" transform="translate(179.5625,19)" /></svg>';
      //const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgCode.replace('fill:red', `fill:${iconBGColor}`));

      return svgUrl;
    }
    else if (iconURL.includes('d_bubble_texts_big')) {

      console.log(iconURL.split('|')[3]);
      iconText = iconURL.split('|')[3] == "" ? '' : (iconURL.split('|')[3].length > 4 ? iconURL.split('|')[3].substring(0, 4) + ".." : iconURL.split('|')[3]),
        ///iconBGColor = "#" + imageContent.split('|')[1];
        iconFontColor = "#" + iconURL.split('|')[2];


      //let iconText = iconURL.split('|')[1];
      //let iconBGColor = iconURL.split('|')[2];
      //let iconFontColor = iconURL.split('|')[3];
      //// create a stylesheet to be used by the marker
      //const stylesheet = document.createElement('style');
      //iconText = iconURL.split('|')[3];
      //iconBGColor = iconURL.split('|')[1];
      //iconFontColor = iconURL.split('|')[2];
      ////stylesheet.textContent = '.test-marker { border: 5px solid orange; border-radius: 4px; padding: 8px 12px; background-color: red; pointer-events: all; }.test - marker: hover {background: blue; }';
      /////stylesheet.textContent +=' .test-marker: hover{background-color: blue; }';
      ////stylesheet.textContent = '.test-marker { background-color: blue; border-radius: 8px;  color: #FFFFFF;  font-size: 14px;  padding: 10px 15px;  position: absolute; }';
      //stylesheet.textContent = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 50px;  background: ' + iconBGColor + ';  border-radius: 5px;  padding: 4px;height:20px;  text-align: center;  color: ' + iconFontColor + ';padding-top:8px;}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid ' + iconBGColor + ';  border-right: 5px solid transparent;  border-top: 5px solid ' + iconBGColor + ';  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;}';
      //document.head.appendChild(stylesheet);

      //const htmlCSSTag = document.createElement("div");
      //htmlCSSTag.className = "bubble bubble-bottom-left";
      //htmlCSSTag.textContent = iconText;//"ABC";

      ////// start SVG IMAGE OF FONTWAESOME

      //const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      //svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      //svg.setAttribute('height', '10');
      //svg.setAttribute('width', '7.5');
      //svg.setAttribute('viewBox', '0 0 512 512');
      //// Create the path element
      //const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      //path.setAttribute('d', 'M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z');

      //path.setAttribute('fill', iconBGColor); // Set the initial fill color
      //// Append the path to the SVG element
      //svg.appendChild(path);
      //// Convert the SVG element to a data URL
      //const svgString = new XMLSerializer().serializeToString(svg);
      //const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgString);
      //// Create the marker icon object
      ////const svgMarker = {
      ////  url: svgUrl,
      ////  scaledSize: new google.maps.Size(52, 52), // Size of the icon
      ////};

      ////// end SVG IMAGE OF FONTWAESOME

      ////sharp end square
      //const svgCode = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="2048" height="2048" style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd"><defs><style>.fil0{fill:none}</style></defs><g id="Layer_x0020_1"><g id="_243117056"><path id="_243119432" class="fil0" d="M0 0h2048v2048H0z"/><path id="_243116192" class="fil0" d="M255.999 255.999h1536v1536h-1536z"/></g><path d="M1792 597.28v645.119c0 16.966-13.755 30.722-30.72 30.722H844.263l-247.755 200.01a30.588 30.588 0 0 1-10.769 6.548c-15.993 5.66-33.549-2.717-39.21-18.71l28.96-10.25-28.92 10.2-66.466-187.799H286.72c-16.966 0-30.72-13.755-30.72-30.721v-645.12c0-16.965 13.754-30.72 30.72-30.72h1474.56c16.965 0 30.72 13.755 30.72 30.72z" style="fill:red;fill-rule:nonzero"/></g></svg>';

      ///// rounded end square
      //const svgCode = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 76.92" style="enable-background:new 0 0 122.88 76.92" xml:space="preserve"><g><path class="st0" d="M13.49,0h95.9c3.71,0,7.08,1.52,9.53,3.96c2.45,2.45,3.96,5.82,3.96,9.53v34.46c0,3.71-1.51,7.11-3.96,9.58 c-2.43,2.44-5.79,3.97-9.53,3.97H24.87L3.81,76.47c-1.08,0.77-2.58,0.52-3.35-0.57c-0.3-0.42-0.45-0.91-0.45-1.39H0V13.49 C0,9.78,1.52,6.4,3.96,3.96C6.4,1.52,9.78,0,13.49,0L13.49,0z M45.98,15.26v29.25h-7.62V32.23h-2.22v12.28h-7.62V15.26h7.62v10.46 h2.22V15.26H45.98L45.98,15.26z M65.36,32.94H55.9v5.2c0,1.08,0.08,1.79,0.23,2.1c0.16,0.31,0.46,0.47,0.91,0.47 c0.56,0,0.94-0.21,1.12-0.62c0.19-0.42,0.28-1.23,0.28-2.42v-3.17h6.91v1.78c0,1.49-0.09,2.63-0.28,3.42 c-0.19,0.8-0.63,1.65-1.31,2.55c-0.68,0.91-1.56,1.58-2.61,2.04c-1.05,0.45-2.37,0.68-3.96,0.68c-1.54,0-2.9-0.22-4.09-0.67 c-1.18-0.44-2.1-1.05-2.76-1.83c-0.66-0.78-1.11-1.63-1.36-2.57c-0.25-0.93-0.38-2.29-0.38-4.07v-7c0-2.1,0.28-3.75,0.85-4.96 c0.57-1.21,1.49-2.14,2.78-2.78c1.29-0.65,2.77-0.97,4.45-0.97c2.05,0,3.73,0.39,5.07,1.17c1.33,0.78,2.27,1.81,2.8,3.09 c0.54,1.28,0.8,3.08,0.8,5.41V32.94L65.36,32.94z M58.08,29.05V27.3c0-1.25-0.07-2.04-0.2-2.4c-0.14-0.36-0.41-0.54-0.83-0.54 c-0.52,0-0.84,0.15-0.96,0.46c-0.12,0.31-0.19,1.13-0.19,2.48v1.75H58.08L58.08,29.05z M75.24,15.26v29.25h-7.51V15.26H75.24 L75.24,15.26z M85.28,20.55l-0.13,2.12c0.65-0.86,1.37-1.5,2.15-1.93c0.78-0.43,1.64-0.63,2.56-0.63c1.13,0,2.11,0.3,2.94,0.91 c0.82,0.61,1.34,1.31,1.54,2.11c0.2,0.79,0.31,2.14,0.31,4.05v10.1c0,2.18-0.13,3.73-0.39,4.65c-0.26,0.92-0.79,1.66-1.59,2.21 c-0.8,0.55-1.77,0.82-2.9,0.82c-0.9,0-1.74-0.21-2.51-0.63c-0.77-0.43-1.47-1.05-2.11-1.89v5.49h-7.28V20.55H85.28L85.28,20.55z M87.37,27.52c0-1.49-0.06-2.38-0.17-2.69c-0.11-0.31-0.41-0.47-0.91-0.47c-0.49,0-0.8,0.18-0.94,0.54 c-0.14,0.36-0.21,1.23-0.21,2.62v9.94c0,1.44,0.07,2.35,0.22,2.71c0.15,0.36,0.46,0.54,0.95,0.54c0.47,0,0.76-0.17,0.88-0.5 c0.12-0.33,0.17-1.13,0.17-2.41V27.52L87.37,27.52z" style="fill:red;"/></g></svg>';
      //const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgCode.replace('fill:red', `fill:${iconBGColor}`));
      //iconBGColor = '#3366FF';
      //const svgCode = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#cb372b" d="M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z" style="fill:red;"/> </svg>';
      //const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgCode.replace('fill:red', `fill:${iconBGColor}`));


      ///////// CURRENTLY WORKING CODE
      // const svgCode = '<svg xmlns="http://www.w3.org/2000/svg" width="71" height="45" viewBox="0 0 71 45" fill="none"> <rect width="71" height="37" rx="10"  style="fill:red;"/><path d="M35 45L27 37H43L35 45Z"   style="fill:red1;"/> </svg>';
      // const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgCode.replace('fill:red', `fill:${iconBGColor}`).replace('fill:red1', `fill:${iconBGColor}`));

      // let pinSvgString = '<svg width="30" height="35" viewBox="0 0 24 24"  stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"  style="fill:red;"></path><text x="50%" y="50%" text-anchor="middle" style="color:LABELCOLOR;" font-size="7" dy=".3em">LABEL</text></svg>';
      // let encodedSvg = pinSvgString.replace('fill:red', `fill:${iconBGColor}`).replace('color:LABELCOLOR', `color: ${iconFontColor}`).replace('LABEL', `${iconText}`);
      //console.log(encodedSvg);

      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('height', '35');
      svg.setAttribute('width', '50');
      svg.setAttribute('viewBox', '0 0 24 24');

      // Create the path element
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z');
      path.setAttribute('fill', iconBGColor); // Set the initial fill color

      // Append the path to the SVG element
      svg.appendChild(path);

      // Convert the SVG element to a data URL
      const svgString = new XMLSerializer().serializeToString(svg);  ////// WORKING CODE
      const svgUrl = 'data:image/svg+xml;base64,' + btoa(svgString); ////// WORKINGCODE.

      return svgUrl;  //svgUrl;
    }
    else
      return iconURL;


  }

  //saveSVG(): void {
  //  saveSvgAsPng(document.getElementById('svgId'), "pinmain.png");
  //}
  testcount = 0;
  async Test() {
    console.log('start outer func');
    console.log(this.testcount);
    await this.innerFunc();
    console.log(this.testcount);
    console.log('end inner func');
  }

  innerFunc(): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Inner function executed after 2 seconds');
        this.testcount = 1;
        resolve();
      }, 2000);
    });

  }

  ////JsMapInitilization_OGCode
  async JsMapInitilization_OGCode() {
    //debugger;
    //this.saveSVG();
    // //alert('JsMapInitilization_OGCode');
    ///// to initialize the map and center it at load
    this.map = new google.maps.Map(document.getElementById('map'), {
      //center: { lat: 20.593684, lng: 78.96288 }, /// India
      center: { lat: this.lat, lng: this.lng }, //{ lat: 40.4230, lng: -98.7372 }, /// USA
      zoom: this.zoom, ///4,
      minZoom: 3,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      ////mapId: 'DEMO_MAP_ID' // Map ID is required for advanced markers.
      mapId: this.GoogleMapID   //'DEMO_MAP_ID' // Map ID is required for advanced markers.
    });

    //// added overlay to avoid following issue "Cannot read properties of undefined (reading 'fromLatLngToDivPixel')" is related to the google.maps.OverlayView
    ////and is caused when attempting to access the map's overlay view before it is fully initialized.
    //this.overlay = new google.maps.OverlayView();
    //this.overlay.setMap(this.map);

    this.addZoomChangeListener();
    //// initialize spiderfy
    const oms = new OverlappingMarkerSpiderfier(this.map, this.optionsOMS);
    //debugger;
    ////alert(1);

    /////////////////////////////////////////////////////////////   START ADVANCED MARKER EXAMPLE
    //const pinImage = new google.maps.marker.PinElement({
    //  background: 'blue',
    //  borderColor: 'yellow',
    //  glyph: 'A', // text inside pin
    //  glyphColor: 'yellow',///color of text
    //  scaledSize: new google.maps.Size(32, 32),
    //});
    //const beachFlagImg = document.createElement('img');
    //beachFlagImg.src = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'; ///this is working
    ////beachFlagImg.src =  './assets/images/Marks/vectorpin.avif'; ///this is working
    ////beachFlagImg.src = 'url(' + pinImage + ')';
    ////beachFlagImg.style.backgroundColor = "red";    
    //beachFlagImg.style.width = "30px";
    //beachFlagImg.style.height = "30px";
    //beachFlagImg.style.color = "blue";



    //// working pin with text Advacned Marker example

    //const pinBackground = new google.maps.marker.PinElement({
    //  background: 'blue',
    //  borderColor: 'yellow',
    //  glyph: 'A', // text inside pin
    //  glyphColor: 'yellow',///color of text 
    //});


    // create a stylesheet to be used by the marker
    ////const stylesheet = document.createElement('style');
    ////const bgColor = 'yellow';
    ////const fontColor = 'black';
    //////stylesheet.textContent = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 40px;  background: ' + bgColor + ';  border-radius: 10px;  padding: 10px;  text-align: center;  color: ' + fontColor + ';}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 10px solid ' + bgColor + ';  border-right: 10px solid transparent;  border-top: 10px solid ' + bgColor + ';  border-bottom: 20px solid transparent;  left: 5px;  bottom: -24px;}';
    ////stylesheet.textContent = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 50px;  background: ' + bgColor + ';  border-radius: 5px;  padding: 4px;height:20px;  text-align: center;  color: ' + fontColor + ';padding-top:8px;}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid ' + bgColor + ';  border-right: 5px solid transparent;  border-top: 5px solid ' + bgColor + ';  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;}';
    ////document.head.appendChild(stylesheet);
    ////const htmlCSSTag = document.createElement("div");
    ////htmlCSSTag.className = "bubble bubble-bottom-left";
    ////htmlCSSTag.textContent = "PASS";


    ////////////
    // A marker with a custom inline SVG.
    // const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"><rect width="56" height="56" rx="28" fill="#7837FF"></rect><path d="M46.0675 22.1319L44.0601 22.7843" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.9402 33.2201L9.93262 33.8723" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M27.9999 47.0046V44.8933" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M27.9999 9V11.1113" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M39.1583 43.3597L37.9186 41.6532" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.8419 12.6442L18.0816 14.3506" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.93262 22.1319L11.9402 22.7843" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M46.0676 33.8724L44.0601 33.2201" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M39.1583 12.6442L37.9186 14.3506" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.8419 43.3597L18.0816 41.6532" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M28 39L26.8725 37.9904C24.9292 36.226 23.325 34.7026 22.06 33.4202C20.795 32.1378 19.7867 30.9918 19.035 29.9823C18.2833 28.9727 17.7562 28.0587 17.4537 27.2401C17.1512 26.4216 17 25.5939 17 24.7572C17 23.1201 17.5546 21.7513 18.6638 20.6508C19.7729 19.5502 21.1433 19 22.775 19C23.82 19 24.7871 19.2456 25.6762 19.7367C26.5654 20.2278 27.34 20.9372 28 21.8649C28.77 20.8827 29.5858 20.1596 30.4475 19.6958C31.3092 19.2319 32.235 19 33.225 19C34.8567 19 36.2271 19.5502 37.3362 20.6508C38.4454 21.7513 39 23.1201 39 24.7572C39 25.5939 38.8488 26.4216 38.5463 27.2401C38.2438 28.0587 37.7167 28.9727 36.965 29.9823C36.2133 30.9918 35.205 32.1378 33.94 33.4202C32.675 34.7026 31.0708 36.226 29.1275 37.9904L28 39Z" fill="#FF7878"></path></svg>';
    ////const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 32 32"><path d="M13 32a1 1 0 0 1-1-1v-5h-1A11 11 0 0 1 0 15v-4A11 11 0 0 1 11 0h10a11 11 0 0 1 11 11v4a11 11 0 0 1-11 11h-1.59l-5.71 5.71a1 1 0 0 1-.7.29zM11 2a9 9 0 0 0-9 9v4a9 9 0 0 0 9 9h2a1 1 0 0 1 1 1v3.59l4.29-4.29A1 1 0 0 1 19 24h2a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9z" data-name="37-Speech Bubble"/></svg>';
    ////const parser = new DOMParser();
    ////const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

    /////////////////////////////////////////////////////////////                 END ADVANCED MARKER EXAMPLE



    let len = this.markerPositions.length;

    let iconText = "";
    let iconBGColor = "";
    let iconFontColor = "";
    let labelOptions = null;// Initialize label options as null
    let widthImg = 32;
    let heightImg = 32;
    //console.log(this.markerPositions);

    for (let i = 0; i < this.markerPositions.length; i++) {
      iconText = "";
      iconBGColor = "";
      iconFontColor = "";
      labelOptions = null;


      let imageContent = this.markerPositions[i].iconurl;
      ////imageContent = './assets/images/Marks/DarkGreenMark.png';
      let marker = new google.maps.Marker({
        //position: this.markerPositions[i],
        position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
        map: this.map,// Set the map on which to display the marker
        icon: {
          //url: this.markerPositions[i].iconurl, // Set the URL of the custom icon image          
          //url: this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl,red), // Set the URL of the custom icon image
          //url: imageIcon,
          //url: svgUrl,//svgMarker,
          url: imageContent,
          scaledSize: new google.maps.Size(widthImg, heightImg), // Set the size of the icon image
          //scaledSize: new google.maps.Size(this.markerPositions[i].widthImg, this.markerPositions[i].heightImg), // Set the size of the icon image
          //anchor: new google.maps.Point(5, 15),
          labelOrigin: new google.maps.Point(10, 10),
        },
        //icon: imageContent,
        label: labelOptions, // Set label options based on condition
        //zIndex: this.markerPositions[i].iconZIndex, // Set zIndex to bring the marker to the front
      });
      //let beachFlagImg = document.createElement('img');
      //beachFlagImg.src = imageContent;
      //let marker = new google.maps.marker.AdvancedMarkerElement({
      //  //position: pinType == 'pin' ? new google.maps.LatLng(this.markerPositions[i].lat_num + 0.00003, this.markerPositions[i].lng_num) : new google.maps.LatLng(this.markerPositions[i].lat_num - 0.00003, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
      //  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num),
      //  map: this.map,// Set the map on which to display the marker

      //  //content: beachFlagImg, ///external website image
      //  //content: pinSvg, /////bubble with svg image
      //  //content: bubbleImage,

      //  //content: iconImage, ////////// this is for default map loading with static pin images  ///the working one properly for default pins with predefined config OFF        
      //  //content: pinBackground.element, ////plain pin marker with background color changeable
      //  //content: htmlCSSTag, ////square bubble with html css
      //  content: beachFlagImg,
      //  //zIndex: this.markerPositions[i].iconZIndex,
      //  //zIndex: (i % 2) == 0 ? google.maps.Marker.MAX_ZINDEX + 1 : -1,
      //});
      if (this.markerPositions[i].iconurl.includes('d_map_xpin_letter')) {
        /// https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin||00ff00|FFFFFF
        widthImg = 32;
        heightImg = 32;
        iconText = imageContent.split('|')[1] == '' ? "" : imageContent.split('|')[1];
        //iconBGColor = "#" + imageContent.split('|')[2];
        iconBGColor = imageContent.split('|')[2];
        //iconFontColor = "#" + imageContent.split('|')[3];
        iconFontColor = imageContent.split('|')[3];
        //if (iconText != "") {
        //  labelOptions = {
        //    text: iconText,
        //    color: iconFontColor, // Set label color
        //    fontWeight: "bold",
        //  };
        //}
        //imageContent = this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl, iconBGColor);
        //imageContent = {
        //  //path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",

        //  path: "M 5.230469 1.875 C 0.617188 4.351562 0.230469 9.300781 4.230469 14.175781 C 5.691406 15.976562 7.078125 18.523438 7.382812 19.949219 C 7.921875 22.875 9.230469 24.148438 9.230469 21.75 C 9.230469 19.800781 11.152344 16.125 13.539062 13.273438 C 16.078125 10.351562 16.078125 5.398438 13.617188 3.148438 C 11.230469 0.976562 7.847656 0.449219 5.230469 1.875 Z M 5.230469 1.875",
        //  //path: "M 3.597656 1.25 C 0.421875 2.898438 0.160156 6.199219 2.910156 9.449219 C 3.914062 10.648438 4.867188 12.351562 5.078125 13.300781 C 5.445312 15.25 6.347656 16.101562 6.347656 14.5 C 6.347656 13.199219 7.667969 10.75 9.308594 8.851562 C 11.054688 6.898438 11.054688 3.601562 9.359375 2.101562 C 7.722656 0.648438 5.394531 0.300781 3.597656 1.25 Z M 3.597656 1.25",
        //  ////path: "M 1.632812 0.546875 C 0.191406 1.269531 0.0703125 2.710938 1.320312 4.132812 C 1.777344 4.660156 2.210938 5.402344 2.308594 5.820312 C 2.476562 6.671875 2.882812 7.042969 2.882812 6.34375 C 2.882812 5.773438 3.484375 4.703125 4.230469 3.871094 C 5.023438 3.019531 5.023438 1.574219 4.253906 0.917969 C 3.507812 0.285156 2.453125 0.132812 1.632812 0.546875 Z M 1.632812 0.546875",
        //  ////path: "M68 295 c-60 -33 -65 -99 -13 -164 19 -24 37 -58 41 -77 7 -39 24 -56 24 -24 0 26 25 75 56 113 33 39 33 105 1 135 -31 29 -75 36 -109 17z",
        //  fillColor: iconBGColor,
        //  fillOpacity: 1,//0.6,
        //  strokeWeight: 1,
        //  rotation: 0,
        //  scale: 1.6,
        //  //anchor: new google.maps.Point(0, 20),
        //  //https://stackoverflow.com/questions/50144150/how-to-perfectly-center-a-label-within-a-google-maps-marker
        //  labelOrigin: new google.maps.Point(8, 8),
        //  //https://convertio.co/
        //  //https://www.iloveimg.com/resize-image/resize-svg
        //  //https://jsfiddle.net/gh/get/library/pure/googlemaps/js-samples/tree/master/dist/samples/marker-symbol-custom/jsfiddle
        //};
        imageContent = './assets/images/Marks/Dynamic/pin_' + iconBGColor + '_' + iconText + '_' + iconFontColor + '.png';
        marker = new google.maps.Marker({
          //position: this.markerPositions[i],
          position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
          map: this.map,// Set the map on which to display the marker
          icon: {
            //url: this.markerPositions[i].iconurl, // Set the URL of the custom icon image          
            //url: this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl,red), // Set the URL of the custom icon image
            //url: imageIcon,
            //url: svgUrl,//svgMarker,
            url: imageContent,
            //scaledSize: new google.maps.Size(widthImg, heightImg), // Set the size of the icon image
            //scaledSize: new google.maps.Size(this.markerPositions[i].widthImg, this.markerPositions[i].heightImg), // Set the size of the icon image
            //anchor: new google.maps.Point(5, 15),
            //labelOrigin: new google.maps.Point(10, 10),
          },
          //icon: imageContent,
          //label: labelOptions, // Set label options based on condition
          //zIndex: this.markerPositions[i].iconZIndex, // Set zIndex to bring the marker to the front
        });

        ////beachFlagImg = document.createElement('img');
        //beachFlagImg.src = imageContent;
        //marker = new google.maps.marker.AdvancedMarkerElement({
        //  //position: pinType == 'pin' ? new google.maps.LatLng(this.markerPositions[i].lat_num + 0.00003, this.markerPositions[i].lng_num) : new google.maps.LatLng(this.markerPositions[i].lat_num - 0.00003, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
        //  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num),
        //  map: this.map,// Set the map on which to display the marker

        //  //content: beachFlagImg, ///external website image
        //  //content: pinSvg, /////bubble with svg image
        //  //content: bubbleImage,

        //  //content: iconImage, ////////// this is for default map loading with static pin images  ///the working one properly for default pins with predefined config OFF        
        //  //content: pinBackground.element, ////plain pin marker with background color changeable
        //  //content: htmlCSSTag, ////square bubble with html css
        //  content: beachFlagImg,
        //  //zIndex: this.markerPositions[i].iconZIndex,
        //  //zIndex: (i % 2) == 0 ? google.maps.Marker.MAX_ZINDEX + 1 : -1,
        //});
      }
      else if (this.markerPositions[i].iconurl.includes('d_bubble_texts_big')) {
        //////  https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|00ff00|404040|TCP
        //////  https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|0000ff|ffffff|DROP|0

        widthImg = 50;
        heightImg = 30;
        iconText = imageContent.split('|')[3] == '' ? "" : imageContent.split('|')[3];
        //iconText = imageContent.split('|')[3] == "" ? '' : (imageContent.split('|')[3].length > 4 ? imageContent.split('|')[3].substring(0, 4) + ".." : imageContent.split('|')[3]),
        //iconBGColor = "#" + imageContent.split('|')[1];
        iconBGColor = imageContent.split('|')[1];
        //iconFontColor = "#" + imageContent.split('|')[2];
        iconFontColor = imageContent.split('|')[2];
        //if (iconText != "") {
        //  labelOptions = {
        //    text: iconText,//"Verizon",
        //    color: iconFontColor, // Set label color
        //    fontSize: '10px',
        //    fontWeight: 'bold'
        //  };
        //}
        //imageContent = this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl, iconBGColor);
        //imageContent = {
        //  path: "M12 573 c8 -10 35 -42 61 -72 l47 -53 0 -195 0 -195 29 -29 29 -29 447 0 447 0 29 29 29 29 0 167 0 167 -29 29 -29 29 -430 0 -429 0 -102 70 c-105 72 -125 83 -99 53z m846 -140 c-120 -2 -316 -2 -435 0 -120 1 -22 2 217 2 239 0 337 -1 218 -2z m-721 -280 c-1 -54 -3 -12 -3 92 0 105 2 149 3 98 2 -51 2 -136 0 -190z m980 -16 c-1 -45 -3 -5 -3 88 0 94 2 130 3 82 2 -48 2 -125 0 -170z m-264 -124 c-122 -2 -324 -2 -450 0 -125 1 -25 2 222 2 248 0 350 -1 228 -2z",
        //  //path: "M416,0H96C42.969,0,0,42.969,0,96v160c0,53.031,42.969,96,96,96h63.984L256,512l96-160h64c53.031,0,96-42.969,96-96V96 C512,42.969,469.031,0,416,0z",
        //  fillColor: iconBGColor,
        //  fillOpacity: 1,////0.6,
        //  strokeWeight: 0.05,//1
        //  rotation: 0,
        //  scale: 0.05,//0.09,
        //  //anchor: new google.maps.Point(0, 20),
        //  //https://stackoverflow.com/questions/35779473/text-labels-to-google-map-markers
        //  //text: "Verizon",
        //  //align: "center",
        //  labelOrigin: new google.maps.Point(500, 100), //new google.maps.Point(250, 150),
        //};
        imageContent = './assets/images/Marks/Dynamic/bb_' + iconBGColor + '_' + iconText + '_' + iconFontColor + '.png';
        //console.log(imageContent)
        //marker = new google.maps.MarkerWithLabel({
        //  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position,
        //  map: map,
        //  draggable: true,
        //  raiseOnDrag: true,
        //  labelContent: "ABCDEFGH",
        //  labelAnchor: new google.maps.Point(15, 65),
        //  labelClass: "labels", // the CSS class for the label
        //  labelInBackground: false,
        //  icon: {
        //    path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        //    fillColor: iconBGColor,
        //    fillOpacity: 1,
        //    strokeColor: '#000',
        //    strokeWeight: 2,
        //    scale: 2
        //  }
        //});

        marker = new google.maps.Marker({
          //position: this.markerPositions[i],
          position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
          map: this.map,// Set the map on which to display the marker
          icon: {
            //  //url: this.markerPositions[i].iconurl, // Set the URL of the custom icon image          
            //  //url: this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl,red), // Set the URL of the custom icon image
            //  //url: imageIcon,
            //  //url: svgUrl,//svgMarker,
            url: imageContent,
            scaledSize: new google.maps.Size(widthImg, heightImg), // Set the size of the icon image
            //  //scaledSize: new google.maps.Size(this.markerPositions[i].widthImg, this.markerPositions[i].heightImg), // Set the size of the icon image
            //  //anchor: new google.maps.Point(5, 15),
            //labelOrigin: new google.maps.Point(25, 10),
          },
          //icon: imageContent,
          //label: labelOptions, // Set label options based on condition
          //zIndex: this.markerPositions[i].iconZIndex, // Set zIndex to bring the marker to the front
        });
        ////beachFlagImg = document.createElement('img');
        //beachFlagImg.src = imageContent;
        //marker = new google.maps.marker.AdvancedMarkerElement({
        //  //position: pinType == 'pin' ? new google.maps.LatLng(this.markerPositions[i].lat_num + 0.00003, this.markerPositions[i].lng_num) : new google.maps.LatLng(this.markerPositions[i].lat_num - 0.00003, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
        //  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num),
        //  map: this.map,// Set the map on which to display the marker

        //  //content: beachFlagImg, ///external website image
        //  //content: pinSvg, /////bubble with svg image
        //  //content: bubbleImage,

        //  //content: iconImage, ////////// this is for default map loading with static pin images  ///the working one properly for default pins with predefined config OFF        
        //  //content: pinBackground.element, ////plain pin marker with background color changeable
        //  //content: htmlCSSTag, ////square bubble with html css
        //  content: beachFlagImg,
        //  //zIndex: this.markerPositions[i].iconZIndex,
        //  //zIndex: (i % 2) == 0 ? google.maps.Marker.MAX_ZINDEX + 1 : -1,
        //});
      }
      ////else
      ////  imageContent = this.markerPositions[i].iconurl; ///default pin when predefined config is OFF

      //console.log(this.markerPositions[i].iconurl);
      //console.log(labelOptions);
      //console.log(imageContent);
      //console.log(this.markerPositions[i].heightImg);

      //imageContent = './assets/images/Marks/DarkGreenMark.png';
      //const svgMarker = {
      //  path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
      //  fillColor: "blue",
      //  fillOpacity: 0.6,
      //  strokeWeight: 0,
      //  rotation: 0,
      //  scale: 2,
      //  anchor: new google.maps.Point(0, 20),
      //};

      ////////////////// Previous worked  marker but currently it is depreceated by googlemap so using AdvancedMarkerElement
      //const marker = new google.maps.Marker({
      //  //position: this.markerPositions[i],
      //  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
      //  map: this.map,// Set the map on which to display the marker
      //  icon: {
      //    //url: this.markerPositions[i].iconurl, // Set the URL of the custom icon image          
      //    //url: this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl,red), // Set the URL of the custom icon image
      //    //url: imageIcon,
      //    //url: svgUrl,//svgMarker,
      //    url: imageContent,
      //    scaledSize: new google.maps.Size(widthImg, heightImg), // Set the size of the icon image
      //    //scaledSize: new google.maps.Size(this.markerPositions[i].widthImg, this.markerPositions[i].heightImg), // Set the size of the icon image
      //    //anchor: new google.maps.Point(5, 15)
      //  },
      //  //icon: imageContent,
      //  label: labelOptions, // Set label options based on condition
      //  zIndex: this.markerPositions[i].iconZIndex, // Set zIndex to bring the marker to the front
      //});
      // console.log('--image--')
      //console.log(this.markerPositions[i].iconurl);

      ////////////////////////////////////////////////////////////////////////////////  #region ADVANCEDMARKER PLOTTING
      /////////// this is for default map loading with static pin images
      //////const iconImage = document.createElement("img");
      //////iconImage.src = this.markerPositions[i].iconurl;
      //////iconImage.width = this.markerPositions[i].widthImg;
      //////iconImage.height = this.markerPositions[i].heightImg;


      //////let imageContent = this.markerPositions[i].iconurl;
      //////if (this.markerPositions[i].iconurl.includes('d_map_xpin_letter')) {
      //////  imageContent = this.GeneratePinMarker(this.markerPositions[i].iconurl, 'Pin');
      //////}
      //////else if (this.markerPositions[i].iconurl.includes('d_bubble_texts_big')) {
      //////  imageContent = this.GeneratePinMarker(this.markerPositions[i].iconurl, 'Bubble');
      //////}
      //////else
      //////  imageContent = iconImage; ///default pin when predefined config is OFF


      //////const marker = new google.maps.marker.AdvancedMarkerElement({
      //////  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
      //////  map: this.map,// Set the map on which to display the marker

      //////  //content: beachFlagImg, ///external website image
      //////  //content: pinSvg, /////bubble with svg image
      //////  //content: bubbleImage,

      //////  //content: iconImage, ////////// this is for default map loading with static pin images  ///the working one properly for default pins with predefined config OFF        
      //////  //content: pinBackground.element, ////plain pin marker with background color changeable
      //////  //content: htmlCSSTag, ////square bubble with html css
      //////  content: imageContent,

      //////});

      ////////////////////////////////////////////////////////                                  #endregion ADVANCEDMARKER PLOTTING

      ////info window
      //const infoWindow = new google.maps.InfoWindow({
      //  content: this.infowindowArray[i]
      //});

      //// to click event to open info window
      //google.maps.event.addListener(marker, 'click', () => {        
      //  infoWindow.open(this.map, marker);
      //});
      this.gMapMarkerCollection.push(marker); //// it will be used in region button toggle to hide and show marker pin


      //////////////////// if marker is not clicked but only zoomed then by default restore to last marker position along with previous left zoom
      if (i == this.markerPositions.length - 1) {
        //this.isLoading = false;
        //debugger;
        //////////this.preDefinedConfigParam.restoreZoom = 10;///this.map.getZoom(); elumalai
        //this.preDefinedConfigParam.restoreLat = this.markerPositions[i].lat_num;
        //this.preDefinedConfigParam.restoreLng = this.markerPositions[i].lng_num;
        //this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
        //this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);
      }
      //////infowindow 
      google.maps.event.addListener(marker, 'click', () => {
        ////alert(this.map.getZoom());
        ////////////// below code is used to restore zoom level and lat/lng .
        this.preDefinedConfigParam.restoreZoom = this.map.getZoom();
        console.log(this.markerPositions[i]);
        this.preDefinedConfigParam.restoreLat = this.markerPositions[i].lat_num;
        this.preDefinedConfigParam.restoreLng = this.markerPositions[i].lng_num;
        this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
        //debugger;
        this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);

        ///close infowindow if already opened
        if (this.infoWindow) {
          this.infoWindow.close();
        }

        /// to get adddress based on latlng
        const latlng = { lat: 37.7749, lng: -122.4194 };
        this.geocode(new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num)).then(place => {
          this.currentPinLocation = place.formatted_address;
          //this.infowindowArray[i].replace('Loading...', this.currentPinLocation)
          //let pinInfo = this.infowindowArray[i].split('@')[1].replace('Loading...', this.currentPinLocation)
          //this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml(pinInfo);
          //this.previous.open();
          //this.previous["isOpen"] = true;//susheel

          this.isLoading = false;

        })
          .catch(err => {
            console.log(err);
            this.isLoading = false;
            this.EmptyBindGMap();
          });

        /////assign content to infowindow
        this.infoWindow = new google.maps.InfoWindow({
          content: this.infowindowArray[i].replace('Loading...', this.currentPinLocation).split('@')[1]
        });


        ///open infowindow
        this.infoWindow.open(this.map, marker);


        /////to call button click event inside infowindow popup
        google.maps.event.addListener(this.infoWindow, 'domready', () => {
          //now my elements are ready for dom manipulation

          /////to call bluetooth
          if (document.getElementById("bluetooth") != null) {
            document.getElementById("bluetooth").addEventListener("click", () => {
              this.OpenBTFXODialog();
            });
          }

          ///// to call OpenStatusDialog(" + this.pinMarker.itemID + "," + this.pinMarker.resultType + ")
          if (document.getElementById("OpenStatusDialog") != null) {
            document.getElementById("OpenStatusDialog").addEventListener("click", () => {
              //debugger;
              let value = (<HTMLInputElement>document.getElementById("OpenStatusDialog")).value;
              this.OpenStatusDialog(value.split(',')[0], value.split(',')[1]);
            });
          }

          /////to call OpenBasicDialog
          if (document.getElementById("OpenBasicDialog") != null) {
            document.getElementById("OpenBasicDialog").addEventListener("click", () => {
              //debugger;
              let value = (<HTMLInputElement>document.getElementById("OpenBasicDialog")).value;
              this.OpenBasicDialog(value.split(',')[0], value.split(',')[1]);
            });
          }

        });


      });//endinfowindow

      //// Add click event listener to the Advanced Marker
      //google.maps.marker.AdvancedMarkerElement.addListener('click', function () {
      //  // Trigger spiderification when the marker is clicked
      //  oms.spiderfy([marker]); // Assuming 'oms' is your OverlappingMarkerSpiderfier instance
      //});
      //debugger
      oms.addMarker(marker);//spiderfy
      oms.keepSpiderfied = true;

      // add the markers to the spiderfier
      //oms.addListener('click', function (marker) {
      //  oms.unspiderfy(); // unspiderfy the markers
      //});



    }//endforloop

    ///to retain toggle region funtion
    debugger;

    ////this func is called when mainfilter has map region configured in it.
    if (this.mainFilterMapRegionName != "") {
      await this.GetMainFilterMapRegion();
      debugger;
      //this.toggleMapRegion = false;///to show only pins iside region
      //this.ToggleMapRegion();
    }


    //this.toggleMapRegion = true;
    if (this.toggleMapRegion) {
      //this.toggleMapRegion = false;
      this.ToggleMapRegion();
    }
    ////alert(2);

    ///////// Maintain spiderfy on every zoom untill last max zoom
    if (this.map) {
      let currentZoom = this.map.getZoom();

      // add an event listener to the map to detect zoom end
      this.map.addListener('zoom_changed', function () {
        //google.maps.event.addListenerOnce(this.map, 'zoom_changed', function () {
        if (this.map) {
          let zoomLevel = this.map.getZoom();
          console.log("current zoom value =" + zoomLevel);
          // only unspiderfy markers after the user has fully zoomed in
          if (zoomLevel > currentZoom) {
            oms.unspiderfy();
            currentZoom = zoomLevel;
          }
        }
      });
    }

    //debugger;
    if (this.routeLatLng.length > 0) {
      ////alert('line');
      //debugger;
      this.DrawMapRoute_JSMap();
    }

    ////// redraw region paths on refresh  click
    //this.getListReg();

    /////to retain toggle region funtion
    //debugger;
    //this.toggleMapRegion = true;
    //this.ToggleMapRegion();

    // this.isLoading = false;
    //this.DrawMapRoute_JSMap_Test();////comment this line of code always , it is for testing pupose only
  }

  ///////below code is pin marker plotter by Advaned marker
  JsMapInitilization() {

    //this.lat = this.markerPositions[0].lat_num;
    //this.lng = this.markerPositions[0].lng_num;

    console.log('zoom');
    console.log(this.zoom);
    ///// to initialize the map and center it at load
    this.map = new google.maps.Map(document.getElementById('map'), {
      //center: { lat: 20.593684, lng: 78.96288 }, /// India
      center: { lat: this.lat, lng: this.lng }, //{ lat: 40.4230, lng: -98.7372 }, /// USA
      zoom: this.zoom, ///4,
      minZoom: 3,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: this.GoogleMapID   //'DEMO_MAP_ID' // Map ID is required for advanced markers.
    });


    //// added overlay to avoid following issue "Cannot read properties of undefined (reading 'fromLatLngToDivPixel')" is related to the google.maps.OverlayView
    ////and is caused when attempting to access the map's overlay view before it is fully initialized.
    //this.overlay = new google.maps.OverlayView();
    //this.overlay.setMap(this.map);

    this.addZoomChangeListener();
    //// initialize spiderfy
    const oms = new OverlappingMarkerSpiderfier(this.map, this.optionsOMS);
    //debugger;
    ////alert(1);

    /////////////////////////////////////////////////////////////   START ADVANCED MARKER EXAMPLE
    //const pinImage = new google.maps.marker.PinElement({
    //  background: 'blue',
    //  borderColor: 'yellow',
    //  glyph: 'A', // text inside pin
    //  glyphColor: 'yellow',///color of text
    //  scaledSize: new google.maps.Size(32, 32),
    //});
    //const beachFlagImg = document.createElement('img');
    //beachFlagImg.src = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'; ///this is working
    ////beachFlagImg.src =  './assets/images/Marks/vectorpin.avif'; ///this is working
    ////beachFlagImg.src = 'url(' + pinImage + ')';
    ////beachFlagImg.style.backgroundColor = "red";    
    //beachFlagImg.style.width = "30px";
    //beachFlagImg.style.height = "30px";
    //beachFlagImg.style.color = "blue";



    //// working pin with text Advacned Marker example

    //const pinBackground = new google.maps.marker.PinElement({
    //  background: 'blue',
    //  borderColor: 'yellow',
    //  glyph: 'A', // text inside pin
    //  glyphColor: 'yellow',///color of text 
    //});


    // create a stylesheet to be used by the marker
    ////const stylesheet = document.createElement('style');
    ////const bgColor = 'yellow';
    ////const fontColor = 'black';
    //////stylesheet.textContent = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 40px;  background: ' + bgColor + ';  border-radius: 10px;  padding: 10px;  text-align: center;  color: ' + fontColor + ';}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 10px solid ' + bgColor + ';  border-right: 10px solid transparent;  border-top: 10px solid ' + bgColor + ';  border-bottom: 20px solid transparent;  left: 5px;  bottom: -24px;}';
    ////stylesheet.textContent = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 50px;  background: ' + bgColor + ';  border-radius: 5px;  padding: 4px;height:20px;  text-align: center;  color: ' + fontColor + ';padding-top:8px;}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid ' + bgColor + ';  border-right: 5px solid transparent;  border-top: 5px solid ' + bgColor + ';  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;}';
    ////document.head.appendChild(stylesheet);
    ////const htmlCSSTag = document.createElement("div");
    ////htmlCSSTag.className = "bubble bubble-bottom-left";
    ////htmlCSSTag.textContent = "PASS";


    ////////////
    // A marker with a custom inline SVG.
    // const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"><rect width="56" height="56" rx="28" fill="#7837FF"></rect><path d="M46.0675 22.1319L44.0601 22.7843" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.9402 33.2201L9.93262 33.8723" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M27.9999 47.0046V44.8933" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M27.9999 9V11.1113" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M39.1583 43.3597L37.9186 41.6532" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.8419 12.6442L18.0816 14.3506" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.93262 22.1319L11.9402 22.7843" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M46.0676 33.8724L44.0601 33.2201" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M39.1583 12.6442L37.9186 14.3506" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.8419 43.3597L18.0816 41.6532" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M28 39L26.8725 37.9904C24.9292 36.226 23.325 34.7026 22.06 33.4202C20.795 32.1378 19.7867 30.9918 19.035 29.9823C18.2833 28.9727 17.7562 28.0587 17.4537 27.2401C17.1512 26.4216 17 25.5939 17 24.7572C17 23.1201 17.5546 21.7513 18.6638 20.6508C19.7729 19.5502 21.1433 19 22.775 19C23.82 19 24.7871 19.2456 25.6762 19.7367C26.5654 20.2278 27.34 20.9372 28 21.8649C28.77 20.8827 29.5858 20.1596 30.4475 19.6958C31.3092 19.2319 32.235 19 33.225 19C34.8567 19 36.2271 19.5502 37.3362 20.6508C38.4454 21.7513 39 23.1201 39 24.7572C39 25.5939 38.8488 26.4216 38.5463 27.2401C38.2438 28.0587 37.7167 28.9727 36.965 29.9823C36.2133 30.9918 35.205 32.1378 33.94 33.4202C32.675 34.7026 31.0708 36.226 29.1275 37.9904L28 39Z" fill="#FF7878"></path></svg>';
    ////const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 32 32"><path d="M13 32a1 1 0 0 1-1-1v-5h-1A11 11 0 0 1 0 15v-4A11 11 0 0 1 11 0h10a11 11 0 0 1 11 11v4a11 11 0 0 1-11 11h-1.59l-5.71 5.71a1 1 0 0 1-.7.29zM11 2a9 9 0 0 0-9 9v4a9 9 0 0 0 9 9h2a1 1 0 0 1 1 1v3.59l4.29-4.29A1 1 0 0 1 19 24h2a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9z" data-name="37-Speech Bubble"/></svg>';
    ////const parser = new DOMParser();
    ////const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

    /////////////////////////////////////////////////////////////                 END ADVANCED MARKER EXAMPLE




    let len = this.markerPositions.length;

    let iconText = "";
    let iconBGColor = "";
    let iconFontColor = "";
    let labelOptions = null;// Initialize label options as null
    let widthImg = 32;
    let heightImg = 32;
    // Create one global InfoWindow
    this.infoWindow = new google.maps.InfoWindow();
    //console.log(this.markerPositions);
    //var bounds = new google.maps.LatLngBounds();
    for (let i = 0; i < this.markerPositions.length; i++) {
      iconText = "";
      iconBGColor = "";
      iconFontColor = "";
      labelOptions = null;

      //console.log(this.markerPositions);
      ////let imageContent = this.markerPositions[i].iconurl;
      ////if (this.markerPositions[i].iconurl.includes('d_map_xpin_letter')) {
      ////  /// https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin||00ff00|FFFFFF
      ////  widthImg = 32;
      ////  heightImg = 32;
      ////  iconText = imageContent.split('|')[1] == '' ? "" : imageContent.split('|')[1];
      ////  iconBGColor = "#" + imageContent.split('|')[2];
      ////  iconFontColor = "#" + imageContent.split('|')[3];
      ////  if (iconText != "") {
      ////    labelOptions = {
      ////      text: iconText,
      ////      color: iconFontColor // Set label color
      ////    };
      ////  }
      ////  imageContent = this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl, iconBGColor);
      ////}
      ////else if (this.markerPositions[i].iconurl.includes('d_bubble_texts_big')) {
      ////  //////  https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|00ff00|404040|TCP
      ////  //////  https://chart.googleapis.com/chart?chst=d_bubble_texts_big&chld=bb|0000ff|ffffff|DROP|0

      ////  widthImg = 50;
      ////  heightImg = 30;
      ////  iconText = imageContent.split('|')[3] == '' ? "" : imageContent.split('|')[3];
      ////  iconBGColor = "#" + imageContent.split('|')[1];
      ////  iconFontColor = "#" + imageContent.split('|')[2];
      ////  if (iconText != "") {
      ////    labelOptions = {
      ////      text: iconText,
      ////      color: iconFontColor // Set label color
      ////    };
      ////  }
      ////  imageContent = this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl, iconBGColor);
      ////}
      ////else
      ////  imageContent = this.markerPositions[i].iconurl; ///default pin when predefined config is OFF



      ////////////////// PREVIOUS WORKED  MARKER BUT CURRENTLY IT IS DEPRECEATED BY GOOGLEMAP SO USING ADVANCEDMARKERELEMENT
      //const marker = new google.maps.Marker({
      //  //position: this.markerPositions[i],
      //  position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
      //  map: this.map,// Set the map on which to display the marker
      //  icon: {
      //    //url: this.markerPositions[i].iconurl, // Set the URL of the custom icon image          
      //    //url: this.GeneratePinMarker_Custom(this.markerPositions[i].iconurl,red), // Set the URL of the custom icon image
      //    //url: imageIcon,
      //    //url: svgUrl,//svgMarker,
      //    url: imageContent,
      //    scaledSize: new google.maps.Size(widthImg, heightImg), // Set the size of the icon image
      //    //scaledSize: new google.maps.Size(this.markerPositions[i].widthImg, this.markerPositions[i].heightImg), // Set the size of the icon image
      //    anchor: new google.maps.Point(5, 15)
      //  },
      //  label: labelOptions // Set label options based on condition

      //});
      // console.log('--image--')
      //console.log(this.markerPositions[i].iconurl);



      ////////////////////////////////////////////////////////////////////////////////  #region ADVANCEDMARKER PLOTTING
      /////////// this is for default map loading with static pin images
      const iconImage = document.createElement("img");
      iconImage.src = this.markerPositions[i].iconurl;
      iconImage.width = this.markerPositions[i].widthImg;
      iconImage.height = this.markerPositions[i].heightImg;

      let pinType = 'pin';
      let imageContent = this.markerPositions[i].iconurl;
      if (this.markerPositions[i].iconurl.includes('d_map_xpin_letter')) {
        imageContent = this.GeneratePinMarker(this.markerPositions[i].iconurl, 'Pin');
        pinType = 'pin';
        //ballonTypeIndex = this.markerPositions[i].iconurl.split('|')[1] == '' ? "" : this.markerPositions[i].iconurl.split('|')[1];

      }
      else if (this.markerPositions[i].iconurl.includes('d_bubble_texts_big')) {
        imageContent = this.GeneratePinMarker(this.markerPositions[i].iconurl, 'Bubble');
        pinType = 'bubble';
      }
      else
        imageContent = iconImage; ///default pin when predefined config is OFF

      /////position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
      const marker = new google.maps.marker.AdvancedMarkerElement({
        //position: pinType == 'pin' ? new google.maps.LatLng(this.markerPositions[i].lat_num + 0.00003, this.markerPositions[i].lng_num) : new google.maps.LatLng(this.markerPositions[i].lat_num - 0.00003, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
        position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num),
        map: this.map,// Set the map on which to display the marker

        //content: beachFlagImg, ///external website image
        //content: pinSvg, /////bubble with svg image
        //content: bubbleImage,

        //content: iconImage, ////////// this is for default map loading with static pin images  ///the working one properly for default pins with predefined config OFF        
        //content: pinBackground.element, ////plain pin marker with background color changeable
        //content: htmlCSSTag, ////square bubble with html css
        content: imageContent,
        zIndex: this.markerPositions[i].iconZIndex,
        //zIndex: (i % 2) == 0 ? google.maps.Marker.MAX_ZINDEX + 1 : -1,
      });


      ////////////////////////////////////////////////////////                                  #endregion ADVANCEDMARKER PLOTTING

      ////info window
      //const infoWindow = new google.maps.InfoWindow({
      //  content: this.infowindowArray[i]
      //});

      //// to click event to open info window
      //google.maps.event.addListener(marker, 'click', () => {        
      //  infoWindow.open(this.map, marker);
      //});

      //this.gMapMarkerCollection.push(marker); //// it will be used in region button toggle to hide and show marker pin ADVANCEMARKER
      this.gMapAdvanceMarkerCollection.push(marker);

      //////////////////// if marker is not clicked but only zoomed then by default restore to last marker position along with previous left zoom
      if (i == this.markerPositions.length - 1) {
        this.isLoading = false;
        //debugger;
        //////////this.preDefinedConfigParam.restoreZoom = 10;///this.map.getZoom(); elumalai
        //this.preDefinedConfigParam.restoreLat = this.markerPositions[i].lat_num;
        //this.preDefinedConfigParam.restoreLng = this.markerPositions[i].lng_num;
        //this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
        //this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);
      }
      //////infowindow
      if (this.infowWindowFlag) {
        google.maps.event.addListener(marker, 'click', () => {
          ////alert(this.map.getZoom());
          ////////////// below code is used to restore zoom level and lat/lng .
          this.preDefinedConfigParam.restoreZoom = this.map.getZoom();
          this.preDefinedConfigParam.restoreLat = this.markerPositions[i].lat_num;
          this.preDefinedConfigParam.restoreLng = this.markerPositions[i].lng_num;
          this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
          //debugger;
          this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);

          ///close infowindow if already opened
          if (this.infoWindow) {
            this.infoWindow.close();
          }

          /// to get adddress based on latlng
          const latlng = { lat: 37.7749, lng: -122.4194 };
          this.geocode(new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num)).then(place => {
            this.currentPinLocation = place.formatted_address;
            //this.infowindowArray[i].replace('Loading...', this.currentPinLocation)
            //let pinInfo = this.infowindowArray[i].split('@')[1].replace('Loading...', this.currentPinLocation)
            //this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml(pinInfo);
            //this.previous.open();
            //this.previous["isOpen"] = true;//susheel

            this.isLoading = false;

          })
            .catch(err => {
              console.log(err);
              this.isLoading = false;
              this.EmptyBindGMap();
            });

          ///assign content to infowindow elumalai
          //this.infoWindow = new google.maps.InfoWindow({
          //  content: this.infowindowArray[i].replace('Loading...', this.currentPinLocation).split('@')[1]
          //});

          /////create single instance and set data
          this.infoWindow.setContent(
            this.infowindowArray[i].replace("Loading...", this.currentPinLocation).split("@")[1]
          );

          /////open infowindow elumalai
          this.infoWindow.open(this.map, marker);


          /////to call button click event inside infowindow popup
          google.maps.event.addListener(this.infoWindow, 'domready', () => {
            //now my elements are ready for dom manipulation

            /////to call bluetooth
            if (document.getElementById("bluetooth") != null) {
              document.getElementById("bluetooth").addEventListener("click", () => {
                this.OpenBTFXODialog();
              });
            }

            ///// to call OpenStatusDialog(" + this.pinMarker.itemID + "," + this.pinMarker.resultType + ")
            if (document.getElementById("OpenStatusDialog") != null) {
              document.getElementById("OpenStatusDialog").addEventListener("click", () => {
                //debugger;
                let value = (<HTMLInputElement>document.getElementById("OpenStatusDialog")).value;
                this.OpenStatusDialog(value.split(',')[0], value.split(',')[1]);
              });
            }

            /////to call OpenBasicDialog
            if (document.getElementById("OpenBasicDialog") != null) {
              document.getElementById("OpenBasicDialog").addEventListener("click", () => {
                //debugger;
                let value = (<HTMLInputElement>document.getElementById("OpenBasicDialog")).value;
                this.OpenBasicDialog(value.split(',')[0], value.split(',')[1]);
              });
            }

          });


        });//endinfowindow
      }///// flag set for infowindow
      //// Add click event listener to the Advanced Marker
      //google.maps.marker.AdvancedMarkerElement.addListener('click', function () {
      //  // Trigger spiderification when the marker is clicked
      //  oms.spiderfy([marker]); // Assuming 'oms' is your OverlappingMarkerSpiderfier instance
      //});

      oms.addMarker(marker);//spiderfy
      oms.keepSpiderfied = true;

      // Add a marker clusterer to manage the markers.
      //new MarkerClusterer ({ this.map,marker });
      //new MarkerClusterer({
      //  map: this.map,
      //  markers: [marker] // Must be an array
      //});

      //// ✅ Use MarkerClustererPlus (compatible with Angular 8)
      //this.markerCluster = new MarkerClusterer(this.map, marker, {
      //  imagePath: 'assets/images/Marks/Apps/m',
      //});

      // add the markers to the spiderfier
      //oms.addListener('click', function (marker) {
      //  oms.unspiderfy(); // unspiderfy the markers
      //});

      // bounds.extend(new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num));
      //bounds.extend(marker.position);

    }//endforloop

    // this.map.fitBounds(bounds);



    ///////// Maintain spiderfy on every zoom untill last max zoom
    if (this.map) {
      let currentZoom = this.map.getZoom();

      // add an event listener to the map to detect zoom end
      this.map.addListener('zoom_changed', function () {
        //google.maps.event.addListenerOnce(this.map, 'zoom_changed', function () {
        if (this.map) {
          let zoomLevel = this.map.getZoom();
          console.log("current zoom value =" + zoomLevel);
          // only unspiderfy markers after the user has fully zoomed in
          if (zoomLevel > currentZoom) {
            oms.unspiderfy();
            currentZoom = zoomLevel;
          }
        }
      });

      /////Attach the debounced updateMarkers function to the bounds_changed event = bounds_changed it will call in every movement on map zoom,panning.
      //this.map.addListener('zoom_changed', this.debounce(() => {
      //  if (!this.initialLoad) {
      //    this.updateMarkers_Map(this.map, this.markerPositions);
      //    this.initialLoad = true;
      //  } else {
      //    this.initialLoad = false;
      //  }
      //}, 500));
      //debugger;
    }

    //debugger;
    if (this.routeLatLng.length > 0) {
      ////alert('line');
      //debugger;

      this.DrawMapRoute_JSMap();
    }
    //alert('advance');
    //////////////  Grouping by 10-degree Latitude Ranges for Fit bounds /// zooms to location where maximum pins are points nearby
    //this.GetGroupedLocation(); /// uncomment if need to zoom to particular position 



    ////// redraw region paths on refresh  click
    //this.getListReg();
    //this.DrawMapRoute_JSMap_Test();////comment this line of code always , it is for testing pupose only

  }

  /////JsMapInitilization_Optimze() below code is for testing performance improvement to avoid map stuck when large no of pins plotted
  JsMapInitilization_Optimize() {
    ///// below code is for testing performance improvement to avoid map stuck when large no of pins plotted
    //alert('JsMapInitilization_Optimize');
    //this.zoom = 12;

    ///// to initialize the map and center it at load
    this.map = new google.maps.Map(document.getElementById('map'), {
      //center: { lat: 20.593684, lng: 78.96288 }, /// India
      center: { lat: this.lat, lng: this.lng }, //{ lat: 40.4230, lng: -98.7372 }, /// USA
      zoom: this.zoom, ///4,
      minZoom: 3,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: this.GoogleMapID   //'DEMO_MAP_ID' // Map ID is required for advanced markers.
    });

    this.LoadingText = "loading ..."
    this.isLoading = true;
    // Call the function to start plotting markers
    this.plotMarkers().then(() => {
      console.log('All markers have been plotted');
      ////alert('done');
      this.LoadingText = "";
      //this.isLoading = false;
    }).catch(err => {
      console.log(err);
      this.isLoading = false;
      this.EmptyBindGMap();
    });;


  }

  ///////////////////// async function to avoid map getting stuck while plotting pins
  async plotMarkers() {
    let len = this.markerPositions.length;
    let iconText = "";
    let iconBGColor = "";
    let iconFontColor = "";
    let labelOptions = null;// Initialize label options as null
    let iconOptions = null;// Initialize label options as null
    let widthImg = 32;
    let heightImg = 32;

    console.log('plotMarkers()');
    this.addZoomChangeListener();
    //// initialize spiderfy
    const oms = new OverlappingMarkerSpiderfier(this.map, this.optionsOMS);

    //console.log('total record');
    //console.log(this.markerPositions.length);
    //console.log('total record');

    let index = 0;
    const chunkSize = 500; // Adjust this value based on performance needs /// A smaller size reduces the risk of blocking but increases the total plotting time. A larger size may improve plotting speed but risks blocking the main thread.
    this.isLoading = true;

    // Create one global InfoWindow
    this.infoWindow = new google.maps.InfoWindow();

    const plotNextChunk = () => {
      const end = Math.min(index + chunkSize, this.markerPositions.length);

      for (let i = index; i < end; i++) {
        //const chunk = this.markerPositions.slice(i, i + chunkSize);

        iconText = "";
        iconBGColor = "";
        iconFontColor = "";
        labelOptions = null;

        ////////////////////////////////////////////////////////////////////////////////  #region ADVANCEDMARKER PLOTTING
        /////////// this is for default map loading with static pin images
        const iconImage = document.createElement("img");
        iconImage.src = this.markerPositions[i].iconurl;
        iconImage.width = this.markerPositions[i].widthImg;
        iconImage.height = this.markerPositions[i].heightImg;

        let pinType = 'pin';
        let imageContent = this.markerPositions[i].iconurl;
        if (this.markerPositions[i].iconurl.includes('d_map_xpin_letter')) {
          imageContent = this.GeneratePinMarker(this.markerPositions[i].iconurl, 'Pin');
          pinType = 'pin';
          //ballonTypeIndex = this.markerPositions[i].iconurl.split('|')[1] == '' ? "" : this.markerPositions[i].iconurl.split('|')[1];

        }
        else if (this.markerPositions[i].iconurl.includes('d_bubble_texts_big')) {
          imageContent = this.GeneratePinMarker(this.markerPositions[i].iconurl, 'Bubble');
          pinType = 'bubble';
        }
        else
          imageContent = iconImage; ///default pin when predefined config is OFF


        const marker = new google.maps.marker.AdvancedMarkerElement({
          //position: pinType == 'pin' ? new google.maps.LatLng(this.markerPositions[i].lat_num + 0.00003, this.markerPositions[i].lng_num) : new google.maps.LatLng(this.markerPositions[i].lat_num - 0.00003, this.markerPositions[i].lng_num), //this.markerPositions[i],// Set the marker position
          position: new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num),
          map: this.map,// Set the map on which to display the marker

          //content: beachFlagImg, ///external website image
          //content: pinSvg, /////bubble with svg image
          //content: bubbleImage,

          //content: iconImage, ////////// this is for default map loading with static pin images  ///the working one properly for default pins with predefined config OFF        
          //content: pinBackground.element, ////plain pin marker with background color changeable
          //content: htmlCSSTag, ////square bubble with html css
          content: imageContent,
          zIndex: this.markerPositions[i].iconZIndex,
          //zIndex: (i % 2) == 0 ? google.maps.Marker.MAX_ZINDEX + 1 : -1,
        });

        this.gMapAdvanceMarkerCollection.push(marker);

        ////////////////////////////////////////////////////////                                  #endregion ADVANCEDMARKER PLOTTING

        ////info window
        //const infoWindow = new google.maps.InfoWindow({
        //  content: this.infowindowArray[i]
        //});

        //// to click event to open info window
        //google.maps.event.addListener(marker, 'click', () => {        
        //  infoWindow.open(this.map, marker);
        //});

        //////////////////// if marker is not clicked but only zoomed then by default restore to last marker position along with previous left zoom
        if (i == this.markerPositions.length - 1) {
          //debugger;
          //////////this.preDefinedConfigParam.restoreZoom = 10;///this.map.getZoom(); elumalai
          //this.preDefinedConfigParam.restoreLat = this.markerPositions[i].lat_num;
          //this.preDefinedConfigParam.restoreLng = this.markerPositions[i].lng_num;
          //this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
          //this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);
        }
        //////infowindow
        if (this.infowWindowFlag) {
          google.maps.event.addListener(marker, 'click', () => {
            ////alert(this.map.getZoom());
            ////////////// below code is used to restore zoom level and lat/lng .
            this.preDefinedConfigParam.restoreZoom = this.map.getZoom();
            this.preDefinedConfigParam.restoreLat = this.markerPositions[i].lat_num;
            this.preDefinedConfigParam.restoreLng = this.markerPositions[i].lng_num;
            this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
            //debugger;
            this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);

            ///close infowindow if already opened
            if (this.infoWindow) {
              this.infoWindow.close();
            }

            /// to get adddress based on latlng
            const latlng = { lat: 37.7749, lng: -122.4194 };
            this.geocode(new google.maps.LatLng(this.markerPositions[i].lat_num, this.markerPositions[i].lng_num)).then(place => {
              this.currentPinLocation = place.formatted_address;
              //this.infowindowArray[i].replace('Loading...', this.currentPinLocation)
              //let pinInfo = this.infowindowArray[i].split('@')[1].replace('Loading...', this.currentPinLocation)
              //this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml(pinInfo);
              //this.previous.open();
              //this.previous["isOpen"] = true;//susheel

              // this.isLoading = false;

            })
              .catch(err => {
                console.log(err);
                this.isLoading = false;
                this.EmptyBindGMap();
              });

            /////assign content to infowindow
            //this.infoWindow = new google.maps.InfoWindow({
            //  content: this.infowindowArray[i].replace('Loading...', this.currentPinLocation).split('@')[1]
            //});
            /////create single instance and set data
            this.infoWindow = this.infoWindow.setContent({
              content: this.infowindowArray[i].replace('Loading...', this.currentPinLocation).split('@')[1]
            });


            ///open infowindow
            this.infoWindow.open(this.map, marker);


            /////to call button click event inside infowindow popup
            google.maps.event.addListener(this.infoWindow, 'domready', () => {
              //now my elements are ready for dom manipulation

              /////to call bluetooth
              if (document.getElementById("bluetooth") != null) {
                document.getElementById("bluetooth").addEventListener("click", () => {
                  this.OpenBTFXODialog();
                });
              }

              ///// to call OpenStatusDialog(" + this.pinMarker.itemID + "," + this.pinMarker.resultType + ")
              if (document.getElementById("OpenStatusDialog") != null) {
                document.getElementById("OpenStatusDialog").addEventListener("click", () => {
                  //debugger;
                  let value = (<HTMLInputElement>document.getElementById("OpenStatusDialog")).value;
                  this.OpenStatusDialog(value.split(',')[0], value.split(',')[1]);
                });
              }

              /////to call OpenBasicDialog
              if (document.getElementById("OpenBasicDialog") != null) {
                document.getElementById("OpenBasicDialog").addEventListener("click", () => {
                  //debugger;
                  let value = (<HTMLInputElement>document.getElementById("OpenBasicDialog")).value;
                  this.OpenBasicDialog(value.split(',')[0], value.split(',')[1]);
                });
              }

            });


          });//endinfowindow
        }///infowwindow flag
        //// Add click event listener to the Advanced Marker
        //google.maps.marker.AdvancedMarkerElement.addListener('click', function () {
        //  // Trigger spiderification when the marker is clicked
        //  oms.spiderfy([marker]); // Assuming 'oms' is your OverlappingMarkerSpiderfier instance
        //});

        oms.addMarker(marker);//spiderfy
        oms.keepSpiderfied = true;

        // add the markers to the spiderfier
        //oms.addListener('click', function (marker) {
        //  oms.unspiderfy(); // unspiderfy the markers
        //});

      }

      index = end;
      if (index < this.markerPositions.length) {
        requestAnimationFrame(plotNextChunk);
      }
      else
        this.isLoading = false;
    };
    requestAnimationFrame(plotNextChunk);

    ///////// Maintain spiderfy on every zoom untill last max zoom
    if (this.map) {
      let currentZoom = this.map.getZoom();

      // add an event listener to the map to detect zoom end
      this.map.addListener('zoom_changed', function () {
        //google.maps.event.addListenerOnce(this.map, 'zoom_changed', function () {
        if (this.map) {
          let zoomLevel = this.map.getZoom();
          console.log("current zoom value =" + zoomLevel);
          // only unspiderfy markers after the user has fully zoomed in
          if (zoomLevel > currentZoom) {
            oms.unspiderfy();
            currentZoom = zoomLevel;
          }
        }
      });

      //// Attach the debounced updateMarkers function to the bounds_changed event = bounds_changed it will call in every movement on map zoom,panning.
      //this.map.addListener('zoom_changed', this.debounce(() => {
      //  if (!this.initialLoad) {
      //    this.updateMarkers_Map(this.map, this.markerPositions);
      //    this.initialLoad = true;
      //  } else {
      //    this.initialLoad = false;
      //  }
      //}, 500));
    }

    //debugger;
    if (this.routeLatLng.length > 0) {
      ////alert('line');
      //debugger;
      this.DrawMapRoute_JSMap();
    }

    //////////////  Grouping by 10-degree Latitude Ranges for Fit bounds
    //this.GetGroupedLocation();  ///uncomment if want to zoom to particular location where maximum no of pins are plotted

  }

  GetGroupedLocation() {
    let groupedLocations = [];
    // Group locations by latitude range

    //const groupedLocations = this.markerPositions.reduce((groups, location) => {    
    groupedLocations = this.markerPositions.reduce((groups, location) => {

      if (!location.popUpRsltType.includes('app')) {
        const groupKey = this.GetGroupKey(location.lat_num);
        if (!groups[groupKey]) {
          groups[groupKey] = [];
        }
        groups[groupKey].push(location);
        //return groups;
      }
      return groups;
    }, {});

    //console.log(groupedLocations);

    let largestGroupKey = null;
    let largestGroupCount = 0;

    //////// BELOW CODE IS TO GET GROUP THAT HAS LARGE NO OF COUNT IN PARTICULAR LAT RANGE
    for (const [key, group] of Object.entries(groupedLocations)) {
      if (group.length > largestGroupCount) {
        largestGroupCount = group.length;
        largestGroupKey = key;
      }
    }

    //console.log('Grouped Locations:', groupedLocations);
    //console.log('Largest Group Key:', largestGroupKey);
    //console.log('Largest Group Count:', largestGroupCount);
    //console.log('Largest Group:', groupedLocations[largestGroupKey]);

    /// BELOW CODE IS TO SHOW ZOOM IN TO PARTICULAR BOUNS REGION WHERE MORE NO OF PINS ARE PLOTTED
    if (groupedLocations[largestGroupKey].length > 0) {
      var bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < groupedLocations[largestGroupKey].length; i++) {
        bounds.extend(new google.maps.LatLng(groupedLocations[largestGroupKey][i].lat_num, groupedLocations[largestGroupKey][i].lng_num));
      }
      this.map.fitBounds(bounds);

    }
  }

  // Function to determine the group key based on latitude
  GetGroupKey(lat) {
    //if (lat >= -32 && lat < -31) return 'Group 1';
    //if (lat >= -34 && lat < -32) return 'Group 2';
    //if (lat >= -36 && lat < -34) return 'Group 3';
    //return 'Others';

    const groupSize = 10;
    const start = Math.floor(lat / groupSize) * groupSize;
    const end = start + groupSize;
    return `${start} to ${end}`;

  }

  // Utility function to create a debounce wrapper
  debounce(func, delay) {
    console.log('debounce');
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  }

  updateMarkers_Map(map, markerList) {
    return;
    if (!map) {
      console.log('Map is not initialized.');
      return;
    }
    ////console.log('updatemarker');
    const bounds = map.getBounds();
    this.zoom = map.getZoom();
    //// Clear existing markers
    //this.markers.forEach(marker => marker.setMap(null));
    //this.markers = [];

    this.EmptyBindGMap();
    this.cd.detectChanges();
    this.markerPositions = [];
    //setTimeout(() => {
    //  //this.markers = this.markerCollection.filter(marker => newBounds.contains(new google.maps.LatLng(marker.lat, marker.lng)));
    //}, 1000);
    // setTimeout(() => { this.map.triggerResize(); }, 500)
    // let index = 0;
    // Add markers that are within the current bounds markerPositions
    this.markers.forEach(location => {
      if (bounds.contains(new google.maps.LatLng(location.lat, location.lng))) {
        // index++;        
        this.markerPositions.push(location);
        this.lat = Number(location.lat);
        this.lng = Number(location.lng);
      }

    });

    if (this.markerPositions.length > 5000)
      this.JsMapInitilization_Optimize();
    else
      this.JsMapInitilization();

  }

  addZoomChangeListener() {
    this.map.addListener('zoom_changed', () => {
      //this.ngZone.run(() => {
      if (this.map) {
        let center = this.map.getCenter();
        //console.log(center.lat() + ',' + center.lng())
        //////////////////// if marker is not clicked but only zoomed then by default restore to last marker position along with previous left zoom
        const zoomLevel = this.map.getZoom();
        this.preDefinedConfigParam.restoreZoom = zoomLevel;
        this.preDefinedConfigParam.restoreLat = center.lat();
        this.preDefinedConfigParam.restoreLng = center.lng();
        this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
        //debugger;
        this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);
      }
      //});
    });

    this.map.addListener('idle', () => {
      //this.ngZone.run(() => {
      if (this.map) {
        let center = this.map.getCenter();
        //console.log(center.lat() + ',' + center.lng())
        //////////////////// if marker is not clicked but only zoomed then by default restore to last marker position along with previous left zoom
        const zoomLevel = this.map.getZoom();
        this.preDefinedConfigParam.restoreZoom = zoomLevel;
        this.preDefinedConfigParam.restoreLat = center.lat();
        this.preDefinedConfigParam.restoreLng = center.lng();
        this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
        //debugger;
        this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);
      }
      //});
    });
  }

  ResetDispalyOptionsList() {
    this.DisplayResultList.forEach(item => item.Checked = true);
    this.AnalysisList.forEach(item => item.Checked = true);
    this.NetTestList.forEach(item => item.Checked = true);
    this.MobileInfoList.forEach(item => item.Checked = true);
    this.ErrorEventList.forEach(item => item.Checked = true);
    this.TypeList.forEach(item => item.Checked = false);
    this.ResultList.forEach(item => item.Checked = false);
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  LimitChangeEvent() {
    //console.log('limitChange')
    this.refreshSelections();
  }

  clearAllFiltersBool = false;
  clearAllFilters() {
    //console.log('clearAll')
    this.delFilterColName = 'clearAllFilters';
    //this.hasFilters = false;
    ////alert(11);
    this.refreshSelections();
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }

  ngOnDestroy() {
    // Clear out the old markers.
    this.markers = [];
    this.markerCollection = [];
    this.subscriptions.forEach(s => s.unsubscribe());
    //https://stackoverflow.com/questions/55263567/angular-6-adding-script-at-component-level-and-checking-if-it-exists
    //this.renderer2.removeChild(this.document.body, this.scriptMapJS);
    //this.renderer2.removeChild(this.document.body, this.scriptCallBack);

  }

  parentEvent() {
    //debugger;
    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
  }

  status1: boolean = false;
  status2: boolean = false;
  togglePanes(type) {
    this.leftPanel = true;
    if (type == 1) {
      this.status1 = !this.status1;
      this.status2 = false;
    }
    else if (type == 2) {
      this.status2 = !this.status2;
      this.status1 = false;
    }
  }

  //legendList: any
  SetPinLegnd(legendList: any) {
    //debugger;
    this.dynamicPinLegends = [];
    let legList = legendList.split('#');
    //console.log(legendList)
    for (let i = 1; i < legList.length; i++) {
      let item = legList[i].split('@');

      let imgPath = item[1].split('-')[1];
      let MarkerPinType = "Pin";
      let iconText = "";
      let iconBGColor = "";
      let iconFontColor = "";
      let dynamicBubbleClass: any;
      let dynamicBubbleClass2: any;


      if (imgPath.includes('d_map_xpin_letter')) {
        MarkerPinType = "Pin";
        iconText = imgPath.split('|')[1];
        iconBGColor = "#" + imgPath.split('|')[2];
        iconFontColor = "#" + imgPath.split('|')[3];
      }
      else if (imgPath.includes('d_bubble_texts_big')) {
        MarkerPinType = "Bubble";
        iconText = imgPath.split('|')[3];
        iconBGColor = "#" + imgPath.split('|')[1];
        iconFontColor = "#" + imgPath.split('|')[2];

        //dynamicBubbleClass1 = '.bubble { position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 50px;  background: ' + iconBGColor + ';  border-radius: 5px;  padding: 4px;height:20px;  text-align: center;  color: ' + iconFontColor + ';padding-top:8px;}.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid ' + iconBGColor + ';  border-right: 5px solid transparent;  border-top: 5px solid ' + iconBGColor + ';  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;}';
        //dynamicBubbleClass2 = '.bubble-bottom-left:before {  content: "";  width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid ' + iconBGColor + ';  border-right: 5px solid transparent;  border-top: 5px solid ' + iconBGColor + ';  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;}';
        //dynamicBubbleClass1 =  'position: relative;  font-family: sans-serif;  font-size: 12px;  line-height: 5px;  width: 50px;  background:red;  border-radius: 5px;  padding: 4px;height:20px;  text-align: center;  color: white;padding-top:8px;' ;
        //dynamicBubbleClass2 = 'width: 0px;  height: 0px;  position: absolute;  border-left: 5px solid red;  border-right: 5px solid transparent;  border-top: 5px solid red;  border-bottom: 20px solid transparent;  left: 0px;  bottom: -15px;' ;
        dynamicBubbleClass = "5px solid " + iconBGColor;
      }

      //console.log(item[5]);
      this.dynamicPinLegends.push(
        {
          queryCount: item[0].split('-')[1],
          imgSrc: item[1].split('-')[1],
          resultType: item[2].split('-')[1],
          thresholdType: item[3].indexOf('- -') != -1 ? item[3].split('- -')[1].split(',')[0].trim() : item[3].split('-')[1].split(',')[0].trim(),//susheel - pass fail test-fail
          pinType: item[4].split('-')[1],
          //condVal: item[5].indexOf(' -') != -1 ? item[5].split('-')[1] + '-' + item[5].split('-')[2] : item[5].split('-')[1],//susheel - check if filter value is -ve
          condVal: item[5].replace(/::true/gi, '').replace(/::false/gi, '').replace(/condVal-/gi, ''),//susheel
          noOfRows: item[6].split('-')[1],
          MarkerPinType: MarkerPinType,
          iconText: iconText == "" ? '' : (iconText.length > 5 ? iconText.substring(0, 6) + ".." : iconText),
          iconBGColor: iconBGColor,
          iconFontColor: iconFontColor,
          dynamicBubbleClass: dynamicBubbleClass,
          legendName: item[7].split('-')[1]
        }
      );
    }

    //console.log('no audio count');
    //console.log(this.NoAudioPolqa_OnePoinOne.length);
    //console.log(this.totalNoAudioScore);
    //if (this.totalNoAudioScore > 0) {
    //  this.dynamicPinLegends.push(
    //    {
    //      queryCount: this.totalNoAudioScore,
    //      imgSrc: 'NoAudioPolqaMark',
    //      resultType: 'POLQA',
    //      thresholdType: '( NO AUDIO )',
    //      pinType: '',
    //      condVal: 'POLQA MOS <= 1.1',//susheel
    //      noOfRows: this.totalNoAudioScore,
    //      MarkerPinType: 'NoAudioPolqaMark',
    //      iconText: 'X',
    //      iconBGColor: 'Red',
    //      iconFontColor: 'Black',
    //      dynamicBubbleClass: ''//
    //    }
    //  );
    //}

    //console.log(this.dynamicPinLegends)-susheel

    //this.dynamicPinLegends = [
    //  {
    //    queryCount:'100',
    //    imgSrc:'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin||00FF00|FFFFFF',
    //    resultType: 'LegAll',
    //    thresholdType : 'PASS',
    //    pinType: 'Threshold Type',
    //    condVal: 'Battery Level() >= 90 < font style = color: green > AND < /font></br > RSSI(dBm) <= 100',
    //    noOfRows:'0'
    //  }
    //];
    //console.log(this.dynamicPinLegends);
    // After updating legend.iconBGColor
    this.cd.detectChanges();
  }


  DynamicHtmlEvent() {
    //var body = "<img (click)="ShowMapLegendWin(0); " src="https://chart.googleapis.com/chart?chst=d_map_xpin_letter&amp;chld=pin||00FF00|FFFFFF" height="27px">";
    //this.test = this.sanitizer.bypassSecurityTrustHtml(body);
  }

  ///private event: MouseEvent;

  // initial center position for the map///////////////////////////////// start Pin Marker
  clickedMarker(infowindow, index: number) {
    //debugger;

    this.resultTypeID = "";
    this.isLoading = true;
    try {
      //this.resultTypeID = this.infowindowArray[index].split('@')[0];
      //this.previous = null;
      //console.log(this.previous)

      ///// close previous window
      //index = index + 1;  ///elumalai
      if (this.previous) {
        //console.log(this.previous["isOpen"])
        if (this.previous["isOpen"] == true)
          this.previous.close();
      }
      this.previous = infowindow;

      //console.log(index);//susheel
      //if (index != 11) {
      if (this.bluetoothData[index].indexOf('IGNORETS-VQUAD') > -1) {
        //console.log(this.bluetoothData[index])//susheel
        this.bluetoothText = this.bluetoothData[index].split('$')[1];//this.bluetoothData[index].split('(')[2].split(')')[0];
        this.isBlutoothButton = true;
      }
      else
        this.isBlutoothButton = false;

      let latlng = {
        lat: infowindow.hostMarker.latitude,
        lng: infowindow.hostMarker.longitude
      }

      this.resultTypeID = this.infowindowArray[index].split('@')[0];

      this.geocode(latlng).then(place => {
        this.currentPinLocation = place.formatted_address;
        let pinInfo = this.infowindowArray[index].split('@')[1].replace('Loading...', this.currentPinLocation)
        this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml(pinInfo);
        this.previous.open();
        this.previous["isOpen"] = true;//susheel

        this.isLoading = false;

      })
        .catch(err => {
          console.log(err);
          this.EmptyBindGMap();
        });

      //}
      //else {

      //  this.infoWindowbody = this.sanitizer.bypassSecurityTrustHtml("fsf");
      //}
      //console.log(this.infowindowArray[index]);
    }
    catch (ex) {
      this.isLoading = false;
      this.EmptyBindGMap();
    }
  }

  //mapClicked($event: MouseEvent) {
  //  //alert();
  //}


  // //markerDragEnd(m: marker, $event: MouseEvent) 
  markerDragEnd() {
    ////alert(1);
    console.log('dragEnd');
  }

  markers: marker[] = [
    {
      lat: this.lat.toString(),
      lng: this.lng.toString(),
      //lat: this.lat,
      //lng: this.lng,
      label: '', //'A',
      draggable: true,
      iconurl: '',// this.iurl,
      widthImg: 0,
      heightImg: 0,
      resultType: '',
      popUpRsltType: '',
      itemID: '',
      lat_num: 0,
      lng_num: 0,
      iconZIndex: 1
    },

  ]


  ///////to get address based on lat n lng
  geocode(latlng: any): Promise<any> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode(
        {
          'location': latlng
        },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            resolve(results[0]);
          } else {
            reject(new Error(status));
          }
        }
      );
    });
  }


  //*********** Marker Cluster
  zoomChanged(event: any) {

    try {
      this.zoom = event;
      ////alert('zoom');

      //this.isLoading = true;
      //debugger;
      if (this.markers.length > 0) {
        this.markerCollection = this.markers;
        this.markers = [];
      }
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  OnTilesLoaded() {
    try {
      this.isLoading = false;
      //debugger;
      if (this.markers.length <= 0)
        this.markers = this.markerCollection;
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  dragEndMap() {
    //console.log(event);
    //debugger;
    try {
      //if (!this.leftPanel) {


      //  this.isLoading = true;


      //  setTimeout(() => { this.isLoading = false; }, 15000);
      //}
      //else
      //  this.leftPanel = false;
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  onBoundChanged() {
    //console.log(event);
    //debugger;
    try {
      //this.isLoading = true;
      //debugger;
      //if (this.markers != undefined && this.markers.length > 0) {
      //  this.markerCollection = this.markers;
      //  this.markers = [];
      //}
    }
    catch (ex) {
      this.isLoading = false;
    }
  }

  CalCluster() {
    //console.log(this.markers);
  }
  //***********


  /////////////////////////////////// End Pin Marker

  /////////////// start Polygon

  paths = [
    [
      { lat: this.lat, lng: this.lng },
      { lat: this.lat, lng: this.lng + 0.1 },
      { lat: this.lat + 0.1, lng: this.lng + 0.1 },
      { lat: this.lat + 0.1, lng: this.lng },
      { lat: this.lat, lng: this.lng },
    ], [
      { lat: this.lat1, lng: this.lng1 },
      { lat: this.lat1, lng: this.lng1 + 0.1 },
      { lat: this.lat1 + 0.1, lng: this.lng1 + 0.1 },
      { lat: this.lat1 + 0.1, lng: this.lng1 },
      { lat: this.lat1, lng: this.lng1 },
    ], [
      { lat: this.lat2, lng: this.lng2 },
      { lat: this.lat2, lng: this.lng2 + 0.1 },
      { lat: this.lat2 + 0.1, lng: this.lng2 + 0.1 },
      { lat: this.lat2 + 0.1, lng: this.lng2 },
      { lat: this.lat2, lng: this.lng2 },
    ]
  ];

  ToggleMapRegion() {

    if (this.loadOldGoogleMap)
      this.ToggleMapRegion_OldMarker();
    else
      this.ToggleMapRegion_AdvanceMarker();
  }

  ToggleMapRegion_OldMarker() {
    debugger;
    let isMainFilterContainsRegionName = this.mainFilterMapRegionName != '' ? true : false; ////check selected mainfilter has region name in it. 
    if (isMainFilterContainsRegionName) {
      this.toggleMapRegion = false;
    }

    if (!this.toggleMapRegion) {
      this.btnRegioncolor = "btnToggle2";
      this.tempMarker = this.gMapMarkerCollection;//this.markers;
      //this.markers = [];
      debugger;
      // show-Hide markers outside region
      this.ShowHideMarkerOustsideRegion(isMainFilterContainsRegionName);

      this.gMapMarkerCollection = [];
      this.toggleMapRegion = !this.toggleMapRegion;
    }
    else {
      this.btnRegioncolor = "btnToggle1";
      //this.markers = this.tempMarker;
      //this.tempMarker = [];
      if (this.gMapMarkerCollection.length <= 0)
        this.gMapMarkerCollection = this.tempMarker;
      this.tempMarker = [];
      // Show all markers
      this.gMapMarkerCollection.forEach(marker => marker.setMap(this.map));
      this.toggleMapRegion = !this.toggleMapRegion;
    }
    //this.toggleMapRegion = !this.toggleMapRegion;

  }

  ShowHideMarkerOustsideRegion(isMainFilterContainsRegionName = false) {

    let regionPolygonList: google.maps.Polygon[] = [];
    let regionCircleList: google.maps.Circle[] = [];

    //regionPolygonList = this.polygonPathList;
    //regionCircleList = this.circleRegionList;
    if (this.polygonPathList.length > 0) {
      ////polygon
      this.polygonPathList.forEach(polygon => {
        regionPolygonList.push(polygon);
      });
    }

    if (this.circleRegionList.length > 0) {
      ////circle
      this.circleRegionList.forEach(circle => {
        regionCircleList.push(circle);
      });
    }

    //// combine 2 region list into one when both gmap region and selected mainfilter has region name.
    if (isMainFilterContainsRegionName) {
      ////polygon
      this.mainFilterRegionPolygonPathList.forEach(polygon => {
        regionPolygonList.push(polygon);
      });

      ////circle
      this.mainFilterRegionCircleRegionList.forEach(circle => {
        regionCircleList.push(circle);
      });

    }

    this.gMapMarkerCollection.forEach(marker => {
      //marker.setMap(null);
      const position = marker.getPosition();

      // Check if position exists to avoid errors
      if (position) {
        const lat = position.lat();
        const lng = position.lng();
        let latlngNewMain = new google.maps.LatLng(lat, lng);

        ////marker is inside polyon
        let isMarkerInsideAnyPolygon = false;
        for (var p = 0; p < regionPolygonList.length; p++) {
          const isExistsInside = google.maps.geometry.poly.containsLocation(latlngNewMain, regionPolygonList[p]);
          if (isExistsInside) {
            isMarkerInsideAnyPolygon = true;
            break;
          }
        }

        ////marker is inside circle
        let isMarkerInsideAnyCircle = false;
        for (var c = 0; c < regionCircleList.length; c++) {
          const isInsideCircle = google.maps.geometry.spherical.computeDistanceBetween(latlngNewMain, regionCircleList[c].getCenter()) <= regionCircleList[c].getRadius();
          if (isInsideCircle) {
            isMarkerInsideAnyCircle = true;
            break;
          }
        }

        ////keep only marker tha iside polygon or circle else remove it
        if (isMarkerInsideAnyPolygon || isMarkerInsideAnyCircle)
          marker.setMap(this.map);
        else
          marker.setMap(null);

      }//endif
    });///endforloop

  }

  ToggleMapRegion_AdvanceMarker() {
    debugger;
    console.log('ToggleMapRegion_AdvanceMarker');
    let isMainFilterContainsRegionName = this.mainFilterMapRegionName != '' ? true : false; ////check selected mainfilter has region name in it. 
    if (isMainFilterContainsRegionName) {
      this.toggleMapRegion = false;
    }

    if (!this.toggleMapRegion) {
      this.btnRegioncolor = "btnToggle2";
      this.tempMarker = this.gMapAdvanceMarkerCollection;//this.markers;
      //this.markers = [];
      debugger;
      // show-Hide markers outside region
      this.ShowHideMarkerOustsideRegion_AdvanceMarker(isMainFilterContainsRegionName);

      this.gMapAdvanceMarkerCollection = [];
      this.toggleMapRegion = !this.toggleMapRegion;
    }
    else {
      this.btnRegioncolor = "btnToggle1";
      //this.markers = this.tempMarker;
      //this.tempMarker = [];
      if (this.gMapAdvanceMarkerCollection.length <= 0)
        this.gMapAdvanceMarkerCollection = this.tempMarker;
      this.tempMarker = [];
      // Show all markers
      this.gMapAdvanceMarkerCollection.forEach(marker => marker.setMap(this.map));
      this.toggleMapRegion = !this.toggleMapRegion;
    }
    //this.toggleMapRegion = !this.toggleMapRegion;

  }

  ShowHideMarkerOustsideRegion_AdvanceMarker(isMainFilterContainsRegionName = false) {

    let regionPolygonList: google.maps.Polygon[] = [];
    let regionCircleList: google.maps.Circle[] = [];

    //regionPolygonList = this.polygonPathList;
    //regionCircleList = this.circleRegionList;
    if (this.polygonPathList.length > 0) {
      ////polygon
      this.polygonPathList.forEach(polygon => {
        regionPolygonList.push(polygon);
      });
    }

    if (this.circleRegionList.length > 0) {
      ////circle
      this.circleRegionList.forEach(circle => {
        regionCircleList.push(circle);
      });
    }

    //// combine 2 region list into one when both gmap region and selected mainfilter has region name.
    if (isMainFilterContainsRegionName) {
      ////polygon
      this.mainFilterRegionPolygonPathList.forEach(polygon => {
        regionPolygonList.push(polygon);
      });

      ////circle
      this.mainFilterRegionCircleRegionList.forEach(circle => {
        regionCircleList.push(circle);
      });

    }

    this.gMapAdvanceMarkerCollection.forEach(marker => {
      //marker.setMap(null);
      //const position = marker.getPosition();
      const position = marker.position;
      //console.log('position');
      //console.log(position);


      // Check if position exists to avoid errors
      if (position) {
        const lat = position.lat;// position.lat();
        const lng = position.lng;//position.lng();
        let latlngNewMain = new google.maps.LatLng(lat, lng);

        ////marker is inside polyon
        let isMarkerInsideAnyPolygon = false;
        for (var p = 0; p < regionPolygonList.length; p++) {
          const isExistsInside = google.maps.geometry.poly.containsLocation(latlngNewMain, regionPolygonList[p]);
          if (isExistsInside) {
            isMarkerInsideAnyPolygon = true;
            break;
          }
        }

        ////marker is inside circle
        let isMarkerInsideAnyCircle = false;
        for (var c = 0; c < regionCircleList.length; c++) {
          const isInsideCircle = google.maps.geometry.spherical.computeDistanceBetween(latlngNewMain, regionCircleList[c].getCenter()) <= regionCircleList[c].getRadius();
          if (isInsideCircle) {
            isMarkerInsideAnyCircle = true;
            break;
          }
        }

        ////keep only marker tha iside polygon or circle else remove it
        if (isMarkerInsideAnyPolygon || isMarkerInsideAnyCircle)
          marker.setMap(this.map);
        else
          marker.setMap(null);

      }//endif
    });///endforloop

  }

  onMouseOver($event, infoWindow, path) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infoWindow;
    // //alert($event.latLng.lat());
    //console.log($event.coords.lat)//-susheel
    this.polyLat = $event.coords.lat;
    this.polyLng = $event.coords.lng;
    this.infoRegionbody = path.label;
    infoWindow.open();
  }

  onMouseOut($event, infoWindow) {
    //infoWindow.close();
  }

  GetAllMapRegion() {
    this.isLoading = true;
    this.url = this.baseUrl + 'GoogleMaps/GetMapRegion';

    this.GetMapConfigData_Service().subscribe((res: any) => {

      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      //console.log(rows);
      this.mapRegionList = rows;
      this.mapRegionList.unshift('--Select Region--');
      //this.GetMapConfigData();
      //this.controlReg.setValue({ name: rows });
      this.getListReg();
      this.isLoading = false;
    });
  }

  GetMapRegionDetail(criteriaName, clearInput?) {
    ////alert('GetMapRegionDetail');
    debugger
    this.isLoading = true;
    this.removePolgonPath();   // Method to remove the polygon from the map

    if (criteriaName == "--Select Region--") {
      criteriaName = "0";
      ///////////// Set region name in subsribe so on edit click load region name in region config
      this.commonFilterService.SetGmapRegion(criteriaName);
    }

    if (this.MapRegClose) {
      this.MapRegClose = false;
      return;
    }

    this.inputLengthReg = criteriaName.length;
    if (criteriaName == "0") {
      this.inputLengthReg = 0;
      this.paths = [];
      this.mapRegionSelected = "0";
      this.isLoading = false;
      return;
    }
    else {
      this.modelRegName = criteriaName;
      this.mapRegionSelected = criteriaName;
    }

    ///////////// Set region name in subsribe so on edit click load region name in region config
    this.commonFilterService.SetGmapRegion(criteriaName);

    this.url = this.baseUrl + 'GoogleMaps/GetMapRegion?criteriaName=' + criteriaName;

    this.isLoading = true;
    this.GetMapConfigData_Service().subscribe((res: any) => {
      //console.log(res);

      let rows: any[] = JSON.parse(res) as any[];
      this.BindMapRegion(rows, false);

      if (this.myConfigNameReg == "null")
        this.OpenAutoCompeleteDailogReg(clearInput);

      this.isLoading = false;
    });
    // this.isLoading = false;
  }

  ////this func is called when mainfilter has map region configured in it.
  async GetMainFilterMapRegion() {
    ////alert('GetMapRegionDetail');
    this.isLoading = true;
    let isMainFilterContainsRegionName = this.mainFilterMapRegionName != '' ? true : false; ////check selected mainfilter has region name in it.
    this.url = this.baseUrl + 'GoogleMaps/GetMapRegion?criteriaName=' + this.mainFilterMapRegionName;
    await this.GetMapConfigData_Service().subscribe((res: any) => {

      let rows: any[] = JSON.parse(res) as any[];
      this.BindMapRegion(rows, isMainFilterContainsRegionName);
      debugger;
      this.toggleMapRegion = false;///to show only pins inside region
      this.ToggleMapRegion();
      this.isLoading = false;
    });

  }

  async BindMapRegion(mapRegion, isMainFilterContainsRegionName = false): Promise<void> {
    debugger;

    this.paths = [];
    //let isMainFilterContainsRegionName = this.mainFilterMapRegionName != '' ? true : false; ////check selected mainfilter has region name in it.

    if (mapRegion.length > 0) {
      this.isLoading = true;
      this.setLimitedOptionsReg = true;
      this.regNamesObservable = this.mapRegionList;

      try {
        // if ($(hiddenArrayRegs[ha] + txtId).val().length > 0) {//hidden field of dataquery.aspx page
        var province = ";";
        //let regindex = 0;
        //console.log(mapRegion);
        for (let h = 0; h < mapRegion.length; h++) {
          //regindex = regindex + 1;
          var splitEachReg = mapRegion[h].RegGPSLatLngs.split(';');
          var chosenColorLoad = "#" + mapRegion[h].RegColors;
          var polyLabel = mapRegion[h].RegNames;
          var regionArr = [];

          for (let i = 0; i < splitEachReg.length - 1; i++) {
            if ((splitEachReg[i].split('^'))[1] != '3') {//place, Degrees or co-ordinates
              //console.log((splitEachReg[i].split('^'))[0]);
              var Lat = parseFloat(((splitEachReg[i].split('^'))[0].split(','))[0]);
              var Lng = parseFloat(((splitEachReg[i].split('^'))[0].split(','))[1]);

              //var latLng = new google.maps.LatLng(Lat, Lng);//parseFloat(
              regionArr.push({ lat: Lat, lng: Lng, label: polyLabel, polyColor: chosenColorLoad });

            }
            else {//Province
              //console.log('start province');
              //console.log((splitEachReg[i].split('^'))[1]);
              province += ((splitEachReg[i].split('^'))[0].split(','))[1] + "@" + polyLabel + "@" + chosenColorLoad + ";";
              //console.log('end province');
            }
          }
          this.paths.push(regionArr);
          if (regionArr.length > 0) {
            if (splitEachReg.length >= 4) {
              var flightPath = this.makePolygon(regionArr, chosenColorLoad, polyLabel, isMainFilterContainsRegionName);
              //arrPolys.push(flightPath);
            }
            else
              this.drawCircle(regionArr, map, chosenColorLoad, polyLabel, isMainFilterContainsRegionName);
          }
        }

        //By all provinces of all regions
        if (province != ";") {
          //debugger;
          //console.log(province);
          await this.getProviceList();  ////  this.getProviceList((arrProvinces[p].split('@'))[0])
          //debugger;

          var arrProvinces = province.split(';');
          for (var p = 1; p < arrProvinces.length - 1; p++) {
            var provPolyLabel = (arrProvinces[p].split('@'))[1] + " : " + (arrProvinces[p].split('@'))[0];
            var provChosenColorLoad = (arrProvinces[p].split('@'))[2];

            //console.log(p);
            //console.log(provPolyLabel);
            //console.log(((arrProvinces[p].split('@'))[0]))
            //console.log(this.Province0List);

            var wsCoords = this.Province0List.filter(items => items.name == ((arrProvinces[p].split('@'))[0]));  //.split('@');//Coor array

            //if (wsCoords.length <= 0)
            //  wsCoords = this.Province1List.filter(items => items.name == ((arrProvinces[p].split('@'))[0]));
            //if (wsCoords.length <= 0)
            //  wsCoords = this.Province2List.filter(items => items.name == ((arrProvinces[p].split('@'))[0]));
            //if (wsCoords.length <= 0)
            //  wsCoords = this.Province3List.filter(items => items.name == ((arrProvinces[p].split('@'))[0]));


            for (var co = 0; co < wsCoords.length; co++) {

              var regionArrProv = new Array();
              ////// 'Wyoming@Example3_US@#CC0099'
              if (Array.isArray(wsCoords[co].coordinates)) {
                ////////// for array of cooradinates
                for (let i = 0; i < wsCoords[co].coordinates.length; i++) {
                  var coordsAll = wsCoords[co].coordinates[i];
                  var coords = coordsAll.split(' ');//split by space

                  regionArrProv = new Array();

                  for (var j = 0; j < coords.length; j++) {
                    if (coords[j].trim().length > 0) {
                      try {
                        var cordlatlng = coords[j].trim().split(",");
                        var Lat = parseFloat(cordlatlng[1]);
                        var Lng = parseFloat(cordlatlng[0]);
                        var latLng = new google.maps.LatLng(Lat, Lng);//parseFloat(

                        regionArrProv.push(latLng);
                      }
                      catch (error) {
                        console.log(coords[j]);
                      }
                    }
                  }
                  var flightPathProv = this.makePolygon(regionArrProv, provChosenColorLoad, provPolyLabel, isMainFilterContainsRegionName);
                }
              }
              else {
                var coordsAll = wsCoords[co].coordinates; //// singe property of coordinates
                var coords = coordsAll.split(' ');//split by space
                regionArrProv = new Array();
                for (var j = 0; j < coords.length; j++) {
                  if (coords[j].trim().length > 0) {
                    try {
                      var cordlatlng = coords[j].trim().split(",");
                      var Lat = parseFloat(cordlatlng[1]);
                      var Lng = parseFloat(cordlatlng[0]);
                      var latLng = new google.maps.LatLng(Lat, Lng);//parseFloat(

                      regionArrProv.push(latLng);
                    }
                    catch (error) {
                      console.log(coords[j]);
                    }
                  }
                }
                var flightPathProv = this.makePolygon(regionArrProv, provChosenColorLoad, provPolyLabel, isMainFilterContainsRegionName);
              }
              //var flightPathProv = this.makePolygon(regionArrProv, provChosenColorLoad, provPolyLabel);

            }

          }

        }///end province
      }
      catch (ex) {
        console.log();
      }
      this.isLoading = false;
    }
    this.isLoading = false;
  }


  async getProviceList(): Promise<void> {
    try {
      this.Province0List = await this.http.get<any[]>('assets/ng-crud-table/KMLMaps/Provinces_New.json').toPromise();
      //this.Province0List = await this.http.get<any[]>('assets/ng-crud-table/KMLMaps/Provinces0.json').toPromise();
      //this.Province1List = await this.http.get<any[]>('assets/ng-crud-table/KMLMaps/Provinces1.json').toPromise();
      //this.Province2List = await this.http.get<any[]>('assets/ng-crud-table/KMLMaps/Provinces2.json').toPromise();
      //this.Province3List = await this.http.get<any[]>('assets/ng-crud-table/KMLMaps/Provinces3.json').toPromise();
    }
    catch (error) {
      console.error('Error loading Provinces data', error);
    }
    //this.http.get<any[]>('assets/ng-crud-table/KMLMaps/Provinces3.json').subscribe(data => {//obj of arrays having name key
    //  debugger;
    //  console.log(data);
    //  this.ProvinceList= data.filter(items => items.name == regionName);

    //});
  }

  removePolgonPath() {
    ////alert('remove');
    debugger
    if (this.polygonPathList) {
      //this.polygonPath.setMap(null); // Remove the polygon from the map
      //this.polygonPath = null; // Optionally, clean up the reference
      this.polygonPathList.forEach(polygon => {
        polygon.setMap(null); // Remove the polygon from the map
      });
      this.polygonPathList = []; // Clear the array
    }

    if (this.circleRegionList) {
      this.circleRegionList.forEach(circleRegion => {
        circleRegion.setMap(null); // Remove the polygon from the map
      });
      this.circleRegionList = [];
    }

  }

  /////to remove region path that are drawn from mainfilter
  removeMainFilterRegionPolgonPath() {
    ////alert('removemfRegion');
    debugger
    //this.tempMarker = [];///clear tempmarker once main filter is set OFF

    if (this.mainFilterRegionPolygonPathList) {
      //this.polygonPath.setMap(null); // Remove the polygon from the map
      //this.polygonPath = null; // Optionally, clean up the reference
      this.mainFilterRegionPolygonPathList.forEach(polygon => {
        polygon.setMap(null); // Remove the polygon from the map
      });
      this.mainFilterRegionPolygonPathList = []; // Clear the array
    }

    if (this.mainFilterRegionCircleRegionList) {
      this.mainFilterRegionCircleRegionList.forEach(circleRegion => {
        circleRegion.setMap(null); // Remove the polygon from the map
      });
      this.mainFilterRegionCircleRegionList = [];
    }

  }


  makePolygon(polyCoords, chosenColor, polyLabel, mainfilterMapRegionSelected = false) {
    //debugger;

    ////color: red;
    ////background - color: white;
    ////font - family: "Lucida Grande", "Arial", sans - serif;
    ////font - size: 10px;
    ////font - weight: bold;
    ////text - align: center;
    ////width: auto;
    ////border: 2px solid black;
    ////white - space: nowrap;

    var polyMarker = new google.maps.Marker({
      position: new google.maps.LatLng(0, 0),
      draggable: false,
      raiseOnDrag: false,
      map: this.map,
      label: {
        text: polyLabel,
        fontSize: "14px",
        fontWeight: "bold",
        color: "white",
      },
      //labelAnchor: new google.maps.Point(30, 20),
      //labelClass: "labels", // the CSS class for the label
      labelStyle: { opacity: 1.0 },
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 0 // Use an invisible icon to only show the label
      },
      visible: false
    });


    //var flightPath;
    if (chosenColor == "#FFFFFF") {
      this.polygonPath = new google.maps.Polygon({
        paths: polyCoords,
        rokeColor: chosenColor,
        strokeOpacity: 0,
        strokeWeight: 2,
        fillColor: chosenColor,
        fillOpacity: 0,
        map: this.map
      });
    }
    else {
      this.polygonPath = new google.maps.Polygon({
        paths: polyCoords,
        rokeColor: chosenColor,
        //strokeOpacity: strokeTrans,
        //strokeWeight: 2,
        fillColor: chosenColor,
        //fillOpacity: fillTrans,
        map: this.map
      });
    }
    //flightPath.setMap(map);
    //flightPath.setMap(this.map);

    //Display MarkerLabel when mouseOver
    google.maps.event.addListener(this.polygonPath, "mousemove", function (event) {
      polyMarker.setPosition(event.latLng);
      polyMarker.setVisible(true);
      if (chosenColor == "#FFFFFF")
        polyMarker.setVisible(false);
      //const position = event.latLng;
      //if (position) {
      //  this.showLabel(position, "Hovered Region Label");
      //}
    });
    google.maps.event.addListener(this.polygonPath, "mouseout", function (event) {
      polyMarker.setVisible(false);
      //this.hideLabel();
    });
    //google.maps.event.addListener(flightPath, "mouseover", function (event) {
    //  latlngZoomCenter = event.latLng;//new google.maps.LatLng(lat, lng); //sets same region position
    //  document.getElementById("boundHid").value = latlngZoomCenter;
    //});
    //debugger;
    //////// if mainfilter selected has map region name
    if (mainfilterMapRegionSelected)
      this.mainFilterRegionPolygonPathList.push(this.polygonPath);
    else
      this.polygonPathList.push(this.polygonPath);

    return this.polygonPath;
  }

  drawCircle(places, map, chosenColor, polyLabel, mainfilterMapRegionSelected = false) {
    //var polyMarker = new MarkerWithLabel({
    //  position: new google.maps.LatLng(0, 0),
    //  draggable: false,
    //  raiseOnDrag: false,
    //  map: map,
    //  labelContent: polyLabel,
    //  labelAnchor: new google.maps.Point(30, 20),
    //  labelClass: "labels", // the CSS class for the label
    //  labelStyle: { opacity: 1.0 },
    //  icon: "http://placehold.it/1x1",
    //  visible: false
    //});
    var polyMarker = new google.maps.Marker({
      position: new google.maps.LatLng(0, 0),
      draggable: false,
      raiseOnDrag: false,
      map: this.map,
      label: {
        text: polyLabel,
        fontSize: "12px",
        fontWeight: "bold",
        color: "red",
      },
      labelAnchor: new google.maps.Point(30, 20),
      //labelClass: "labels", // the CSS class for the label
      labelStyle: { opacity: 1.0 },
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 0 // Use an invisible icon to only show the label
      },
      visible: false
    });

    var strokeTrans = 0.8;
    var fillTrans = 0.2;
    if (chosenColor == "#FFFFFF") {
      strokeTrans = 0;
      fillTrans = 0;
    }
    for (var i = 0, place; place = places[i]; i++) {
      var circleRegion = new google.maps.Circle({
        center: place,
        radius: 200000,
        strokeColor: chosenColor,
        strokeOpacity: strokeTrans,
        strokeWeight: 2,
        fillColor: chosenColor,
        fillOpacity: fillTrans
      });
      circleRegion.setMap(this.map);

      //////// if mainfilter selected has map region name
      if (mainfilterMapRegionSelected)
        this.mainFilterRegionCircleRegionList.push(circleRegion);
      else
        this.circleRegionList.push(circleRegion);

      google.maps.event.addListener(circleRegion, "mousemove", function (event) {
        polyMarker.setPosition(event.latLng);
        polyMarker.setVisible(true);
        if (chosenColor == "#FFFFFF")
          polyMarker.setVisible(false);
      });
      google.maps.event.addListener(circleRegion, "mouseout", function (event) {
        polyMarker.setVisible(false);
      });
      //google.maps.event.addListener(myCity, "mouseover", function (event) {
      //  latlngZoomCenter = place;//new google.maps.LatLng(lat, lng); //sets same region position
      //  document.getElementById("boundHid").value = latlngZoomCenter;
      //});
    }
  }

  // Method to show the custom label using OverlayView
  div: any;
  showLabel(position: google.maps.LatLng, text: string) {
    // //alert();
    // Create the custom label overlay if it doesn't exist
    if (!this.customLabelOverlay) {
      this.customLabelOverlay = new google.maps.OverlayView();

      this.customLabelOverlay.onAdd = () => {
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.backgroundColor = 'white'; // Background color
        div.style.border = '2px solid black'; // Border color and thickness
        div.style.padding = '5px'; // Padding around the text
        div.style.fontFamily = '"Lucida Grande", "Arial", sans - serif'; // Font style
        div.style.fontSize = '12px'; // Font size
        div.style.fontWeight = 'bold'; // Font weight
        div.style.color = 'red'; // Text color
        div.style.whiteSpace = 'nowrap'; // Prevent text wrapping
        div.style.borderRadius = '5px'; // Rounded corners
        div.innerText = text; // The text of the label

        const panes = this.customLabelOverlay.getPanes();// ?.getPanes();
        if (panes) {
          panes.overlayLayer.appendChild(div);
        }

        //(this.customLabelOverlay as any).div = div;

        // Store div for later access in `draw` and `onRemove`
        this.div = div;

      };

      this.customLabelOverlay.draw = () => {
        const projection = this.customLabelOverlay.getProjection(); //this.customLabelOverlay ?.getProjection();
        const pixelPosition = projection.fromLatLngToDivPixel(position);  //projection ?.fromLatLngToDivPixel(position);

        //if (pixelPosition && this.customLabelOverlay ?.div) {
        if (pixelPosition && this.div) {
          //this.customLabelOverlay.div.style.left = `${pixelPosition.x}px`;
          //this.customLabelOverlay.div.style.top = `${pixelPosition.y}px`;
          this.div.style.left = pixelPosition.x + 'px';
          this.div.style.top = pixelPosition.y + 'px';
        }
      };

      this.customLabelOverlay.onRemove = () => {
        //if (this.customLabelOverlay ?.div) {
        //  this.customLabelOverlay.div.parentNode ?.removeChild(this.customLabelOverlay.div);
        //  this.customLabelOverlay.div = null;
        //}
        // Remove the div from the map when the overlay is removed
        if (this.div) {

          this.div.parentNode.removeChild(this.div);
          this.div = null;
        }
      };

      this.customLabelOverlay.setMap(this.map); // Set the label on the map
    } else {
      // Update the position and text of the label
      //this.customLabelOverlay.draw = () => {
      //  const projection = this.customLabelOverlay ?.getProjection();
      //  const pixelPosition = projection ?.fromLatLngToDivPixel(position);

      //  if (pixelPosition && this.customLabelOverlay ?.div) {
      //    this.customLabelOverlay.div.style.left = `${pixelPosition.x}px`;
      //    this.customLabelOverlay.div.style.top = `${pixelPosition.y}px`;
      //    this.customLabelOverlay.div.innerText = text;
      //  }
      //};
    }
  }

  // Method to hide the custom label
  hideLabel(): void {
    if (this.customLabelOverlay) {
      this.customLabelOverlay.setMap(null); // Remove the label from the map
      this.customLabelOverlay = null; // Clean up the reference
    }
  }

  /////////////// end Polygon

  /// start Toggle Div
  DivToggle(controlName) {

    switch (controlName) {
      case 'showAnalysis':
        this.showAnalysis = !this.showAnalysis;
        break;
      case 'showNetTest':
        this.showNetTest = !this.showNetTest;
        break;
      case 'showMobileInfo':
        this.showMobileInfo = !this.showMobileInfo;
        break;
      case 'showErrorEvents':
        this.showErrorEvents = !this.showErrorEvents;
        break;
      case 'showTypes':
        this.showTypes = !this.showTypes;
        break;
      case 'showResults':
        this.showResults = !this.showResults;
        break;
    }

  }
  /// end toggle div

  //////////////////// start Check ALL / UnCheck ALL
  CheckBox(event) {
    const checked = event.target.checked;
    //this.nontrade.forEach(item => item.selected = checked);
  }


  GetMapChanges(controlName = '') {//shoukd be similar to below GetMapConfigByID function
    this.isLoading = true;
    this.stopFollowRoadRoute = true;
    if (controlName != '')
      this.DivToggle(controlName);

    ///// on display options selectoins, maintain zoom position to previuosly selected position
    if (this.mapDisplayOptions.PredefinedConfig.restoreLat != 0 && this.mapDisplayOptions.PredefinedConfig.restoreLng != 0) {
      this.zoom = this.mapDisplayOptions.PredefinedConfig.restoreZoom;
      this.lat = this.mapDisplayOptions.PredefinedConfig.restoreLat;
      this.lng = this.mapDisplayOptions.PredefinedConfig.restoreLng;
    }

    /////to handle general filterswhen coming from another page and editeventid filter this.delFilterColName = 'clearAllFilters'; clearAllFilters
    //this.commonFilterService.ClearAllFilters.subscribe(res => { this.delFilterColName = 'clearAllFilters'; });
    this.HandleGeneralFilter();

    this.GetDispaylOption();
    //debugger
    //if (this.commonFilterDates == undefined || this.commonFilterDates == "")
    this.SetcommonFilterDates();
    ////
    this.preDefinedConfigParam = new PredefinedConfig();
    this.preDefinedConfigParam.strStartDate = this.commonFilterDates.split('^')[0];
    this.preDefinedConfigParam.strEndDate = this.commonFilterDates.split('^')[1];
    this.preDefinedConfigParam.strLastRecord = '';
    this.preDefinedConfigParam.TimeStamp_Type = this.TSSelected.toString();
    //console.log(this.TSSelected)
    this.preDefinedConfigParam.FilterOnOff = 1;
    this.preDefinedConfigParam.MainFilterID = this.MainFilterID;
    if (this.preDefinedConfigParam.MainFilterID > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;
    if (this.genArr.length > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;

    //console.log("GetMapChanges() = ");
    //console.log(this.genArr.length);
    //if (this.genArr.length == 0) {
    //  //alert();

    //}
    //debugger;
    this.preDefinedConfigParam.limitPinCount = this.limitPinCount;
    this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;

    this.url = this.baseUrl + 'GoogleMaps/GetMapOnChangeEvent';

    this.preDefinedConfigParam.generalFilter = this.genArr;

    /////// Set mapDisplayOptions in services, this will be used to restore when return to googlemap from another page
    this.mapDisplayOptions.displayOptionApplied = true;
    //debugger;
    this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);

    this.GetMapDispayOptions_Service().subscribe((res: any) => {
      let rows: any[] = JSON.parse(res) as any[];
      ////console.log(rows)
      //if (rows != null)
      //  this.BindMapDetails(rows);
      //debugger;
      if (rows != null) {
        if (rows.length > 1) {

          let checkPolqaRecords = false;
          if (this.usePredefinedConfig == 'ON') {
            if (rows[rows.length - 2].includes('POLQA'))
              checkPolqaRecords = true;

            this.SetPinLegnd(rows[rows.length - 2]);
          }

          //// legend popup data
          this.dynamicLegendPopupData = [];
          this.dynamicLegendPopupData.push(JSON.parse(rows[rows.length - 1]));
          //console.log(this.dynamicLegendPopupData);
          //this.legendPopupData = this.dynamicLegendPopupData;

          if (this.usePredefinedConfig == "ON") {
            rows.pop();
            rows.pop();
          }

          this.BindMapDetails(rows);////elumalai

          if (this.usePredefinedConfig == 'ON') {
            //console.log('no audio count');
            //console.log(this.NoAudioPolqa_OnePoinOne.length);
            //console.log(this.totalNoAudioScore);
            //debugger;
            if (checkPolqaRecords) {
              this.dynamicPinLegends.push(
                {
                  queryCount: this.totalNoAudioScore,
                  imgSrc: 'NoAudioPolqaMark',
                  resultType: 'POLQA',
                  thresholdType: '( NO AUDIO )',
                  pinType: '',
                  condVal: 'POLQA MOS <= 1.1',//susheel
                  noOfRows: this.totalNoAudioScore,
                  MarkerPinType: 'NoAudioPolqaMark',
                  iconText: 'X',
                  iconBGColor: 'Red',
                  iconFontColor: 'Black',
                  legendName: 'POLQA',
                  dynamicBubbleClass: ''//
                }
              );
            }
          }///end if

          //this.BindMapDetails(rows);//susheel
        }
      }
      else {
        this.markers = [];
        this.markerCollection = [];
      }

      this.isLoading = false;
    });

    ////// start handle genral filter for cloumn filter
    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (this.delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });
      //console.log(this.genArrDel)
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }

    ////// end handle genral filter for cloumn filter

  }

  GetDispaylOption() {

    this.mapDisplayOptions.mapConfigID = this.mapConfigID;
    this.mapDisplayOptions.usePredefinedConfig = this.usePredefinedConfig == "OFF" ? 0 : 1;
    this.mapDisplayOptions.analysisEnabled = this.analysisEnabled;
    this.mapDisplayOptions.netTestEnabled = this.netTestEnabled;
    this.mapDisplayOptions.mobileInfoEnabled = this.mobileInfoEnabled;
    this.mapDisplayOptions.errorEventsEnabled = this.errorEventsEnabled;
    this.mapDisplayOptions.DisplayResultList = this.DisplayResultList;//DisplayResultList
    this.mapDisplayOptions.AnalysisList = this.AnalysisList;
    this.mapDisplayOptions.NetTestList = this.NetTestList;
    this.mapDisplayOptions.MobileInfoList = this.MobileInfoList;
    this.mapDisplayOptions.ErrorEventList = this.ErrorEventList;
    this.mapDisplayOptions.TypeList = this.TypeList;
    this.mapDisplayOptions.ResultList = this.ResultList;
  }

  //////////////////// end Check ALL / UnCheck ALL

  ////////////////// start Get PageLoad Data
  test: string;
  selMapConfig: string;
  GetPredefinedConfig(prevConfigID?) {
    //debugger;
    this.routeLatLng = [];
    this.stopFollowRoadRoute = true;
    this.isLoading = true;
    if (this.previous) {
      //console.log(this.previous["isOpen"])
      if (this.previous["isOpen"] == true)
        this.previous["isOpen"] = false;
    }

    //this.GetDispaylOption();
    if (this.mapDisplayOptions.PredefinedConfig.restoreLat != 0 && this.mapDisplayOptions.PredefinedConfig.restoreLng != 0) {
      if (this.mapDisplayOptions.mapConfigID > 0)
        this.selMapConfig = this.mapDisplayOptions.mapConfigID.toString();

      this.zoom = this.mapDisplayOptions.PredefinedConfig.restoreZoom;
      this.lat = this.mapDisplayOptions.PredefinedConfig.restoreLat;
      this.lng = this.mapDisplayOptions.PredefinedConfig.restoreLng;
    }

    this.commonFilterService.setUsePredefinedConfigData(this.usePredefinedConfig);

    if (this.usePredefinedConfig == "ON") {
      this.url = this.baseUrl + 'GoogleMaps/GetMapFilter';

      this.GetMapConfigData_Service().subscribe((res: any) => {
        this.isLoading = false;
        let rows: any[] = JSON.parse(res) as any[];
        //console.log(rows)

        //debugger;
        this.mapFilterConfigList = rows;
        if (rows.length > 0)//susheel
        {
          //console.log(prevConfigID)
          if (!prevConfigID) {
            if (!this.selMapConfig) {////if (this.selMapConfig === undefined || this.selMapConfig === "") {
              this.selMapConfig = rows[0].ID;
              this.control.setValue({ Name: rows[0].Name });
            }
            else {
              if (this.selMapConfig == "0") {////if (this.selMapConfig === undefined || this.selMapConfig === "") {
                this.selMapConfig = rows[0].ID;
                this.control.setValue({ Name: rows[0].Name });
              }
              else {
                /////// SET below the input text value - this.selMapConfig has previuosly selected value
                let mapConfigSelArr = this.mapFilterConfigList.find(m => m.ID == this.selMapConfig);
                if (mapConfigSelArr)
                  this.control.setValue({ Name: mapConfigSelArr.Name });
              }
            }
            //this.control.setValue({ id: this.selMapConfig });
            //console.log(this.selMapConfig)-susheel

            this.selectedMapConfigID = Number(this.selMapConfig)/////after restoredisplayoption to set previuos selected value in dropdown
          }
          this.getList();
          //if (this.myConfigName == "null")
          //  this.OpenAutoCompeleteDailog(true);

          this.GetMapConfigByID(this.selMapConfig);
        }


        this.GetAllMapRegion();
      });
    }
    else {
      //debugger
      this.isLoading = false;
      this.GetMapConfigData();
    }
  }

  AllGeneralFilter = [];
  filtersWithEventID = {};
  filters = {};
  delFilterColName = '';
  async GetMapConfigData() {
    //debugger;
    this.Loading = "Loading ..."
    this.isLoading = true;

    //this.commonFilterService.GeneralEventIDFilter.subscribe(res => {
    //  //console.log(res)
    //  this.filtersWithEventID = res;
    //});
    //this.commonFilterService.ClearAllFilters.subscribe(res => { this.clearAllGeneralFilters(); });

    //console.log(this.delFilterColName)
    if (this.delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key.toUpperCase() !== this.SetTimestampSearch(this.TSSelected).toUpperCase())
          delete this.filters[key];
      }
    }

    if (this.delFilterColName != 'clearAllFilters') {
      this.genArr = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"].toUpperCase() != this.SetTimestampSearch(this.TSSelected).toUpperCase();
      });

      this.commonFilterService.GeneralFilterDF.subscribe(res => {
        //console.log(res)
        this.filters = res;
      });
    }

    if (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0) {
      this.dataFilter.filters = this.filtersWithEventID;
      //console.log(filtersWithEventID)
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });
      let generalFilterArrayAll = this.dataFilter.getProcessedFiltersArray("ALL");
      this.genArr = [...this.genArr, ...generalFilterArrayAll];

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
      let generalFilterArrayNew = this.dataFilter.getProcessedFilters("");
      this.filters = { ...this.filters, ...generalFilterArrayNew };
    }
    else if (Object.keys(this.filtersWithEventID).length == 0) {
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }

    }
    //console.log(genArr)
    //console.log(filters)

    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      //cleared = 1;
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });

      for (const key in this.filters) {
        if (key == this.delFilterColName)
          delete this.filters[key];
      }
    }
    //console.log(this.genArr)
    this.hasFilters = this.genArr.length <= 0 ? false : true;

    if (this.delFilterColName != 'clearAllFilters') {
      //let newFilters = {};
      //for (const key in this.filters) {
      //  if (this.filters[key].rsltType == 'call-events' || this.filters[key].rsltType == '') {
      //    let value = this.filters[key].value;
      //    let matchMode = this.filters[key].matchMode;
      //    let valueTo = this.filters[key].valueTo;
      //    let type = this.filters[key].type;
      //    let rsltType = this.filters[key].rsltType;
      //    let title = this.filters[key].title;
      //    newFilters[key] = { value, matchMode, valueTo, type, rsltType, title };
      //  }
      //}
      ////console.log(newFilters)
      this.commonFilterService.setGeneralFilterData(this.filters);//(newFilters);
    }
    else
      this.hasFilters = false;

    //if (this.MainFilterID != 0) {
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      this.dbAndBrHrs = res;
    });
    if (this.dbAndBrHrs == -500) {//query var col table
      await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
        this.commonFilterService.setDBAndBrowserHrsDiff(res);
        this.dbAndBrHrs = res;
        this.commonFilterDates = formatDate(new Date(Date.now() + -1 * 600 * 1000), this.dbTz, this.dbAndBrHrs) + "^" + formatDate(new Date(), this.dbTz, this.dbAndBrHrs);//"06/02/2019 11:00:00^06/02/2019 20:00:00";
      });
    }
    //}

    this.url = this.baseUrl + 'GoogleMaps/GetMapConfigData';

    ///uncomented by elumalai
    this.commonFilterService.TSBetween.subscribe(res => {
      // debugger;
      this.commonFilterDates = res;
    });//latest dates selected is set here from service

    let isMainfilterCustDatetime = false;
    this.commonFilterService.mainFilter_ContainsCustDate.subscribe(res => {
      //debugger;
      if (res) {
        isMainfilterCustDatetime = true;
      }
    });

    //Added to set proper dates here based on range selection
    if (!isMainfilterCustDatetime) {
      this.commonFilterService.TSRangeFilter.subscribe(res => {
        if (res.RangeType !== "custom") { this.commonFilterDates = lastDateFunc(res.RangeType, this.dbTz, this.dbAndBrHrs) }
      });//sets start and end dates to latest timestamps based on range type selection - IMP
    }
    this.commonFilterService.setDatesProperties(this.commonFilterDates);

    ////// Common filter dates  
    //let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";
    this.commonFilterService.mfDateTime.subscribe(res => {
      if (res != "")
        this.commonFilterDates = res.replace(';', '^');
    });


    //// common filter date range
    //let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";  
    //this.commonFilterService.TSBetween.subscribe(res => dates = res);//latest dates selected is set here from service
    ////Added to set proper dates here based on range selection
    //this.commonFilterService.TSRangeFilter.subscribe(res => { if (res.RangeType !== "custom") { dates = lastDateFunc(res.RangeType) } });//sets start and end dates to latest timestamps based on range type selection - IMP
    //this.PredefinedConfigOff.push({
    //debugger;

    if (!this.hasFilters) {
      ///if clearfilter is clicked then remove all filters from this.genArr
      //debugger;

      this.genArr = [];
    }

    this.preDefinedConfigParam = new PredefinedConfig();
    this.preDefinedConfigParam.limitPinCount = this.limitPinCount;
    //console.log(this.commonFilterDates)
    this.preDefinedConfigParam.strStartDate = this.commonFilterDates.split('^')[0];
    this.preDefinedConfigParam.strEndDate = this.commonFilterDates.split('^')[1];
    this.preDefinedConfigParam.strLastRecord = '';

    this.preDefinedConfigParam.TimeStamp_Type = this.TSSelected.toString();

    this.preDefinedConfigParam.FilterOnOff = 1;
    this.preDefinedConfigParam.MainFilterID = this.MainFilterID;
    if (this.preDefinedConfigParam.MainFilterID > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;
    // //});
    if (this.genArr.length > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;


    //console.log("GetMapConfigData() = ");
    //console.log(this.genArr.length);

    this.preDefinedConfigParam.generalFilter = this.genArr;

    /////// Set mapDisplayOptions in services, this will be used to restore when return to googlemap from another page
    this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
    this.mapDisplayOptions.usePredefinedConfig = this.usePredefinedConfig == "OFF" ? 0 : 1;
    //debugger;
    this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);

    try {
      this.GetMapConfigData_Service().subscribe((res: any) => {
        //console.log(res);// - susheel
        //debugger;
        try {
          let rows: any[] = JSON.parse(res) as any[];
          //this.isLoading = false;
          //let data = rows;
          //debugger;
          //if (this.usePredefinedConfig == "OFF") {
          //  if (rows != null) {
          //    if (rows.length > 0) {
          //      this.pinLegends = rows[rows.length - 1].replace('[', '').replace(']', '').split(',');
          //      rows.pop();
          //    }
          //  }
          //}
          //else {
          //  //this.divPinLegends = this.sanitizer.bypassSecurityTrustHtml(rows[rows.length - 1]);
          //  //rows.pop();
          //}

          //this.bluetoothData = rows;
          //console.log(rows);// - susheel
          debugger;
          if (rows != null) {

            this.BindMapDetails(rows);

          }
          else {
            this.markers = [];
            this.markerCollection = [];
          }
          this.Loading = "";
          //this.isLoading = false;
          // this.isLoading = false;  ////elumalai commented due for intiliaze_optimize function as loading image should show till all pins plotted

          //let str = "1,2,3"; 
          //console.log(str.split(","));
          //this.cd.detectChanges();
        }
        catch (ex) {
          this.Loading = "";
          this.isLoading = false;
          this.EmptyBindGMap();
        }
      });
    }
    catch (ex) {
      ////alert(2);
      this.Loading = "";
      this.isLoading = false;
      this.EmptyBindGMap();
    }
    //setTimeout(() => { this.map.triggerResize(); }, 500)
    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (this.delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });
      //console.log(this.genArrDel)
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    //debugger
  }

  async updateMarkers(newBounds: LatLngBounds) {
    //debugger;

    //this.cd.detectChanges();

    //this.markers = [];
    //setTimeout(() => {
    //  //this.markers = this.markerCollection.filter(marker => newBounds.contains(new google.maps.LatLng(marker.lat, marker.lng)));
    //}, 1000);

    // setTimeout(() => { this.map.triggerResize(); }, 500)
  }



  BindMapDetails(mapData) {
    this.mapData = mapData;
    //console.log(this.mapData.length)
    this.markers = [];
    this.markerCollection = [];
    //debugger;
    if (this.usePredefinedConfig == "OFF") {
      if (this.mapData != null) {
        if (this.mapData.length > 0) {
          this.pinLegends = this.mapData[this.mapData.length - 1].replace('[', '').replace(']', '').split(',');
          ///// for total nettest and Mobile info count
          if (this.pinLegends.length > 0) {
            //debugger;
            this.totalNetTestPassCount = parseInt(this.pinLegends[26]) + parseInt(this.pinLegends[28]) + parseInt(this.pinLegends[30]) + parseInt(this.pinLegends[32]) + parseInt(this.pinLegends[34]) + parseInt(this.pinLegends[36]) + parseInt(this.pinLegends[38]) + parseInt(this.pinLegends[40]) + parseInt(this.pinLegends[42]);
            this.totalNetTestFailCount = parseInt(this.pinLegends[27]) + parseInt(this.pinLegends[29]) + parseInt(this.pinLegends[31]) + parseInt(this.pinLegends[33]) + parseInt(this.pinLegends[35]) + parseInt(this.pinLegends[37]) + parseInt(this.pinLegends[39]) + parseInt(this.pinLegends[41]) + parseInt(this.pinLegends[43]);
            this.totalMobInfoPassCount = parseInt(this.pinLegends[45]) + parseInt(this.pinLegends[47]) + parseInt(this.pinLegends[49]);
            this.totalMobInfoFailCount = parseInt(this.pinLegends[46]) + parseInt(this.pinLegends[48]) + parseInt(this.pinLegends[50]);
            this.totalFailuresOverall = (this.totalNetTestFailCount + this.totalMobInfoFailCount + parseInt(this.pinLegends[25]));  ////(netTestFailCnt + mobInfoFailCnt + vacFailCnt)
          }
          this.mapData.pop();
        }
      }
    }



    this.bluetoothData = this.mapData;

    //if (this.usePredefinedConfig == "ON")
    // this.mapData.pop();

    if (this.mapData != null) {
      ////alert(this.TSSelected.toString());
      let timestampTypeMain = "VQuad ";
      if (this.TSSelected == 2)
        timestampTypeMain = "VQT ";
      else if (this.TSSelected == 0)
        timestampTypeMain = "Call ";

      this.Initialize(this.mapData, timestampTypeMain, 1);
    }

    //console.log(this.markers);

    //for (let i = 0; i < this.mapData.length; i++) {
    //  var data = this.mapData[i].MERGED.split(",");
    //this.pinMarker = new marker();GetMapRegion
    //this.pinMarker.lat = data[0];
    //this.pinMarker.lng = data[1];
    //this.pinMarker.label = "Z" + i;
    //this.pinMarker.iconurl = this.iurl_b;

    //this.markers.push(this.pinMarker);
    //}
  }

  ////////////////  end Get pageload data

  ///////////////////////////////// start get map config byID

  /////// this is created for restorepreviuos display otopn for predefinedconfig ON
  async SetcommonFilterDates() {
    //debugger
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      this.dbAndBrHrs = res;
    });
    if (this.dbAndBrHrs == -500) {//query var col table
      await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
        this.commonFilterService.setDBAndBrowserHrsDiff(res);
        this.dbAndBrHrs = res;
        this.commonFilterDates = formatDate(new Date(Date.now() + -1 * 600 * 1000), this.dbTz, this.dbAndBrHrs) + "^" + formatDate(new Date(), this.dbTz, this.dbAndBrHrs);//"06/02/2019 11:00:00^06/02/2019 20:00:00";
      });
    }
    //}

    this.url = this.baseUrl + 'GoogleMaps/GetMapConfigData';

    ///uncomented by elumalai
    this.commonFilterService.TSBetween.subscribe(res => {
      this.commonFilterDates = res;
    });//latest dates selected is set here from service

    let isMainfilterCustDatetime = false;
    this.commonFilterService.mainFilter_ContainsCustDate.subscribe(res => {
      //debugger;
      if (res) {
        isMainfilterCustDatetime = true;
      }
    });

    //Added to set proper dates here based on range selection
    if (!isMainfilterCustDatetime) {
      this.commonFilterService.TSRangeFilter.subscribe(res => {
        if (res.RangeType !== "custom") { this.commonFilterDates = lastDateFunc(res.RangeType, this.dbTz, this.dbAndBrHrs) }
      });//sets start and end dates to latest timestamps based on range type selection - IMP
    }
    this.commonFilterService.setDatesProperties(this.commonFilterDates);

    ////// Common filter dates  
    //let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";
    this.commonFilterService.mfDateTime.subscribe(res => {
      if (res != "")
        this.commonFilterDates = res.replace(';', '^');
    });
  }

  clearAllGeneralFilters() {
    //console.log("cleared")
    this.dataFilter = new DataFilter();
    //this.boolClearFilters = true;
    this.commonFilterService.setGeneralEventIDFilterData({});
  }

  GetMapConfigByID(mapConfigID, mapLegendApplied = 0) {
    //console.log(this.MapClose)
    if (this.MapClose) {
      this.MapClose = false;
      return;
    }

    this.stopFollowRoadRoute = true;
    ////alert(mapConfigID);

    ///set selected custom reportid and selected  filter method[aggr/timestamp/group] in service so that to load selected custom report config details when configuration screen is opened
    this.commonFilterService.SetGmapConfigID(mapConfigID);

    if (this.previous) {
      //console.log(this.previous["isOpen"])
      if (this.previous["isOpen"] == true)
        this.previous["isOpen"] = false;
    }

    this.Loading = "Loading ...";
    this.isLoading = true;

    /////to handle general filterswhen coming from another page and editeventid filter
    ///this.commonFilterService.ClearAllFilters.subscribe(res => { this.clearAllGeneralFilters(); });
    this.HandleGeneralFilter();

    this.mapConfigID = mapConfigID;
    if (mapConfigID != null) {
      this.inputLength = 1;
    }
    else
      this.inputLength = 0;

    this.GetDispaylOption();

    let dRoute = this.DrawRoute == "ON" ? 1 : 0;
    //if (this.commonFilterDates == undefined || this.commonFilterDates == "")
    this.SetcommonFilterDates();

    this.preDefinedConfigParam = new PredefinedConfig();
    this.preDefinedConfigParam.limitPinCount = this.limitPinCount;
    this.preDefinedConfigParam.strStartDate = this.commonFilterDates.split('^')[0];
    this.preDefinedConfigParam.strEndDate = this.commonFilterDates.split('^')[1];
    this.preDefinedConfigParam.strLastRecord = '';

    this.preDefinedConfigParam.TimeStamp_Type = this.TSSelected.toString();

    this.preDefinedConfigParam.FilterOnOff = 1;
    this.preDefinedConfigParam.gMapConfigID = mapConfigID;
    this.preDefinedConfigParam.drawRoute = dRoute;
    this.preDefinedConfigParam.MainFilterID = this.MainFilterID;
    if (this.preDefinedConfigParam.MainFilterID > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;
    if (this.genArr.length > 0)
      this.preDefinedConfigParam.FilterOnOff = 0;

    //console.log("GetMapConfigByID() = ");
    //console.log(this.genArr.length);
    //debugger;
    this.url = this.baseUrl + 'GoogleMaps/GetMapConfigDataByID';
    if (mapLegendApplied == 1) {
      this.preDefinedConfigParam.thresholdLegends = this.thresholdLegends;
      this.preDefinedConfigParam.thresholdLegendsCount = this.thresholdLegendsCount;
      this.preDefinedConfigParam.callIDLegends = this.callIDLegends;//susheel
      this.preDefinedConfigParam.devIDLegends = this.devIDLegends;
      this.preDefinedConfigParam.callEventsLegends = this.callEventsLegends;

    }

    this.mapDisplayOptions.PredefinedConfig = this.preDefinedConfigParam;
    this.preDefinedConfigParam.generalFilter = this.genArr;

    /////// Set mapDisplayOptions in services, this will be used to restore when return to googlemap from another page
    this.mapDisplayOptions.displayOptionApplied = false;
    //debugger;
    this.commonFilterService.SetGMapDisplayOption(this.mapDisplayOptions);

    this.GetMapConfigDataByID_Service().subscribe((res: any) => {
      //console.log(res);
      try {
        let rows: any[] = JSON.parse(res) as any[];
        //console.log(rows);

        //debugger;
        this.infowindowArray = [];
        //this.divPinLegends = this.sanitizer.bypassSecurityTrustHtml(rows[rows.length - 1]);
        if (rows != null) {
          if (rows.length > 1) {
            let checkPolqaRecords = false;
            if (this.usePredefinedConfig == 'ON') {
              this.setLimitedOptions = true;
              this.mapNamesObservable = this.mapFilterConfigList;

              /////////////to check result has polqa records based on that no audio pin marker show/hide
              if (rows[rows.length - 2].includes('POLQA'))
                checkPolqaRecords = true;

              this.SetPinLegnd(rows[rows.length - 2]);
            }
            //debugger;
            //// legend popup data
            this.dynamicLegendPopupData = [];
            this.dynamicLegendPopupData.push(JSON.parse(rows[rows.length - 1]));
            //console.log(this.dynamicLegendPopupData);
            //this.legendPopupData = this.dynamicLegendPopupData;
            //debugger;
            rows.pop();
            rows.pop();
            this.BindMapDetails(rows);//susheel

            if (this.usePredefinedConfig == 'ON') {
              //console.log('no audio count');
              //console.log(this.NoAudioPolqa_OnePoinOne.length);
              //console.log(this.totalNoAudioScore);
              debugger;
              if (checkPolqaRecords) {
                this.dynamicPinLegends.push(
                  {
                    queryCount: this.totalNoAudioScore,
                    imgSrc: 'NoAudioPolqaMark',
                    resultType: 'POLQA',
                    thresholdType: '( NO AUDIO )',
                    pinType: '',
                    condVal: 'POLQA MOS <= 1.1',//susheel
                    noOfRows: this.totalNoAudioScore,
                    MarkerPinType: 'NoAudioPolqaMark',
                    iconText: 'X',
                    iconBGColor: 'Red',
                    iconFontColor: 'Black',
                    dynamicBubbleClass: ''//
                  }
                );
              }
            }///end if


          }
        }
        else {
          this.markers = [];
          this.markerCollection = [];
        }
        this.Loading = "";
        this.isLoading = false;

      }
      catch (ex) {
        this.Loading = "";
        this.isLoading = false;
        this.EmptyBindGMap();
      }


    });

    ////// start handle genral filter for cloumn filter
    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (this.delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });
      //console.log(this.genArrDel)
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }

    ////// end handle genral filter for cloumn filter

  }
  //////////////////////////////// end get map config byID


  /////////////////////////// Start Initialize Map From old webviewer function
  Initialize(latlngValMain, timestampTypeMain, outputGPS) {//provides array of locations
    debugger;
    //this.cd.detectChanges();
    this.latlngValMainAgain = latlngValMain;
    this.infowindowArray = [];
    this.markerPositions = [];
    this.NoAudioPolqa_OnePoinOne = [];
    this.totalNoAudioScore = 0;

    var arrPolys = 0;///selectedRegConfigApply(1, map);//Draw polygons commented by elumalai
    //if (this.modelRegName != "") {
    //  this.GetMapRegionDetail(this.modelRegName);
    //}

    //this.map = new google.maps.Map(document.getElementById('map'), {
    //  //center: { lat: 20.593684, lng: 78.96288 }, /// India
    //  center: { lat: 40.4230, lng: -98.7372 }, /// USA
    //  zoom: 4
    //});

    ////ZOOM LIMIT
    ////Changes zoom levels when the projection is available.
    //google.maps.event.addListenerOnce(map, "projection_changed", function () {
    //  map.setMapTypeId(google.maps.MapTypeId.HYBRID);  //Changes the MapTypeId in short time.
    //  setZoomLimit(map, google.maps.MapTypeId.ROADMAP);
    //  setZoomLimit(map, google.maps.MapTypeId.HYBRID);
    //  setZoomLimit(map, google.maps.MapTypeId.SATELLITE);
    //  setZoomLimit(map, google.maps.MapTypeId.TERRAIN);
    //  map.setMapTypeId(google.maps.MapTypeId.ROADMAP);  //Sets the MapTypeId to original.
    //});


    /////////Get zoom and position
    //google.maps.event.addListener(map, "bounds_changed", function () {
    //  document.getElementById("boundHid").value = latlngZoomCenter;
    //  document.getElementById("zoomHid").value = map.getZoom();
    //  var bounds = map.getBounds();

    //});


    ////////Set marker position to center when Zoom changed
    //google.maps.event.addListener(map, "zoom_changed", function () {
    //  map.setCenter(latlngZoomCenter);
    //  if (map.getZoom() == 3)
    //    map.setCenter(new google.maps.LatLng(40.4230, -98.7372));
    //});

    //codeLatLng('N39º08\'36\'\' W077º12\'57\'\'');
    //let rsltTypeEach = new Array();
    this.rsltTypeEach = new Array();
    //debugger
    //console.log(latlngValMain)
    var loopcnt = 0
    var loopInterval = 1000;
    this.count = 0;

    let iconZIndex = 1;
    //console.log(new Date())
    for (var varLatLong = 0; varLatLong < latlngValMain.length; varLatLong++)//add marker for each location
    {
      loopcnt = varLatLong;
      //if (latlngValMain.length > 1000 && loopcnt == loopInterval) {
      //  setTimeout(() => {
      //    //// delay map binding by 5 secs for large data
      //  }, 15000);
      //  loopInterval = loopInterval + 1000;
      //}

      this.pinMarker = new marker();

      if (latlngValMain[varLatLong] != null) {
        if (latlngValMain[varLatLong].length > 0) {

          /////to set zindex based on pass/fail/testfail icon
          if (latlngValMain[varLatLong].includes('- PASS')) {
            iconZIndex = 1;
          }
          else if (latlngValMain[varLatLong].includes('- FAIL')) {
            iconZIndex = -1;
          }
          else if (latlngValMain[varLatLong].includes('- TEST')) {
            /// - TEST FAILED
            iconZIndex = -2;
          }

          var latlngValMainSplit = latlngValMain[varLatLong].split("^");// split to seperate orig value - Co-or^Rslt^Device ID#DateTime^(imgPath#Thresh-Params/VQLoc/VQPhID/CallEvents-COND button)^Threshold Type^RSLT btn
          //console.log(latlngValMainSplit)// - susheel
          if (latlngValMainSplit[0].length > 0)//check for NULL latlong
          {

            var typeNameMain = latlngValMainSplit[1].indexOf('_') != -1 ? (latlngValMainSplit[1].split('_'))[0] : latlngValMainSplit[1];//Type of result
            var typeName = latlngValMainSplit[1].indexOf('_') != -1 ? (latlngValMainSplit[1].split('_'))[0] : latlngValMainSplit[1];//Type of result
            if (typeName == 'VQUAD')
              typeName = 'CALL EVENTS';
            else if (typeName == 'TDM')
              typeName = 'Audio and Delay';
            else if (typeName.indexOf('GENERAL') != -1)
              typeName = typeName.replace('GENERAL', 'PHONEINFO');
            else if (typeName.indexOf('VQT') != -1)
              typeName = typeName.replace('VQT', 'PESQ');
            else if (typeName.indexOf('VQUADAPP') != -1)
              typeName = 'VQUAD NODE';
            else if (typeName.indexOf('MOBILEAPP') != -1)
              typeName = 'MOBILE';

            this.rsltTypeEach[this.count] = latlngValMainSplit[1].indexOf('_') != -1 ? (latlngValMainSplit[1].split('_'))[1] : latlngValMainSplit[1];//add results into results array

            var TSPhID = "";
            if (latlngValMainSplit.length > 2)
              TSPhID = latlngValMainSplit[2];//Device ID#Timestamp

            var pinImgSrc = "";
            var PolqaScore = "";

            if (latlngValMainSplit.length > 3) {
              if (typeName == "POLQA") {
                //debugger;
                //pinImgSrc = "$" + (latlngValMainSplit[3].split("$"))[1];
                ///// below code by elumalai as per requirement that POLQA_Score below 1.1 including 0 and N/A is needed to show as "No Audio" marker pin
                if (this.mapConfigID > 0 && this.usePredefinedConfig == "ON") {
                  PolqaScore = latlngValMainSplit[2].split('#')[4];
                  pinImgSrc = ""; //(latlngValMainSplit[3].split("@"))[0];
                  if (Number(PolqaScore) <= this.NoAudioScoreCondition)
                    this.NoAudioPolqa_OnePoinOne.push(PolqaScore);
                  else
                    pinImgSrc = (latlngValMainSplit[3].split("@"))[0];
                }
                else {
                  ////// default mapping                  
                  PolqaScore = (latlngValMainSplit[3].split("$"))[0];
                  pinImgSrc = "";
                  if (Number(PolqaScore) <= this.NoAudioScoreCondition)
                    this.NoAudioPolqa_OnePoinOne.push(PolqaScore);
                }
                //if (Number(PolqaScore) < this.NoAudioScoreCondition)
                //  this.NoAudioPolqa_OnePoinOne.push(PolqaScore);

              }
              else
                pinImgSrc = (latlngValMainSplit[3].split("@"))[0];//imgSrcMain+Param + (@COND btn - not required)

            }
            ////alert(pinImgSrc);   
            var rsltBtn = "";
            var rsltHead = "";
            var rsltVals = "";
            var ThresholdType = "";

            if (latlngValMainSplit.length == 5)//RSLT btn for other than Threshold(because no Pass/Fail val in split) 
            {
              rsltVals = (latlngValMainSplit[4].split('@'))[1];
              rsltHead = (latlngValMainSplit[4].split('@'))[0];
            }
            else if (latlngValMainSplit.length == 6)//RSLT btn for Threshold   
            {
              if (latlngValMainSplit[4].indexOf("PASS") != -1)
                ThresholdType = "PASS";
              else if (latlngValMainSplit[4].indexOf("FAILED") != -1)
                ThresholdType = "TEST FAILED";
              else if (latlngValMainSplit[4].indexOf("FAIL") != -1)
                ThresholdType = "FAIL";
              typeName = typeName + latlngValMainSplit[4];// add pass / fail to rsltType  
              rsltVals = (latlngValMainSplit[5].split('@'))[1];
              rsltHead = (latlngValMainSplit[5].split('@'))[0];
            }
            //rsltVals = rsltVals.replace(/\'/g,"&#39;");   
            //rsltVals = rsltVals.replace(/º/g,"&#176;");
            if (latlngValMainSplit.length > 4) {
              rsltVals = rsltVals.replace(/\s/g, "&nbsp;");
              rsltBtn = rsltHead + "@" + rsltVals + '\"); class=popupButton>Result Display</button></p>';
            }

            //rsltBtn = rsltBtn.replace(/\'/g,"&#39;");   
            //rsltBtn = rsltBtn.replace(/º/g,"&#176;");
            ////alert(rsltBtn);
            var startLatLang = "0,0,";
            var endLatLang = latlngValMainSplit[0];

            //French
            if (endLatLang.split(",").length > 3) {
              var arrGPS = endLatLang.split(",");
              endLatLang = "";
              for (var x = 0; x < arrGPS.length; x++) {
                var delim = ",";
                if (x % 2 == 0 && x < 3)
                  delim = ".";
                endLatLang += arrGPS[x] + delim;
              }
              if (endLatLang != "")
                endLatLang = endLatLang.substring(0, endLatLang.length - 1);
            }

            var routeColor;
            if (latlngValMainSplit[0].indexOf("@") != -1) {//start information
              startLatLang = (latlngValMainSplit[0].split("@"))[1].trim();
              endLatLang = (latlngValMainSplit[0].split("@"))[0];
              routeColor = (latlngValMainSplit[0].split("@"))[2].trim();
            }
            //debugger;
            /////// to get result id from each array item to pass in popup model


            if (this.usePredefinedConfig == "ON") {
              //console.log(rsltVals.split('!')[0]);
              rsltVals = rsltVals != "" ? rsltVals.split('!')[0] : latlngValMain[varLatLong].split('$')[1]; //rsltVals.split('!')[0];
            }
            else
              rsltVals = latlngValMain[varLatLong].split('$')[1];
            //debugger;
            this.CodeLatLng(endLatLang, typeNameMain, this.count, endLatLang, TSPhID, pinImgSrc, rsltBtn, ThresholdType, startLatLang, routeColor, arrPolys, timestampTypeMain, outputGPS, rsltVals, iconZIndex, PolqaScore);//end GPS location, result-type, coutVal, again end GPS, PhID+TS, ImgPath+Params+COND btn, RSLT btn, start GPS
            this.count++;
          }
        }
      }
      //if (varLatLong == latlngValMain.length - 1) {

      //  ////alert(latlngValMain.length);
      //  ///lat = 12.9264;// 42.536652;//39.143 ///12.9264;
      //  ///lng = 77.6012;//
      //  const bounds: LatLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(startLatLang, endLatLang));
      //  this.updateMarkers(bounds);
      //}
    }
    //console.log(new Date())
    //console.log(this.markers)// - susheel
    //this.cd.detectChanges();
    //debugger;
    ////alert(this.markerPositions.length);

    this.initialLoad = true;
    if (!this.loadOldGoogleMap) {
      if (this.markerPositions.length > 5000) {
        if (confirm("This operation involves plotting more than 5000 marker pins, which may take some time. Do you want to proceed or cancel?"))
          this.JsMapInitilization_Optimize();
        else
          this.EmptyBindGMap();
      }
      else
        this.JsMapInitilization();
    }
    else
      this.JsMapInitilization_OGCode();


    if (this.markerPositions.length > 0) {
      debugger;
      this.totalNoAudioScore = 0;
      if (this.NoAudioPolqa_OnePoinOne.length > 0) {
        this.totalNoAudioScore = this.NoAudioPolqa_OnePoinOne.length;
        if (this.pinLegends.length > 0) {
          this.pinLegends[9] = this.pinLegends[9] - this.totalNoAudioScore; ///// this.pinLegends[9] = POLQA
        }
      }
    }

  }
  //else {
  //  __doPostBack("btnRefresh", "OnClick");
  //}
  // end of initialize function

  CodeLatLng(latlngVal, rsltType, myCount, LatLongOrig1, TimeStamp, NewImgSrc, FinalRsltBtn, ThresholdType, startLatLang, routeColor, arrPolys, timestampTypeMain, outputGPS, rsltVals, iconZIndex, PolqaScore) {

    //loc, result type, count val, GPS Co-orditanes, PhID+TS, Image path+Params+COND btn, RSLT btn, start GPS
    //console.log(latlngVal + "," + rsltType + "," + myCount + "," + LatLongOrig1 + "," + TimeStamp + "," + NewImgSrc + "," + FinalRsltBtn + "," + ThresholdType + "," + startLatLang);

    //if (ThresholdType != "") // susheel
    //debugger

    var input = latlngVal;
    var NewTS = TimeStamp.split('#'); //Split Phone ID and TS
    NewImgSrc = NewImgSrc.replace('Call Control Event</font>', 'Call Control Event&nbsp;</font>')
    var extrSpacesThreshold = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
    if (NewTS[2] == "DUMMY")
      extrSpacesThreshold = "&nbsp;"
    if (ThresholdType.length > 0)
      ThresholdType = "<div><font face='verdana' style='color:blue'>THRESHOLD</font> " + extrSpacesThreshold + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + ThresholdType + "</div>";

    if (input.length > 0) {
      var latlngStr = input.split(',', 3); //GPS co-or
      var latConvert = latlngStr[0].length > 0 ? latlngStr[0] : "0";
      var lngConvert = latlngStr[1].length > 0 ? latlngStr[1] : "0";
      var displayEndGPS = latlngStr[2];

      var startlatlngStr = startLatLang.split(',', 3); //start GPS co-or
      var startlatConvert = startlatlngStr[0].length > 0 ? startlatlngStr[0] : "0";
      var startlngConvert = startlatlngStr[1].length > 0 ? startlatlngStr[1] : "0";

      if (latConvert == "0" && lngConvert == "0")//check for 0 latlong
      {
        this.count--;
        return;
      }


      var splitNewImg = NewImgSrc.split("#"); //Pin img path + Params + COND btn
      if (displayEndGPS == "NONE")
        displayEndGPS = LatLongOrig1.replace(',NONE', '');
      var latDecimalSpaces = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";//20
      var lngDecimalSpaces = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";//16
      if (outputGPS == 0) {
        var newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + displayEndGPS + "</div>"; //End GPS Loc
        if ((startlatConvert + "," + startlngConvert) != "0,0" && startlatlngStr[2] != displayEndGPS)
          newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "Device GPS (Start)</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + startlatlngStr[2] + "</div>" + newLatLongOrig1.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'Device GPS (End)</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'); //Start and End GPS Loc
        if (NewImgSrc.length > 0)//new info added
          newLatLongOrig1 = splitNewImg[1] + newLatLongOrig1; //(Params + COND btn) + GPS Loc + RSLT btn
        this.LatLongOriginal[this.count] = newLatLongOrig1; //GPS InfoBubble
      }
      else {
        var newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "Latitude</font> " + latDecimalSpaces + " " + latConvert + "</div>"; //End GPS Lat
        newLatLongOrig1 += "<div><font face='verdana' style='color:blue'>" + "Longitude</font> " + lngDecimalSpaces + " " + lngConvert + "</div>"; //End GPS Long
        if ((startlatConvert + "," + startlngConvert) != "0,0" && startlatlngStr[2] != displayEndGPS)
          newLatLongOrig1 = "<div><font face='verdana' style='color:blue'>" + "Device Latitude (Start)</font> " + latDecimalSpaces + " " + startlatConvert + "</div>"
            + "<div><font face='verdana' style='color:blue'>" + "Device Longitude (Start)</font> " + lngDecimalSpaces + " " + startlngConvert + "</div>"
            + newLatLongOrig1.replace('Latitude</font> ' + latDecimalSpaces, 'Device Latitude (End)</font> ' + latDecimalSpaces).replace('Longitude</font> ' + lngDecimalSpaces, 'Device Longitude (End)</font> ' + lngDecimalSpaces); //Start and End GPS Loc
        if (NewImgSrc.length > 0)//new info added
          newLatLongOrig1 = splitNewImg[1] + newLatLongOrig1; //(Params + COND btn) + GPS Loc + RSLT btn
        this.LatLongOriginal[this.count] = newLatLongOrig1; //GPS InfoBubble
      }
      //debugger;
      var lat = parseFloat(latConvert);
      var lng = parseFloat(lngConvert);
      var ImgRslt = "Yellow";
      var rsltTypePopUp = "pesq";
      var timestampNameRsltType = timestampTypeMain;//"VQuad ";

      if (timestampNameRsltType == "VQT " && rsltType != "VQT" && rsltType != "POLQA")
        timestampNameRsltType = "VQuad ";

      if (rsltType == "VQT" || rsltType == "POLQA") {

        ImgRslt = "Yellow";
        if (PolqaScore == "N/A" || (Number(PolqaScore) <= this.NoAudioScoreCondition))
          ImgRslt = "NoAudio"; ////for polqa score <=1.1

        if (rsltType == "POLQA")
          rsltTypePopUp = "polqa";
      }
      else {
        ////commented as dont know the purpose of it - Elumalai
        //if (timestampNameRsltType == "VQT ")
        //  timestampNameRsltType = "VQuad ";


        rsltTypePopUp = rsltType.toLowerCase();
        if (rsltType.indexOf("VQUAD") != -1 || rsltType.indexOf("TDM") != -1 || rsltType.indexOf("RTD") != -1 || rsltType.indexOf("SNR") != -1 || rsltType.indexOf("OWD") != -1 || rsltType.indexOf("PDD") != -1) {
          ImgRslt = "Green";
          rsltTypePopUp = "audio-delay";
          if (rsltType.indexOf("VQUAD") != -1)
            rsltTypePopUp = "call-events";
          //////below condition should set rsltTypePopUp = "call-events"; for snr-error,rtd-error,pdd-error,owd-error so that it point to callevent screen for display result button click //elumalai
          if (rsltType.indexOf("-ERROR") != -1 && (rsltType.indexOf("TDM") == -1))
            rsltTypePopUp = "call-events";
        }
        else if (rsltType == "VBA")
          ImgRslt = "Pink";
        else if (rsltType == "EMU")
          ImgRslt = "Orange";
        //else if (rsltType == "POLQA")
        //    ImgRslt = "Red";
        else if (rsltType.indexOf("FAX") != -1)
          ImgRslt = "Black";
        else if (rsltType.indexOf("VAC") != -1) {
          ImgRslt = "Purple";
          timestampNameRsltType = "Device ";
        }
        else if (rsltType == "CONNDROP") {
          ImgRslt = "Red";
          timestampNameRsltType = "Device ";
        }
        else if (rsltType.indexOf("GENERAL") != -1 || rsltType.indexOf("SIM") != -1 || rsltType.indexOf("UE") != -1) {
          ImgRslt = "GreenNew";
          timestampNameRsltType = "Device ";
          rsltTypePopUp = "mobileinfo-" + rsltType;
        }
        else//NetTest
        {
          ImgRslt = "Blue";
          timestampNameRsltType = "Device ";
          rsltTypePopUp = "nettest-" + rsltType;
        }
      }

      if (rsltType.indexOf("-FAIL") != -1)
        ImgRslt = "Red";
      //debugger;
      var image = './assets/images/Marks/' + ImgRslt + 'Mark.png';

      if (rsltType.indexOf("-ERROR") != -1 && rsltType.indexOf("FAX") != -1) {
        image = 'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|E|000000|FFFFFF';
        rsltTypePopUp = "fax";
      }
      else if (rsltType.indexOf("-ERROR") != -1 && (rsltType.indexOf("VQUAD") != -1 || rsltType.indexOf("RTD") != -1 || rsltType.indexOf("SNR") != -1 || rsltType.indexOf("OWD") != -1 || rsltType.indexOf("PDD") != -1)) {
        image = 'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|E|009900|000000';
        rsltTypePopUp = "audio-delay";
        if (rsltType.indexOf("VQUAD") != -1)
          rsltTypePopUp = "call-events";
        //////below condition should set rsltTypePopUp = "call-events"; for snr-error,rtd-error,pdd-error,owd-error so that it point to callevent screen for display result button click //elumalai
        if (rsltType.indexOf("-ERROR") != -1 && (rsltType.indexOf("FAX") == -1))
          rsltTypePopUp = "call-events";
      }
      else if (rsltType.indexOf("-FAIL") != -1) {
        image = 'https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|F|BC1E1E|000000';
        if (rsltType.indexOf("VAC") != -1)
          rsltTypePopUp = "vac";
        else if (rsltType.indexOf("GENERAL") != -1 || rsltType.indexOf("SIM") != -1 || rsltType.indexOf("UE") != -1)
          rsltTypePopUp = "mobileinfo-" + (rsltType.split('-'))[0];
        else
          rsltTypePopUp = "nettest-" + (rsltType.split('-'))[0];
      }

      //for image size vary dynamically based on pin / bubble
      var widthImg = 24;
      var heightImg = 30;

      //for mobile and vquad status
      if (rsltType.indexOf("VMOBILEAPP") != -1) {
        //debugger;
        widthImg = 40;
        heightImg = 25;
        image = './assets/images/Marks/Apps/' + (rsltType.split("-"))[1] + '.png';
        rsltTypePopUp = "vmobileapp";
      }
      else if (rsltType.indexOf("MOBILEAPP") != -1) {
        image = './assets/images/Marks/Apps/' + (rsltType.split("-"))[1] + '.png';
        rsltTypePopUp = "mobileapp";
      }
      else if (rsltType.indexOf("VQUADAPP") != -1) {
        widthImg = 40;
        heightImg = 25;
        image = './assets/images/Marks/Apps/' + (rsltType.split("-"))[1] + '.png';
        rsltTypePopUp = "vquadapp";
      }
      if (NewImgSrc.length > 0)//new image
        image = splitNewImg[0];

      //console.log(image);
      /////// start new code elumalai bind lat lng to marker array
      //this.pinMarker = new marker();
      this.pinMarker.lat = lat.toString();
      this.pinMarker.lng = lng.toString();
      this.pinMarker.label = "";//(rsltType.split("-"))[1];
      this.pinMarker.iconurl = image; //this.iurl_b;
      this.pinMarker.widthImg = widthImg;//susheel
      this.pinMarker.heightImg = heightImg;
      this.pinMarker.resultType = rsltType.replace("GENERAL", "PHONEINFO");//susheel
      this.pinMarker.popUpRsltType = rsltTypePopUp;
      this.pinMarker.itemID = rsltVals;
      this.pinMarker.lat_num = lat;
      this.pinMarker.lng_num = lng;
      this.pinMarker.iconZIndex = iconZIndex;

      this.markers.push(this.pinMarker); ///commented by elumalai for performance purpose

      //this.markerCollection.push(this.pinMarker);  //elumalai for boundchange event 
      this.markerPositions.push(this.pinMarker);


      var lat_lng_mine = new Array();
      //https://roufid.com/angular-uncaught-referenceerror-google-not-defined/ - refer to region config component getloc 
      //https://www.digitalocean.com/community/tutorials/angular-angular-google-maps
      //https://stackoverflow.com/questions/47198904/angular-google-is-not-defined
      // this.mapsAPILoader.load().then(() => {// - susheel //commented by elumalai

      var latlngNewMain = new google.maps.LatLng(lat, lng);

      // this.markerPositions.push(this.pinMarker);//this.markerPositions.push(latlngNewMain);


      var startlatlngNewMain = new google.maps.LatLng(parseFloat(startlatConvert), parseFloat(startlngConvert));
      lat_lng_mine.push(startlatlngNewMain);//start
      lat_lng_mine.push(latlngNewMain);//end


      if ((startlatConvert + "," + startlngConvert) != "0,0" && (latConvert + "," + lngConvert) != "0,0" && (startlatlngStr[2] != displayEndGPS))
        this.routeLatLng.push({ origin: startlatlngNewMain, destination: latlngNewMain, color: routeColor, lat_lng_combine: lat_lng_mine });// to draw followpath route by elumalai


      //this.cd.detectChanges();
      //});



      var resu = "Loading...";
      var finalResu = resu;
      //map.setZoom(myZoom);

      //set and open windows
      var TSandPhID = "";
      if (TimeStamp.length > 0) {
        let extraSpaceDevice = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        let extraSpacecallid = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        var phoneIDHead = "VQuad Device ID&nbsp;";
        var locHead = "VQuad Call ID&nbsp;&nbsp;";
        var extrSpaceVQuadTS = "";
        var infoWindowWidth = 300;
        var VQuadNodeSpaces = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        var VQuadNodeGPSSpaces = this.LatLongOriginal[myCount];
        var phoneIDValue = NewTS[0];
        var locValue = NewTS[1];
        if (NewTS[2].indexOf('IGNORETS') != 0) {
          if (timestampNameRsltType == "Device ") {
            extrSpaceVQuadTS = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
            infoWindowWidth = 400;
            phoneIDHead += extrSpaceVQuadTS.replace(extrSpaceVQuadTS, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
            locHead += extrSpaceVQuadTS.replace(extrSpaceVQuadTS, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
            TSandPhID = "<div><font face='verdana' style='color:blue'>" + timestampNameRsltType + "Timestamp (Start)</font> &nbsp;" + NewTS[2] + "</div>";
            TSandPhID += "<div><font face='verdana' style='color:blue'>" + timestampNameRsltType + "Timestamp (End)</font> &nbsp;&nbsp;&nbsp;&nbsp;" + NewTS[3] + "</div>";
            if (VQuadNodeGPSSpaces !== undefined) {
              VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('PARAMETERS</font> &nbsp;', 'PARAMETERS</font> ' + extrSpaceVQuadTS);
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'VQuad GPS</font> ' + extrSpaceVQuadTS + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Latitude</font> ' + extrSpaceVQuadTS + latDecimalSpaces);
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Longitude</font> ' + extrSpaceVQuadTS + lngDecimalSpaces);
              }
            }
          }
          else {
            var endTS = NewTS[2];
            if (NewTS[2] == "DUMMY")
              endTS = NewTS[3];
            extrSpaceVQuadTS = "&nbsp;";
            let extraSpaceTS = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
            /////Renaming all VQuad included columns to generic for both VQuad and vMobile
            //TSandPhID = "<div><font face='verdana' style='color:blue'>" + timestampNameRsltType + "Timestamp1</font> &nbsp;" + endTS + "</div>";
            TSandPhID = "<div><font face='verdana' style='color:blue'>" + "Timestamp" + extraSpaceTS + "</font> &nbsp;" + endTS + "</div>";
            //console.log(timestampNameRsltType); console.log('*');

            if (VQuadNodeGPSSpaces !== undefined) {
              VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('PARAMETERS</font> &nbsp;', 'PARAMETERS</font> ' + extrSpaceVQuadTS);
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'VQuad GPS</font> ' + extrSpaceVQuadTS + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Latitude</font> ' + extrSpaceVQuadTS + latDecimalSpaces);
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Longitude</font> ' + extrSpaceVQuadTS + lngDecimalSpaces);
              }
            }
          }
          TSandPhID += ThresholdType;
          phoneIDValue = "&nbsp;" + phoneIDValue;
        }
        else if (NewTS[2].indexOf('IGNORETS') == 0)//VQuad Or Mobile App or VMobile
        {
          FinalRsltBtn = (NewTS[2].split("-"))[2];
          if (NewTS[2].indexOf('-VQUAD') != -1 || NewTS[2].indexOf('-VMOBILE') != -1)//VQUAD
          {
            phoneIDHead = "IP Address";
            locHead = "Node Name";
            phoneIDValue = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + phoneIDValue;
            //locValue = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + locValue;
            VQuadNodeSpaces = "";
            finalResu = resu.replace(/<br\/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/g, '<br/>');//have to be done only once
            if (VQuadNodeGPSSpaces !== undefined) {
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'VQuad GPS</font> ');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Latitude &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> ');
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Longitude &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> ');
              }
            }
          }
          else//MOBILE
          {
            locValue = (locValue.split("-"))[1];
            phoneIDHead = "Device PhoneID&nbsp;&nbsp;&nbsp;";
            locHead = "Device Name&nbsp;";
            locValue = "&nbsp;&nbsp;" + locValue;
            if (VQuadNodeGPSSpaces !== undefined) {
              if (outputGPS == 0) {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('VQuad GPS</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', 'Device GPS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> ');
              }
              else {
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Latitude</font> ' + latDecimalSpaces, 'Device Latitude' + '&nbsp;&nbsp;&nbsp;&nbsp;' + '</font> ');
                VQuadNodeGPSSpaces = VQuadNodeGPSSpaces.replace('Longitude</font> ' + lngDecimalSpaces, 'Device Longitude' + '&nbsp;&nbsp;' + '</font> ');
              }
            }
          }
        }
        if (NewTS[0] != "IGNOREDEVICE")
          TSandPhID += "<div><font face='verdana' style='color:blue'>" + phoneIDHead + "</font> &nbsp;" + phoneIDValue + "</div>";
        if (NewTS[1] != "IGNORELOCATION")
          TSandPhID += "<div><font face='verdana' style='color:blue'>" + locHead + "</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + locValue + "</div>";

        if (NewTS[4] != undefined && NewTS[4].indexOf('Result Display') != -1)
          FinalRsltBtn = NewTS[4];
      }
      //debugger;
      var substrResu = finalResu.substring(0, finalResu.indexOf("<br/>&nbsp;"));
      var chkWidthResu = infoWindowWidth;
      if (substrResu.length > 30)
        chkWidthResu = infoWindowWidth + (substrResu.length - 30) * 10;

      let infowindowPopupButton = "";
      if (this.pinMarker.resultType.includes('APP') && !this.pinMarker.resultType.toLowerCase().includes("mobile"))
        infowindowPopupButton = "<button type='button' style='cursor: pointer;color: white;font-size: 10px;font-weight: bold;font-family: Verdana;background-color: #6D96D6;padding-left: 3px;padding-right: 3px;' id='OpenStatusDialog' value=" + this.pinMarker.itemID + "," + this.pinMarker.resultType + " onclick=OpenStatusDialog(" + this.pinMarker.itemID + "," + this.pinMarker.resultType + ");>Status Display</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button style='cursor: pointer;color: white;font-size: 10px;font-weight: bold;font-family: Verdana;background-color: #6D96D6;padding-left: 3px;padding-right: 3px;'  id='bluetooth' type='button'>Bluetooth</button>";
      else if (this.pinMarker.resultType.toLowerCase().includes("mobile")) {
        infowindowPopupButton = "<button type='button' style='cursor: pointer;color: white;font-size: 10px;font-weight: bold;font-family: Verdana;background-color: #6D96D6;padding-left: 3px;padding-right: 3px;' id='OpenStatusDialog' value=" + this.pinMarker.itemID + "," + this.pinMarker.popUpRsltType + " >Status Display</button>";
      }
      else
        infowindowPopupButton = "<button type='button' style='cursor: pointer;color: white;font-size: 10px;font-weight: bold;font-family: Verdana;background-color: #6D96D6;padding-left: 3px;padding-right: 3px;' id='OpenBasicDialog' value=" + this.pinMarker.itemID + "," + this.pinMarker.popUpRsltType + " >Results Display</button>";

      this.infowindowArray.push(rsltVals + "@<div style='width: " + chkWidthResu + "px; overflow: hidden;'><div><font face='verdana' style='color:blue'>RESULT</font> " + extrSpaceVQuadTS + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + VQuadNodeSpaces + this.rsltTypeEach[myCount].replace('TDM', 'Audio and Delay') + "</div>" + TSandPhID + VQuadNodeGPSSpaces + "<div><font face='verdana' style='color:blue'>LOCATION</font> " + extrSpaceVQuadTS + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + VQuadNodeSpaces + finalResu + "</div>" + "</div><br/>" + infowindowPopupButton);

      //console.log(rsltType + rsltVals);
      //console.log("modified");
      //console.log(rsltTypePopUp);
      //console.log("**********");

      //this.pinMarker.itemID = rsltVals;
      //this.markers.push(this.pinMarker); ///commented by elumalai for performance purpose
      // this.markerCollection.push(this.pinMarker);  //elumalai for boundchange event

    } //end return 

    ////// commeneted by elumalai drawroute
    if ((startlatConvert + "," + startlngConvert) != "0,0" && (latConvert + "," + lngConvert) != "0,0" && (startlatlngStr[2] != displayEndGPS)) {
      //console.log('route count');

      this.DrawMapRoute(lat_lng_mine, routeColor);//this.DrawMapRoute(lat_lng_mine, routeColor);
    }
    //this.cd.detectChanges();
  }// end of codelatlng function N12º55'35'' E77º36'04''

  /////////////////////////// End Initialize Map From old webviewer function


  /////////////////////////// Start Draw Route
  onMapReady(map: any) {
    //console.log(map);

    //const bounds: LatLngBounds = new google.maps.LatLngBounds();
    //for (const mm of this.markers) {
    //  bounds.extend(new google.maps.LatLng(mm.lat, mm.lng));
    //}
    //map.fitBounds(bounds);



    //const bounds: LatLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(this.lat, this.lng));
    // this.updateMarkers(bounds);
    //// dragend  idle
    //map.addListener("idle", this.updateMarkers(bounds));
    //this.map.addListener("idle", function () {
    //  //do what you want

    //});



    this.map = map;
    //this.DrawMapRoute();
  }

  DrawRouteOnOff() {
    if (this.DrawRoute == "ON")
      this.DrawMapRoute_JSMap();
    else {
      this.ClearDirect();//this.ClearDrawRoute('');
      this.ClearRoad();
    }
  }

  DrawMapRoute(lat_lng, routeColor) {
    // DrawMapRoute() {
    //debugger;
    if (this.DrawRoute == "OFF")
      return;

    //var lineSymbol = {
    //  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    //};

    if (this.DrawLine == "1") { ///Draw short parabola route or Plane/sea routes

      //const flightPlanCoordinates = [
      //  { lat: this.lat1, lng: this.lng1 },
      //  //  { lat: this.lat1, lng: this.lng1},
      //  { lat: this.lat2, lng: this.lng2 },
      //];

      const line = new google.maps.Polyline({
        strokeOpacity: 0.5,
        path: lat_lng,  //[],
        map: this.map
      });

    }
    else {// //Draw road route in actual way google mentioned road ways
      if (this.routeLatLng.length > 0)
        this.showDrawRouteDirection = true
    }


  }

  /// draw lines along  with each pin marker plotted
  DrawMapRoute_JSMap1(lat_lng, routeColor) {
    // DrawMapRoute() {
    //debugger;
    if (this.DrawRoute == "OFF")
      return;

    //var lineSymbol = {
    //  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    //};

    const arrowSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      fillColor: 'red',
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 5
    };

    if (this.DrawLine == "1") { ///Draw short parabola route or Plane/sea routes

      const flightPlanCoordinates = [
        { lat: 12.971599, lng: 77.594563 },
        { lat: 12.29581, lng: 76.639381 },
        { lat: 11.410204, lng: 76.695032 },
      ];

      const flightPath = new google.maps.Polyline({
        path: flightPlanCoordinates,
        icons: [
          {
            icon: arrowSymbol,
            offset: "50%",
          },
        ],
        geodesic: true,
        strokeColor: routeColor,
        strokeOpacity: 1.0,
        strokeWeight: 2
        //map: this.map
      });

      flightPath.setMap(this.map);

    }
    else {// //Draw road route in actual way google mentioned road ways
      //debugger;
      if (this.routeLatLng.length > 0) {

        //Intialize the Path Array
        var path = new google.maps.MVCArray();

        //this.showDrawRouteDirection = true

        //Intialize the Direction Service
        var directionsServiceWaypoint = new google.maps.DirectionsService();
        //var directionsRendererwaypoint = new google.maps.DirectionsRenderer({
        //  polylineOptions: {
        //    strokeColor: 'blue',
        //    icons: [{
        //      icon: arrowSymbol,
        //      offset: '50%'
        //    }]
        //  },
        //});
        //directionsRendererwaypoint.setMap(this.map);

        //////const waypts = []; //const waypts:google.maps.DirectionsWaypoint[] = [];

        //////for (let i = 0; i < flightPlanCoordinates.length; i++) {
        //////  waypts.push({
        //////    location: new google.maps.LatLng(flightPlanCoordinates[i]),
        //////    stopover: true,
        //////  });
        //////}

        //////var wayPointRequest = {
        //////  origin: { lat: 12.971599, lng: 77.594563 },
        //////  destination: { lat: 11.410204, lng: 76.695032 },
        //////  waypoints: waypts,
        //////  optimizeWaypoints: true,
        //////  travelMode: 'DRIVING',
        //////};
        //////directionsServiceWaypoint.route(wayPointRequest, function (result, status) {
        //////  if (status == 'OK') {
        //////    directionsRendererwaypoint.setDirections(result);
        //////  }
        //////});//end  waypoint


        //Set the Path Stroke Color
        var poly = new google.maps.Polyline({
          map: this.map,
          icons: [{
            icon: arrowSymbol,
            offset: '50%'
          }],
          strokeColor: 'blue' ////routeColor
        });

        //Loop and Draw Path Route between the Points on MAP
        for (var i = 0; i < lat_lng.length; i++) {
          if ((i + 1) < lat_lng.length) {
            var src = lat_lng[i];//latlng1
            var des = lat_lng[i + 1];//latlng2
            path.push(src);
            poly.setPath(path);
            directionsServiceWaypoint.route({
              origin: src,
              destination: des,

              travelMode: google.maps.DirectionsTravelMode.DRIVING
            }, function (result, status) {
              if (status == google.maps.DirectionsStatus.OK) {
                for (var i = 0, len = result.routes[0].overview_path.length; i < len; i++) {
                  path.push(result.routes[0].overview_path[i]);
                }
              }
            });
          }
        } //end for loop

      }

    }


  }

  /////draw line after all pins are plotted
  DrawMapRoute_JSMap_OG() {
    ////alert(this.DrawLine);
    //debugger;

    if (this.DrawRoute == "OFF")
      return;

    //var lineSymbol = {
    //  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    //};

    const arrowSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
      //fillColor: 'red',
      //fillOpacity: 1,
      //strokeWeight: 0,
      //scale: 5
    };
    this.isLoading = true;
    if (this.DrawLine == "1") { ///Draw short parabola route or Plane/sea routes
      //debugger;
      //this.ClearDrawRoute('Road');
      this.ClearRoad();

      //const flightPlanCoordinates = [
      //  { lat: 12.971599, lng: 77.594563 },
      //  { lat: 12.29581, lng: 76.639381 },
      //  { lat: 11.410204, lng: 76.695032 },
      //];

      if (this.routeLatLng.length > 0) {
        for (let i = 0; i < this.routeLatLng.length; i++) {
          //console.log(this.routeLatLng[i].lat_lng_combine);

          const flightPath = new google.maps.Polyline({
            path: this.routeLatLng[i].lat_lng_combine,
            icons: [
              {
                icon: arrowSymbol,
                offset: "50%",
              },
            ],
            geodesic: true,
            strokeColor: this.routeLatLng[i].color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            optimized: false,
            //map: this.map
          });

          flightPath.setMap(this.map);
          this.DirectPolylines.push(flightPath);

          if (i == this.routeLatLng.length - 1)
            this.isLoading = false;
        }
      }
    }
    else {// //Draw road route in actual way google mentioned road ways
      ////alert('road');
      //debugger;
      //this.ClearDrawRoute('Direct');
      this.ClearDirect()

      if (this.routeLatLng.length > 0) {

        //Intialize the Path Array
        //var path = new google.maps.MVCArray();

        //this.showDrawRouteDirection = true

        //Intialize the Direction Service
        //var directionsServiceWaypoint = new google.maps.DirectionsService();
        //for (var k = 0; k < this.routeLatLng.length; k++) {
        //  console.log(this.routeLatLng[k].lat_lng_combine[0]);
        //  console.log(this.routeLatLng[k].lat_lng_combine[1]);
        //  console.log('****************************');
        //}

        for (var j = 0; j < this.routeLatLng.length; j++) {
          //for (var j = 0; j < 100; j++) {
          const directionsServiceWaypoint = new google.maps.DirectionsService();
          const directionsRendererwaypoint = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
            preserveViewport: true,
            polylineOptions: {
              strokeColor: this.routeLatLng[j].color,
              icons: [{
                icon: arrowSymbol,
                offset: '50%'
              }]
            },
            map: this.map
          });


          //directionsRendererwaypoint.setMap(this.map);
          this.followRoadRoute.push(directionsRendererwaypoint);
          //debugger;
          let wayPointRequest = {
            //origin: this.routeLatLng[j].lat_lng_combine[0],//{ lat: 12.971599, lng: 77.594563 },
            //destination: this.routeLatLng[j].lat_lng_combine[1], //{ lat: 11.410204, lng: 76.695032 },
            origin: this.routeLatLng[j].origin,//{ lat: 12.971599, lng: 77.594563 },
            destination: this.routeLatLng[j].destination, //{ lat: 11.410204, lng: 76.695032 },
            // waypoints: waypts,
            //optimizeWaypoints: true,
            travelMode: 'DRIVING',
          };
          directionsServiceWaypoint.route(wayPointRequest, function (result, status) {
            if (status == 'OK') {
              //debugger;
              //console.log(j);
              directionsRendererwaypoint.setDirections(result);
              directionsRendererwaypoint.setOptions({ visible: true });
            }
            else {
              // Log the error
              console.log('Directions request failed:', status);
              // Retry the request after a delay (e.g., 1 second)
              //setTimeout(DrawMapRoute_JSMap, 1000);
              //setTimeout(() => {
              //  debugger;
              //  this.DrawMapRoute_JSMap();
              //}, 1000);

            }
          });//end  waypoint

          if (j == this.routeLatLng.length - 1)
            this.isLoading = false;


          //setTimeout(() => {
          //      debugger;                
          //    }, 1000);

        }//end for loop

      }///end check if routeLatLng > 0

      this.isLoading = false;
    }


  }

  DrawMapRoute_JSMap() {
    ////alert(this.DrawLine);
    //debugger;

    if (this.DrawRoute == "OFF")
      return;

    //var lineSymbol = {
    //  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    //};

    const arrowSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
      //fillColor: 'red',
      //fillOpacity: 1,
      //strokeWeight: 0,
      //scale: 5
    };
    this.isLoading = true;
    if (this.DrawLine == "1") { ///Draw short parabola route or Plane/sea routes
      //debugger;
      ////alert('direct');
      //this.ClearDrawRoute('Road');
      this.stopFollowRoadRoute = true;
      this.ClearRoad();

      //const flightPlanCoordinates = [
      //  { lat: 12.971599, lng: 77.594563 },
      //  { lat: 12.29581, lng: 76.639381 },
      //  { lat: 11.410204, lng: 76.695032 },
      //];

      if (this.routeLatLng.length > 0) {
        for (let i = 0; i < this.routeLatLng.length; i++) {
          //console.log(this.routeLatLng[i].lat_lng_combine);

          const flightPath = new google.maps.Polyline({
            path: this.routeLatLng[i].lat_lng_combine,
            icons: [
              {
                icon: arrowSymbol,
                offset: "50%",
              },
            ],
            geodesic: true,
            strokeColor: this.routeLatLng[i].color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            optimized: false,
            //map: this.map
          });

          flightPath.setMap(this.map);
          this.DirectPolylines.push(flightPath);

          if (i == this.routeLatLng.length - 1)
            this.isLoading = false;
        }
      }

    }
    else {// //Draw road route in actual way google mentioned road ways
      ////alert('road');
      //debugger;
      //this.ClearDrawRoute('Direct');
      this.ClearDirect()

      if (this.routeLatLng.length > 0) {
        this.stopFollowRoadRoute = false;
        this.startDirections();

      }///end check if routeLatLng > 0

      this.isLoading = false;
    }


  }

  ClearDrawRoute(routeType) {

    if (routeType == "Direct") {

      for (var i = 0; i < this.DirectPolylines.length; i++) {
        //this.DirectPolylines[i].setMap(null);
        this.DirectPolylines[i].setVisible(false);

      }
      this.DirectPolylines = [];


      //// Get the current bounds of the map
      //var bounds = this.map.getBounds();

      //// Set the center of the map to the current center
      //this.map.setCenter(bounds.getCenter());

      //// Set the zoom level of the map to the current zoom level
      //this.map.setZoom(this.map.getZoom());
    }
    else if (routeType == "Road") {

      for (var i = 0; i < this.followRoadRoute.length; i++) {
        this.followRoadRoute[i].setMap(null);
        //this.followRoadRoute[i].setOptions({ visible: false });
      }
      this.followRoadRoute = [];


      //// Get the current bounds of the map
      //var bounds = this.map.getBounds();

      //// Set the center of the map to the current center
      //this.map.setCenter(bounds.getCenter());

      //// Set the zoom level of the map to the current zoom level
      //this.map.setZoom(this.map.getZoom());
    }
    else {
      //remove both Direct and Follow route
      if (this.DrawRoute == "OFF") {
        ////DIRECT PATH
        for (var i = 0; i < this.DirectPolylines.length; i++) {
          //this.DirectPolylines[i].setMap(null);
          this.DirectPolylines[i].setVisible(false);
          //this.DirectPolylines[i].setMap(null);
        }
        this.DirectPolylines = [];

        /////// Follow Road PATH
        for (var i = 0; i < this.followRoadRoute.length; i++) {
          //this.followRoadRoute[i].setOptions({ visible: false });
          this.followRoadRoute[i].setMap(null);
        }
        this.followRoadRoute = [];
      }///endif
    }//end else

  }

  ClearDirect() {

    for (var i = 0; i < this.DirectPolylines.length; i++) {
      this.DirectPolylines[i].setVisible(false);
      //this.DirectPolylines[i].setMap(null);
    }
    this.DirectPolylines = [];

  }

  ClearRoad() {

    //this.stopFollowRoadRoute = true;
    //this.DrawLine = "1";
    for (var i = 0; i < this.followRoadRoute.length; i++) {
      this.followRoadRoute[i].setMap(null);
      //this.followRoadRoute[i].setOptions({ visible: false });
    }
    this.followRoadRoute = [];

  }

  private async getDirections(request: google.maps.DirectionsRequest, directionsRendererwaypoint: google.maps.DirectionsRenderer): Promise<google.maps.DirectionsResult> {
    let directionsServiceWaypoint = new google.maps.DirectionsService();

    return new Promise<google.maps.DirectionsResult>((resolve, reject) => {
      directionsServiceWaypoint.route(request, (result, status) => {
        if (status === 'OK') {
          console.log('successs');
          directionsRendererwaypoint.setDirections(result);
          //directionsRendererwaypoint.setOptions({ visible: true });
          directionsRendererwaypoint.setMap(this.map);
          resolve(result as google.maps.DirectionsResult);
        } else {
          console.log('error');
          reject(new Error('Directions request failed with status: ' + status));
        }
      });
    });


  }

  private async processRequest(request: google.maps.DirectionsRequest, directionsRendererwaypoint: google.maps.DirectionsRenderer): Promise<void> {
    try {
      const result = await this.getDirections(request, directionsRendererwaypoint);
      // Process the result as needed
    } catch (error) {
      // Handle the error
    }
  }

  private async startDirections(): Promise<void> {
    //const MAX_CONCURRENT_REQUESTS = 5;
    //const semaphore = new Semaphore(MAX_CONCURRENT_REQUESTS);
    const arrowSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    };

    //const routeLatLng = this.routeLatLng;//: YourLatLngType[] = /* Your array of LatLng objects ;

    for (let j = 0; j < this.routeLatLng.length; j++) {
      if (this.stopFollowRoadRoute) {
        /////to stop async function
        this.ClearRoad();
        //this.stopFollowRoadRoute = false;
        console.log('stopped');
        return;
      }

      const directionsRendererwaypoint = new google.maps.DirectionsRenderer({
        suppressMarkers: true,
        preserveViewport: true,
        polylineOptions: {
          strokeColor: this.routeLatLng[j].color,
          icons: [{
            icon: arrowSymbol,
            offset: '50%'
          }]
        },
        map: this.map
      });


      //directionsRendererwaypoint.setMap(this.map);
      this.followRoadRoute.push(directionsRendererwaypoint);
      const request: google.maps.DirectionsRequest = {
        origin: this.routeLatLng[j].origin,
        destination: this.routeLatLng[j].destination,
        travelMode: google.maps.DirectionsTravelMode.DRIVING, // 'DRIVING',
      };

      await this.processRequest(request, directionsRendererwaypoint);
      //await semaphore.delay(); // Introduce a delay between requests if needed
    }
  }


  //////////////////////////  End Draw Route

  /////////////////////////// start Popup Section bluetooth and status display
  //VQuad node Bluetooth List  
  OpenBTFXODialog() {
    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    //debugger;


    dailogConfig.data = { pageValue: this.bluetoothText, nodeStatus: true };

    this.dialog.open(VquadbtfxoComponent, dailogConfig);
  }

  //VQuad or Mobile Nodes N/W status
  OpenStatusDialog(itemID, resultType) {
    /// //alert(resultType);
    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;

    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "70%";
    //debugger;

    let vquadID = "";
    //itemID = "21";
    //resultType = "call-events";

    if (this.usePredefinedConfig == "OFF")/// it should be OFF
    {
      if (resultType.toLowerCase().includes('mobile'))
        vquadID = itemID + "@" + resultType + "$" + this.usePredefinedConfig; // for testing itemid =21
      else
        vquadID = itemID + "@" + resultType + "$" + this.usePredefinedConfig; // for testing itemid =21
    }
    else
      vquadID = itemID + "@" + resultType + "$" + this.usePredefinedConfig; // for testing itemid =37014543 and resultype="call-events"

    dailogConfig.data = { pageValue: vquadID };

    let dialogRef = this.dialog.open(GooglemapstatuspopupComponent, dailogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        //debugger;
        this.commonFilterService.setNonFiltersScreen(this.staticScreen);
      }
    );
  }

  //Results window
  OpenBasicDialog(requestID, rsltType) {
    //if (this.resultTypeID != "")
    // requestID = this.resultTypeID;

    //console.log(requestID + ',' + rsltType)
    const dailogConfig = new MatDialogConfig();
    //dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "80%";
    let newRsltType = rsltType;
    let selectedSubResults = "";
    if (rsltType.indexOf("mobileinfo") != -1 || rsltType.indexOf("nettest") != -1) {
      newRsltType = (rsltType.split('-'))[0];

      selectedSubResults = (rsltType.split('-'))[1];

      //got from sub-results-selection component
      let netTestData = [
        { id: 1, name: 'TCP' },
        { id: 2, name: 'UDP' },
        { id: 3, name: 'VOIP' },
        { id: 4, name: 'ROUTE' },
        { id: 5, name: 'HTTP' },
        { id: 6, name: 'FTP' },
        { id: 7, name: 'DNS' },
        { id: 8, name: 'SMS' },
        { id: 9, name: 'EMAIL' }
      ];
      let mobileInfoData = [
        { id: 1, name: 'GENERAL' },
        { id: 2, name: 'SIM' },
        { id: 3, name: 'UE' }
      ];
      let rsltIndex = -1;
      if (newRsltType == "nettest")
        rsltIndex = netTestData.find(x => x.name == selectedSubResults).id;
      else
        rsltIndex = mobileInfoData.find(x => x.name == selectedSubResults).id;
      this.resultsService.setNetTestOrMobInfoByID(rsltIndex);

      selectedSubResults += newRsltType == "nettest" ? "DATA" : "INFO";
    }

    dailogConfig.data = { popupOrNot: true, requestID: requestID, rsltType: newRsltType, TSSelected: this.TSSelected };

    //https://stackoverflow.com/questions/41357021/passing-input-values-to-dialog-component
    let dialogRef = this.dialog.open(BasicComponent, dailogConfig);
    let instance = dialogRef.componentInstance;
    instance.selectedSubResults = selectedSubResults;

    //dialogRef.afterClosed().subscribe(
    //  data => { this.successMsgBasic = data; }
    //);
  }

  ShowMapLegendWin(rsltType, condVal, pinType) {

    if (rsltType.trim() == "Audio and Delay")
      rsltType = "TDM";

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "50%";
    //debugger;
    this.legendPopupData = this.dynamicLegendPopupData;
    //console.log(this.legendPopupData[0])
    this.legendPopupData = this.legendPopupData[0].filter(m => m.ConditionValue.replace(/::true/gi, '').replace(/::false/gi, '') == condVal && m.RsltType == rsltType);

    let currPinRsltIndx = this.legendPopupData[0].RsltIndex; //-1;
    //let currListEachRsltCondVal = "";
    //this.dynamicLegendPopupData[0].every(item => {
    //  if (currListEachRsltCondVal != item.ConditionValue) {
    //    currListEachRsltCondVal = item.ConditionValue;
    //    currPinRsltIndx++;

    //    if (currListEachRsltCondVal == this.legendPopupData[0].ConditionValue)
    //      return false; 
    //  }
    //  return true;
    //});
    //console.log(currListEachRsltCondVal)

    if (this.legendPopupData.length <= 0) {
      return;
    }
    else {
      /// mark threshold.isapplied =1  if already applied
      for (let i = 0; i < this.appliedLegendThreshold.length; i++) {
        if (this.appliedLegendThreshold[i].replace(/::true/gi, '').replace(/::false/gi, '') == condVal) {
          //debugger
          this.legendPopupData[0].IsApplied = 1;//as fetched from orig list, set isApplied again everytime
          this.appliedLegendThreshold.splice(i);//if already applied remove and add freshly condVal below again everytime
        }
      }
    }
    //console.log(this.legendPopupData)

    dailogConfig.data = { pageValue: this.legendPopupData, pinType: pinType };

    let dialogResult = this.dialog.open(GooglemaplegendpopupComponent, dailogConfig);

    dialogResult.afterClosed().subscribe((resultData) => {

      if (resultData) {
        let tLegends = resultData;
        //debugger;

        if (tLegends[0].IsApplied == 1)//susheel
          this.appliedLegendThreshold.push(tLegends[0].ConditionValue.replace(/::true/gi, '').replace(/::false/gi, ''));//add or re-add applied new threshold

        if (pinType == "Threshold Type") {
          let allTRs = ";" + this.thresholdLegendsCount;//document.getElementById("hidMapLegendsApplyOrNot").value;//All applied TRs
          let entireThresholds = ";" + this.thresholdLegends; // document.getElementById("hidMapLegendsThresholds").value;

          if (allTRs.indexOf(';' + currPinRsltIndx + ';') != -1) {//leg each pin index
            allTRs = allTRs.replace(';' + currPinRsltIndx + ';', ';');//remove existing pin index applied

            var subVal = entireThresholds.substring(entireThresholds.indexOf(';' + currPinRsltIndx + '@'), entireThresholds.indexOf('@' + currPinRsltIndx + ';') + 3); //entireThresholds.substring(entireThresholds.indexOf(';' + document.getElementById("hidMapLegends").value + '@'), entireThresholds.indexOf('@' + document.getElementById("hidMapLegends").value + ';') + 3);
            entireThresholds = entireThresholds.replace(subVal, ';');//empty existing pin index's threshold val applied
          }
          else//Current applied tr newly
          {
            allTRs += currPinRsltIndx + ';'; //add pin index
            entireThresholds += currPinRsltIndx + "@"; //Indicating respective pin Index

            for (let i = 0; i < tLegends.length; i++) {
              //console.log(tLegends[i].OperatorDropDown)
              // $('#trMapLeg' + document.getElementById("hidMapLegends").value).find("input").each(function () {
              var x = "";
              //if (this.id.indexOf('DevID') != -1) //Device ID ^ as start
              //  x = this.value + "$";
              //else if (this.id.indexOf('txtMapLeg') != -1)//Operator ~ threshold ~ AND/OR of each parameter
              //  x = (document.getElementById(this.id.replace('txt', 'ddl')) != null ? document.getElementById(this.id.replace('txt', 'ddl')).selectedIndex : "0") + "-" + this.value + "^" + (document.getElementById(this.id.replace('txtMapLeg', 'ddlAndOrMapLeg')) != null ? document.getElementById(this.id.replace('txtMapLeg', 'ddlAndOrMapLeg')).value : "AND") + ",";
              if (tLegends[i].IsVquadData == 1) {
                x = tLegends[i].Text + "$";
              }
              else {
                x = tLegends[i].newOperatorIndex + "-" + tLegends[i].Text + "^" + (tLegends[i].AndORDropDown != null ? tLegends[i].AndORDropDown : "AND") + ",";
              }

              entireThresholds += x;//single or multi thresholds set here
              // });
            }
            entireThresholds += "@" + currPinRsltIndx + ";"; //closing with respective pin Index

          }
          ///document.getElementById("hidMapLegendsThresholds").value = entireThresholds.substring(1, entireThresholds.length);//Remove first and last ;'s
          ///document.getElementById("hidMapLegendsApplyOrNot").value = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          this.thresholdLegends = entireThresholds.substring(1, entireThresholds.length);//Remove first and last ;'s
          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(this.thresholdLegends)
          //console.log(this.thresholdLegendsCount)
        }
        else if (pinType == "VQuad Call ID Type") {
          let allTRs = ";" + this.thresholdLegendsCount;
          if (allTRs.indexOf(';' + currPinRsltIndx + ';') == -1)
            allTRs += currPinRsltIndx + ';'; //add rslt index

          let entireCallIDs = ";" + this.callIDLegends;

          entireCallIDs += tLegends[0].currCritListValue;

          //entireCallIDs += "@" + currPinRsltIndx + ";";
          this.callIDLegends = entireCallIDs;

          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(entireCallIDs)
          //console.log(this.thresholdLegendsCount)
        }
        else if (pinType == "VQuad Device ID Type") {
          let allTRs = ";" + this.thresholdLegendsCount;
          if (allTRs.indexOf(';' + currPinRsltIndx + ';') == -1)
            allTRs += currPinRsltIndx + ';'; //add rslt index

          let entireDevIDs = ";" + this.devIDLegends;

          entireDevIDs += tLegends[0].currCritListValue;

          //entireDevIDs += "@" + currPinRsltIndx + ";";
          this.devIDLegends = entireDevIDs;

          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(entireDevIDs)
          //console.log(this.thresholdLegendsCount)
        }
        else if (pinType == "Call Control Event Type") {
          let allTRs = ";" + this.thresholdLegendsCount;
          if (allTRs.indexOf(';' + currPinRsltIndx + ';') == -1)
            allTRs += currPinRsltIndx + ';'; //add rslt index

          let entireCCEs = ";" + this.callEventsLegends;

          entireCCEs += tLegends[0].currCritListValue;

          //entireCCEs += "@" + currPinRsltIndx + ";";
          this.callEventsLegends = entireCCEs;

          this.thresholdLegendsCount = allTRs.substring(1, allTRs.length);//Remove first and last ;'s
          //console.log(entireDevIDs)
          //console.log(this.thresholdLegendsCount)
        }

        this.GetMapConfigByID(this.mapConfigID, 1);

      } else {
        //this.pinColor = 'Nothing...';
      }
    });



    //this.showPopupLegend = true;
  }

  CloseMapLegendWin() {
    // this.showPopupLegend = false;
  }

  /////////////////////////// end Popup Section bluetooth and status display

  //////////////////   left panel Checkbox list

  pdfFilePathNew = "/Webviewer/assets/DowloadedScripts/GoogleMapHelp.pdf";//http://localhost:4200/assets/DowloadedScripts/GoogleMapHelp.pdf
  modalTitle = "'Google Maps Help'";
  OpenHelpPDFView(helpDocType) {
    if (helpDocType == "DefinitionHelp") {
      this.pdfFilePathNew = "/Webviewer/assets/DowloadedScripts/GoogleMapHelp.pdf";
      this.modalTitle = "Google Maps Help";
    }
    else {
      this.pdfFilePathNew = "/Webviewer/assets/DowloadedScripts/GoogleMapNotVisibleHelp.pdf";
      this.modalTitle = "Google Maps Not Visible";
    }
  }
  OpenHelp(helpDocType) {

    let pdfFilePath = "";
    if (helpDocType == "DefinitionHelp")
      pdfFilePath = '/Webviewer/assets/DowloadedScripts/GoogleMapHelp.pdf';  //// '/Webviewer/assets/images/ITS/ITSHelp.pdf';
    else
      pdfFilePath = '/Webviewer/assets/DowloadedScripts/GoogleMapNotVisibleHelp.pdf';

    const windowFeatures = 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,height = ' + screen.height * .66 + ',width=' + screen.width * .66;
    // Open the popup window
    //const popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    const popupWindow = window.open('', '_blank', windowFeatures);

    popupWindow.document.open();
    popupWindow.document.write(`
				<html>
					<head>
						<title>Google Maps HELP</title>
						
            <body onload=""><iframe src="${pdfFilePath}" width="100%" height="100%"></iframe></body>
          </head>
        </html>
      `)
    popupWindow.document.close();
    // Write the HTML content to the popup window
    //    popupWindow.document.write(`
    //  <html>
    //    <body>
    //      <iframe src="${pdfFilePath}" width="600" height="400"></iframe>      
    //    </body>
    //  </html>
    //`);

    //    // Make sure to close the document write operation
    //    popupWindow.document.close();

  }

  SpiralClicked() {
    ////alert();
  }


  DisplayResultList = [
    {
      Name: "Results",
      Value: "0",
      Checked: true
    },
    {
      Name: "Failures",
      Value: "1",
      Checked: true
    },
    {
      Name: "VQuad Nodes",
      Value: "2",
      Checked: true
    },
    {
      Name: "Mobile Devices",
      Value: "3",
      Checked: true
    },
    {
      Name: "VMobile Devices",
      Value: "4",
      Checked: true
    }
  ];

  AnalysisList = [
    //{
    //  Name: "Check/UnCheck All",
    //  Value: "1",
    //  Checked: true
    //},
    {
      Name: "Failures",
      Value: "2",
      Checked: true
    },
    {
      Name: "Call Events",
      Value: "3",
      Checked: true
    },
    {
      Name: "PESQ",
      Value: "4",
      Checked: true
    },
    {
      Name: "POLQA",
      Value: "5",
      Checked: true
    },
    {
      Name: "RTD",
      Value: "6",
      Checked: true
    },
    {
      Name: "OWD",
      Value: "7",
      Checked: true
    },
    {
      Name: "PDD",
      Value: "8",
      Checked: true
    },
    {
      Name: "SNR",
      Value: "9",
      Checked: true
    },
    {
      Name: "EModule",
      Value: "10",
      Checked: true
    },
    {
      Name: "EMU",
      Value: "11",
      Checked: true
    },
    {
      Name: "FAX",
      Value: "12",
      Checked: true
    },
    {
      Name: "VAC",
      Value: "13",
      Checked: true
    },
  ];

  NetTestList = [
    //{
    //  Name: "Check/UnCheck All",
    //  Value: "0",
    //  Checked: true
    //},
    {
      Name: "Failures",
      Value: "1",
      Checked: true
    },
    {
      Name: "Connection Drop",
      Value: "2",
      Checked: true
    },
    {
      Name: "TCP",
      Value: "3",
      Checked: true
    },
    {
      Name: "UDP",
      Value: "4",
      Checked: true
    },
    {
      Name: "VOIP",
      Value: "5",
      Checked: true
    },
    {
      Name: "ROUTE",
      Value: "6",
      Checked: true
    },
    {
      Name: "HTTP",
      Value: "7",
      Checked: true
    },
    {
      Name: "FTP",
      Value: "8",
      Checked: true
    },
    {
      Name: "DNS",
      Value: "9",
      Checked: true
    },
    {
      Name: "SMS",
      Value: "10",
      Checked: true
    },
    {
      Name: "EMAIL",
      Value: "11",
      Checked: true
    }
  ];

  MobileInfoList = [
    //{
    //  Name: "Check/UnChecl All",
    //  Value: "0",
    //  Checked: true
    //},
    {
      Name: "Failures",
      Value: "1",
      Checked: true
    },
    {
      Name: "PHONEINFO",
      Value: "2",
      Checked: true
    },
    {
      Name: "SIM",
      Value: "3",
      Checked: true
    },
    {
      Name: "UE",
      Value: "4",
      Checked: true
    }
  ];

  ErrorEventList = [
    //{
    //  Name: "Check/UnCheck All",
    //  Value: "0",
    //  Checked: true
    //},
    {
      Name: "Call Events",
      Value: "1",
      Checked: true
    },
    {
      Name: "RTD",
      Value: "2",
      Checked: true
    },
    {
      Name: "OWD",
      Value: "3",
      Checked: true
    },
    {
      Name: "PDD",
      Value: "4",
      Checked: true
    },
    {
      Name: "SNR",
      Value: "5",
      Checked: true
    },
    {
      Name: "FAX",
      Value: "6",
      Checked: true
    }
  ];

  TypeList = [
    {
      Name: "Threshold Settings",
      Value: "0",
      Checked: false
    },
    {
      Name: "VQuad Call ID",
      Value: "1",
      Checked: false
    },
    {
      Name: "VQuad Devcie ID",
      Value: "2",
      Checked: false
    },
    {
      Name: "Call Events",
      Value: "3",
      Checked: false
    }
  ];

  ResultList = [
    {
      Name: "VQT PESQ",
      Value: "VQTDATA|0|",
      Checked: false
    },
    {
      Name: "VQT POLQA",
      Value: "VQTPOLQA|1|",
      Checked: false
    },
    {
      Name: "VQuad Call Events",
      Value: "VQUADDATA|2|",
      Checked: false
    },
    {
      Name: "Audio and Delay Analysis",
      Value: "VQUADDATA|3|",
      Checked: false
    },
    {
      Name: "TCP",
      Value: "TCPDATA|4|",
      Checked: false
    },
    {
      Name: "UDP",
      Value: "UDPDATA|5|",
      Checked: false
    },
    {
      Name: "VOIP",
      Value: "VOIPDATA|6|",
      Checked: false
    },
    {
      Name: "ROUTE",
      Value: "ROUTEDATA|7|",
      Checked: false
    },
    {
      Name: "HTTP",
      Value: "HTTPDATA|8|",
      Checked: false
    },
    {
      Name: "FTP",
      Value: "FTPDATA|9|",
      Checked: false
    },
    {
      Name: "DNS",
      Value: "DNSDATA|10|",
      Checked: false
    },
    {
      Name: "SMS",
      Value: "SMSDATA|11|",
      Checked: false
    },
    {
      Name: "EMAIL",
      Value: "EMAILDATA|12|",
      Checked: false
    },
    {
      Name: "Phone Info",
      Value: "GENERALINFO|13|",
      Checked: false
    },
    {
      Name: "SIM",
      Value: "SIMINFO|14|",
      Checked: false
    },
    {
      Name: "UE",
      Value: "UEINFO|15|",
      Checked: false
    },
    {
      Name: "EMU",
      Value: "EMUDATA|16|",
      Checked: false
    },
    {
      Name: "FAX",
      Value: "FAXDATA|17|",
      Checked: false
    },
    {
      Name: "EModule",
      Value: "EModule|18|",
      Checked: false
    },
    {
      Name: "Connection Drop",
      Value: "CONNDROPDATA|19|",
      Checked: false
    },
    {
      Name: "VAC",
      Value: "VACDATA|20|",
      Checked: false
    }
  ];

  SampleLocations = [
    { lat: -31.56391, lng: 147.154312 },
    { lat: -33.718234, lng: 150.363181 },
    { lat: -35.304724, lng: 148.662905 },
    { lat: -36.817685, lng: 175.699196 },
    { lat: -31.56391, lng: 146.154312 },
    { lat: -32.56391, lng: 147.154312 },
    { lat: -33.718234, lng: 150.363181 },
    { lat: -35.304724, lng: 148.662905 }
  ];

  //////////////////   left panel Checkbox list

  ////////////////////////////////////////////////////////////// SERVICES /////////////////////////////////////////////////////

  GetMapConfigData_Service() {
    //debugger
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.preDefinedConfigParam, options);

  }

  GetMapConfigDataByID_Service() {
    //debugger
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.mapDisplayOptions, options);

  }

  GetMapDispayOptions_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.mapDisplayOptions, options);

  }

  SetTimestampSearch(tsSearch) {
    switch (tsSearch) {
      case 0:
        return "CALL_TIMESTAMP";
      case 1:
        return "VQUAD_TIMESTAMP";
      case 2:
        return "VQT_Timestamp";
      case 3:
        return "DCOSS_TIMESTAMP";
    }

  }

  parentRef(TSSelected) {
    //console.log('refresh');
    this.TSSelected = parseInt(TSSelected);
    //this.setRsltType();
    //////// Common filter dates 
    ////let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";  
    //this.commonFilterService.TSBetween.subscribe(res => this.commonFilterDates = res);//latest dates selected is set here from service
    ////Added to set proper dates here based on range selection
    //this.commonFilterService.TSRangeFilter.subscribe(res => {
    //  if (res.RangeType !== "custom")
    //  { this.commonFilterDates = lastDateFunc(res.RangeType) }
    //});//sets start and end dates to latest timestamps based on range type selection - IMP

    //this.commonFilterService.setDatesProperties(this.commonFilterDates);

    this.commonFilterService.usePredefinedConfig.subscribe(res => this.usePredefinedConfig = res);
    //this.GetPredefinedConfig(this.selMapConfig);-susheel IMP
  }
  parentEventID() {
    //console.log('parentid');
    //console.log('parentEventID')
    //this.filterEventIDSelected = true;
    //debugger;
    //////alert('parentEventID');
    this.refreshSelections();
  }
  parentAutoRef(AutoRefreshInfo) {
    //console.log('autorefsh');
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }



  displayFn(selectItem: any): string {
    return selectItem && selectItem.Name && !selectItem.Name.includes('--Select Map Config--') ? selectItem.Name : '';
  }

  _mapName(value: any): any[] {
    //console.log(value)
    let mapNameValue = '';
    if (typeof value === "string") {
      this.toHighlight = value;
      mapNameValue = value.toLowerCase();
    }
    else {
      this.toHighlight = value.Name;
      mapNameValue = value.Name.toLowerCase();
    }
    return this.mapFilterConfigList.filter(option => option.Name.toLowerCase().includes(mapNameValue) || option.Name.includes('--Select Map Config--'));
  }

  getList() {
    this.mapNamesObservable = this.mapFilterConfigList;
    if (this.init) {
      this.mapNamesObservable = [this.mapFilterConfigList[0]];
    }
    if (this.myConfigName != "null" && this.init)
      this.setConfigByName(this.myConfigName);
  }
  setConfigByName(name) {
    this.modelMapName = name;
    //console.log(this.modelMapName)
    let mapConfigName = this.modelMapName.trim();
    this.inputLength = this.modelMapName.trim().length;
    if (mapConfigName.length == 0) {
      this.GetMapConfigByID(null);
      return;
    }

    let id = this.mapFilterConfigList.find(x => x.Name == mapConfigName).id;
    this.GetMapConfigByID(id);

    this.init = false;
  }

  inputLength = 0;
  setLimitedOptions = true;
  onKeydownMain($event) {
    if (!this.setLimitedOptions) {
      this.setLimitedOptions = true;
      this.control.valueChanges.subscribe(newValue => {
        this.mapNamesObservable = this._mapName(newValue);
      })
    }
    this.inputLength = $event.target.value.length;
    this.modelMapName = $event.target.value;
    if (this.inputLength == 0) {
      this.triggerCollection.forEach((x, i) => {
        if (i == 1) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value.ID == this.selectedMapConfigID);
          if (firstSelectedOption) {
            this.MapClose = true;
            this.control.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });
    }
  }
  clearInputText() {
    this.control.setValue("");
    this.inputLength = 0;
  }
  clearInput(input: HTMLInputElement, auto: MatAutocomplete) {
    this.control.setValue("");
    this.inputLength = 0;
    this.selectedMapConfigID = 0;
    this.modelMapName = "";
    input.focus();
    //input.placeholder = '';
    //input.value = '';
    //auto.options.forEach(option => option.deselect());
    //auto.closePanel();

    //this.clearAllSelections();
    if (this.myConfigName != "null") {
      this.triggerCollection.forEach((x, i) => {
        if (i == 1)
          setTimeout(() => x.openPanel());
      });
    }
  }

  openOrClose = false;
  MapClose = false;
  OpenAutoCompeleteDailog(init?, closed?) {
    let tmOut = 0;
    if (init) {
      tmOut = 1000;
    }
    else {
      this.setLimitedOptions = false;
      this.mapNamesObservable = this.mapFilterConfigList;
    }

    this.triggerCollection.forEach((x, i) => {
      if (i == 1) {
        if (this.openOrClose == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrClose = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrl.nativeElement.blur();
            this.inputCtrl.nativeElement.focus();
            this.toHighlight = this.inputCtrl.nativeElement.value;
            if (this.inputLength > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedMapConfigID !== 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value.ID == this.selectedMapConfigID);
                if (firstSelectedOption) {
                  if (this.initArrow)
                    this.MapClose = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrClose = true;
        }
      }
    });
  }

  initArrow = true;
  SetArrowClick() {
    if (this.initArrow) {
      this.initArrow = false;
    }
  }



  displayFnReg(selectItem: any): string {
    return selectItem && selectItem && !selectItem.includes('--Select Region--') ? selectItem : '';
  }

  _regName(value: any): any[] {
    this.toHighlightReg = value;
    let RegNameValue = value.toLowerCase();
    return this.mapRegionList.filter(option => option.toLowerCase().includes(RegNameValue) || option.includes('--Select Region--'));
  }

  getListReg() {

    this.regNamesObservable = this.mapRegionList;
    if (this.myConfigNameReg != "null" && this.initReg)
      this.setConfigByNameReg(this.myConfigNameReg);

    ////restore previous selected region config 
    if (this.restorePreviousMapRegionName != "0") {
      //this.isLoading = true;
      //////alert(this.restorePreviousMapRegionName);
      //this.myConfigNameReg = this.restorePreviousMapRegionName;
      //this.openOrCloseReg = false;
      this.inputRegCtrl.nativeElement.value = this.restorePreviousMapRegionName;
      this.setConfigByNameReg(this.restorePreviousMapRegionName);
      this.OpenAutoCompeleteDailogReg(false);
      this.inputRegCtrl.nativeElement.value = this.restorePreviousMapRegionName;
    }
    //this.isLoading = false;
  }
  setConfigByNameReg(name) {
    this.modelRegName = name;
    //this.ResetPage();
    //console.log(this.modelRegName)
    ////restore previous selected region



    let RegConfigName = this.modelRegName.trim();
    //this.resetCritErrors();
    if (RegConfigName.length == 0) {
      this.GetMapRegionDetail("0");
      return;
    }
    this.GetMapRegionDetail(name);


    this.initReg = false;
  }

  inputLengthReg = 0;
  setLimitedOptionsReg = true;
  onKeydownMainReg($event) {
    if (!this.setLimitedOptionsReg) {
      this.setLimitedOptionsReg = true;
      this.controlReg.valueChanges.subscribe(newValue => {
        this.regNamesObservable = this._regName(newValue);
      })
    }
    this.inputLengthReg = $event.target.value.length;
    this.modelRegName = $event.target.value;
    if (this.inputLengthReg == 0) {
      this.triggerCollection.forEach((x, i) => {
        if (i == 0) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value == this.modelRegName);
          if (firstSelectedOption) {
            this.MapRegClose = true;
            this.controlReg.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });
    }
  }
  clearInputTextReg() {
    this.controlReg.setValue("");
    this.inputLengthReg = 0;
  }
  clearInputReg(auto: MatAutocomplete) {
    this.controlReg.setValue("");
    this.inputLengthReg = 0;
    this.mapRegionSelected = "0";
    this.modelRegName = "";
    //input.placeholder = '';
    //input.value = '';
    //auto.options.forEach(option => option.deselect());
    //auto.closePanel();
    this.GetMapRegionDetail("0", false);
    if (this.myConfigNameReg != "null") {
      this.triggerCollection.forEach((x, i) => {
        if (i == 0)
          setTimeout(() => x.openPanel());
      });
    }
  }

  openOrCloseReg = false;
  MapRegClose = false;
  OpenAutoCompeleteDailogReg(init?, closed?) {
    //const input = document.getElementById('message') as HTMLInputElement;
    //input.focus();
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsReg = false;
      this.regNamesObservable = this.mapRegionList;
    }

    this.triggerCollection.forEach((x, i) => {
      if (i == 0) {
        if (this.openOrCloseReg == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseReg = false;
        }
        else {
          setTimeout(() => {
            this.inputRegCtrl.nativeElement.blur();
            this.inputRegCtrl.nativeElement.focus();
            this.toHighlightReg = this.inputRegCtrl.nativeElement.value;
            if (this.inputLengthReg > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.modelRegName.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value == this.modelRegName);
                if (firstSelectedOption) {
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }

            //x.openPanel();
          }, tmOut);
          this.openOrCloseReg = true;
        }
      }
    });
  }

  initArrowReg = true;
  SetArrowClickReg() {
    if (this.initArrowReg) {
      this.initArrowReg = false;
    }
  }

}

// just an interface for type safety.
class marker {
  lat: string;
  lng: string;
  label?: string;
  draggable: boolean;
  iconurl: string;
  widthImg: number;
  heightImg: number;
  resultType: string;
  popUpRsltType: string;
  itemID: string;
  lat_num: number;
  lng_num: number;
  iconZIndex: number;
}
class markerDisplay {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  iconurl: string;
  widthImg: number;
  heightImg: number;
  resultType: string;
  popUpRsltType: string;
  itemID: string;
}

class PredefinedConfig {
  getINISettings: string = "";
  strStartDate: string = "";
  strEndDate: string = "";
  strLastRecord: string = "";
  TimeStamp_Type: string = "";
  FilterOnOff: number = 1;
  drawRoute: number = 0;

  thresholdLegends: string = "";
  thresholdLegendsCount: string = "";
  callIDLegends: string = "";//susheel
  devIDLegends: string = "";
  callEventsLegends: string = "";

  gMapConfigID: number = 0;
  MainFilterID: number = 0;
  limitPinCount: boolean = true;
  drawLine: string = "1";
  restoreZoom: number = 4;
  restoreLat: number = 0;
  restoreLng: number = 0;

  generalFilter = [];
}

class Semaphore {
  private permits: number;

  constructor(private maxPermits: number) {
    this.permits = maxPermits;
  }

  async delay(ms: number = 100): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, ms));
  }

  async acquire(): Promise<void> {
    while (this.permits <= 0) {
      await this.delay();
    }
    this.permits -= 1;
  }

  release(): void {
    this.permits += 1;
  }
}



